import {ILanguage} from './language';
import * as moment from "moment";
import {MyRound} from "../directives/my.round";
import {DisplayMinute} from "../directives/display.minute";
import {Utils} from "../model/Utils";
import {ValidationType} from "../model/validation/CustomValidation";
import {MyDateFormat} from "../directives/my.date.format";
import {FrenchDepartment} from "./french.department.fr";

export class LanguageFr  extends FrenchDepartment  implements ILanguage{
  LanguageCode: string = 'fr-ca';
  LanguageDescription: string = 'Français/Canada';
  'day.short.1': string = 'Lun';
  'day.short.2': string = 'Mar';
  'day.short.3': string = 'Mer';
  'day.short.4': string = 'Jeu';
  'day.short.5': string = 'Ven';
  'day.short.6': string = 'Sam';
  'day.short.7': string = 'Dim';
  'month.short.1': string = 'Jan';
  'month.short.2': string = 'Fev';
  'month.short.3': string = 'Mar';
  'month.short.4': string = 'Avr';
  'month.short.5': string = 'Mai';
  'month.short.6': string = 'Jui';
  'month.short.7': string = 'Jul';
  'month.short.8': string = 'Aoû';
  'month.short.9': string = 'Sep';
  'month.short.10': string = 'Oct';
  'month.short.11': string = 'Nov';
  'month.short.12': string = 'Dec';
  'month.1': string = 'Janvier';
  'month.2': string = 'Février';
  'month.3': string = 'Mars';
  'month.4': string = 'Avril';
  'month.5': string = 'Mai';
  'month.6': string = 'Juin';
  'month.7': string = 'Juillet';
  'month.8': string = 'Août';
  'month.9': string = 'Septembre';
  'month.10': string = 'Octobre';
  'month.11': string = 'Novembre';
  'month.12': string = 'Décembre';
  All: string = 'Tous';
  Filter: string = 'Filtre';
  NoItems: string = 'Aucun Elément';
  Expand: string = 'Déplier';
  Collapse: string = 'Plier';
  PleaseSelect: string = 'Faites un choix';
  NbrSelectedOptions: string = '{{nbOptions}} options sélectionnées.';
  PleaseSelectUnit = 'Sélectionner une unité';
  NbrSelectedUnit = '{{nbOptions}} unités sélectionnées.';
  NoUnits = 'Aucune unité.';
  FormatDDMMM = 'DD MMM';
  Currency = '{{v}} $';
  CurrencySymbol = '$';
  YouNeedToSelectAServiceOrDepartment = 'Vous devez sélectionner un service ou un departement.';
  AddNewWorkshift = 'Ajouter un poste';
  Job = 'Choisissez le poste';
  StartTime = 'Début du quart';
  EndTime = 'Fin du quart';
  Validate = 'Valider';
  Cancel = 'Annuler';
  NoEmployeeSelected = 'Aucun employé sélectionné.';
  Add = 'Ajouter';
  SelectingEmployees = 'Sélection de l\'employé ';
  FullName = 'Nom complet';
  CurrentWage = 'Taux horaire';
  Availability = 'Disponibilité';
  NoEmployeeFound = 'Aucun employé trouvé.';
  WorkShiftDescription = 'Quart de travail';

  WorkShiftOf = 'Horaire du {{refDate}}';
  WorkShift = 'Quart de travail';
  // Meal1Label = 'Diner';
  // Meal2Label = 'Souper';
  Meal1Label = 'Repas 1';
  Meal2Label = 'Repas 2';
  MealPaid = 'payé';
  Break1Label = 'Pause 1';
  Break2Label = 'Pause 2';

  MissingPlanning = 'Il manque {{qty}} employé(s) le {{dayOfWeek}}';
  TooManyPlanning = '{{qty}} employé(s) en trop pour {{dayOfWeek}}';
  MONDAY = 'lundi';
  TUESDAY = 'mardi';
  WEDNESDAY = 'mercredi';
  THURSDAY = 'jeudi';
  FRIDAY = 'vendredi';
  SATURDAY = 'samedi';
  SUNDAY = 'dimanche';

  // Lunch = 'Diner';
  // Supper = 'Souper';
  Lunch = 'Repas 1';
  Supper = 'Repas 2';
  LunchIsPaid = 'payé';
  SupperIsPaid = 'payé';
  Break1 = 'Pause 1';
  Break2 = 'Pause 2';
  Note = 'Note';
  ThisEmployeeIsNotAvailable = '{{fn}} n\'est pas disponible.';
  ThisEmployeeIsNotAvailablePrecise = '{{fn}} n\'est pas disponible. ({{when}})';
  ThisEmployeeIsNotAvailableStartEndHour = '{{fn}} n\'est pas disponible de {{startHour}} à {{endHour}}.';
  ThisEmployeeIsAvailableStartEndHour = '{{fn}} est disponible de {{startHour}} à {{endHour}}.';
  ThisEmployeeAlreadyScheduled = '{{fn}} est déjà occupé à {{fullJobDescription}}. {{when}}';
  ThisEmployeeAlreadyScheduledWithDay = '{{day}}: {{fn}} est déjà occupé à {{fullJobDescription}}.';
  ThisEmployeeIsNotActive = 'Le statut de {{fn}} n\'est pas actif, {{reason}} {{note}}';
  TooMuchTimeScheduled = '{{fn}} travaille plus longtemps que l\'horaire prévu.';
  NotEnoughEmployeeScheduled = 'Il n\'a pas assez de temps travaillé pour combler l\'horaire.';
  WeekOf = 'Semaine du ';
  TimesheetsByWeekAndEmployee = 'Feuille de temps par semaine';
  TimesheetsToApprove = 'Feuilles de temps à approuver';

  'meal.punched.but.no.meal.scheduled' = 'Le repas a été punché mais aucun n\'a été prévu.';
  'diff.between.meal.punched.and.scheduled' = 'La durée poinçonnée {{punched}} est différente de la durée prévue {{scheduled}}.';
  'pause.is.mandatory' = 'La pause est obligatoire';
  'pause.duration.is.different' = 'La durée de la pause est différente de la durée normale {{duration}}.';
  'pause.duration.is.greater' = 'La durée de la pause est supérieure à la durée normale {{duration}}.';
  'no.punched.start.time' = 'Aucun poinçon de début de quart.';
  'no.punched.end.time' = 'Aucun poinçon de fin de quart.';
  'start.time.equals.end.time' = 'Le début et la fin sont égaux.';
  'no.sick.days.found' = 'Aucun jour de maladie prévu.'
  'no.enough.minutes.left' = 'Il ne reste pas assez de temps alloué pour les jours de maladie {{left}} HH:MM.';
  'no.family.days.found' = 'Aucune journée familiale.';
  'no.enough.unpaid.family.days.left' = 'Il ne reste plus de journée familiale non payée.';
  'no.enough.paid.family.days.left' = 'Il ne reste plus de journée familiale payée.';

  'no.punch.found' = 'Aucun poinçon trouvé.';
  'no.start.shift.punch.found' = 'Aucun poinçon de début de quart.';
  'real.start.different.punch.start' = 'Début réel différent du début poinçonné. {{punched}}';
  'no.end.shift.punch.found' = 'Aucun poinçon de fin de quart.';
  'real.end.different.punch.end' = 'Fin réelle différente de la fin poinçonnée. {{punched}}';
  'no.meal.scheduled' = 'Aucun repas n\'a été prévu.';
  'diff.between.meal.saved.and.scheduled' = 'La durée {{saved}} est différente de la durée prévue {{scheduled}}.';


  TimeBankGlobal = 'Banq. de temps travaillé (Heures:Minutes)';
  Begin = 'Début de la semaine';
  Current = 'Semaine courante';
  SickDays = 'Congés maladies (Heures:Minutes)';
  Vacation = 'Vacances';
  DatePeriod = 'Du {{from}} au {{to}}';
  EmployeeSummary = 'Sommaire';
  TimeBankUsage = 'Mise en banque du temps travaillé';
  Hours = 'Heures'
  HoursApproved = 'Approuvées';
  HoursBanked = 'Banquées';
  PaidHrs = 'Payées';
  Amount = 'Montant';
  Regular = 'Temps régulier';
  Regularх1_5 = 'Temps x 1.5'
  WorkedHours = 'Heures travaillées';

  TraineeshipHours = 'Entraînements';
  TrainingHours = 'Formations';

  PaidLeavesHours = 'Abs. payées';
  PaidFamilyAbsence = 'Absences Famille payées';
  SubTotal = 'Sous-total';
  Holidays = 'Fériés';
  Vacations = 'Vacances';
  NoVacations = 'Pas de vacances';

  DoYouReallyWantToDeleteTheseVacations='Voulez-vous supprimer ces vacances?';
  TimeBank = 'Banque de temps travaillé';
  VacationsBalanceOrTimeBankBalanceAreNegativeDoYouWantToSaveAnyway='Attention!<br> Le solde de la banque de temps travaillé <u><b>ou</b></u> le solde des vacances restantes est négatif.<br><br> <b>Voulez-vous continuer et enregistrer?</b>';
  Solde_Balance = 'Solde';
  TRAVAIL = 'Travail';
  ENTRAINEMENT = 'Entraînement';
  FERIE = 'Férié';
  CONGE_AVEC_SOLDE = 'Congé avec Solde';
  CONGE_SANS_SOLDE = 'Congé sans Solde';

  SICK_LEAVE_PAID = 'Congé Maladie (Payé)';
  SICK_LEAVE_UNPAID = 'Congé Maladie (Non Payé)';

  BEREAVEMENT_LEAVE_PAID = 'Absence pour cause de d\u00E9c\u00E8s (Payée)';
  BEREAVEMENT_LEAVE_UNPAID = 'Absence pour cause de d\u00E9c\u00E8s (Non-payée)';
  FAMILY_LEAVE_PAID = 'Absence pour raison familiale (Payée)';
  FAMILY_LEAVE_UNPAID = 'Absence pour raison familiale (Non-payée)';



  JOUR1CSST = '1er jour CSST';
  ABSAUTH = 'Absence autoris\u00E9e (Non-payée)';
  ABSAUTHPAYE = 'Absence autoris\u00E9e (Payée)';
  ABSNONAUTH = 'Absence non-autoris\u00E9e (Non-payée)';
  ABSMALPAYE = 'Absence pour cause de maladie (Payée)';
  ABSMALNONPAYE = 'Absence pour cause de maladie (Non-payée)';
  ABSDECPAYE = 'Absence pour cause de d\u00E9c\u00E8s (Payée)';
  ABSDECNONPAYE = 'Absence pour cause de d\u00E9c\u00E8s (Non-payée)';
  ABSFAM = 'Absence pour raison familiale (Non-payée)';
  ABSFAM_PAID = 'Absence pour raison familiale (Payée)';
  VACANCE = 'Vacances';
  FORMATION = 'Formation';
  ABSAUTHNONPAYE = 'Absence autoris\u00E9e (Non-payée)';
  OTHER = 'Autre';
  UNION_RELATED = 'Syndicat';

  Employee = 'Employé';
  'Division/Job' = 'Division / Poste';
  Meals = 'Repas';
  Breaks = 'Pauses';

  TimesheetType = 'Type';
  ShiftStart = 'Début de Quart';
  ShiftEnd = 'Fin de Quart';
  Meal1 = 'Repas 1';
  Meal2 = 'Repas 2';
  Save = 'Enregistrer';
  Dashboard = 'Tableau de bord';
  Schedules = 'Horaires';
  SchedulesPerEmployees = 'Horaires / Employé';
  Timesheets = 'Feuilles de temps';
  TimesheetsAndExpenses = 'Approbations';
  Employees = 'Employés';
  Searching = 'Recherche';
  Search = 'Rechercher';
  EnterLastNameFirstName = 'Entrez le nom de famille et le prénom si nécessaire.'
  IncludeHiddenEmployee = 'Inclure les employés invisibles';


  USER_ROLE_PUNCH = 'Horodateur';
  USER_ROLE_USER = 'Responsable';
  USER_ROLE_READ_ONLY = 'Resp. (Limité)';
  USER_ROLE_DEMO = 'Employé';
  USER_ROLE_EXECUTIVE = 'Admin. (Limité)';
  USER_ROLE_ADMIN = 'Administrateur';
  USER_ROLE_SYS_ADMIN = 'Admin. Système';
  USER_ROLE_REP = 'Représentant';
  USER_ROLE_NO_ROLE = 'Aucun Rôle';

  LastName = 'Nom';
  FirstName = 'Prénom';
  Matricule = 'Matricule';
  Username = 'Code usager';
  UserRole = 'Rôle (Usager)';

  age = '{{age}} ans';

  EmployeeDetail = 'Information sur l\'employé';
  lastName = 'Nom';
  firstName = 'Prénom';
  bdate = 'Date de naissance';
  address = 'Adresse';
  city = 'Ville';
  nas = 'Numéro d\'Assurance Sociale';
  country = 'Pays';
  provState = 'Province';
  postalCode = 'Code postal';
  tel1 = 'Téléphone principal';
  tel2 = 'Téléphone secondaire';
  telCell = 'Téléphone cellulaire';
  email = 'Courriel';
  professionalEmail='Courriel Professionnel';

  telPage = 'Pagette';
  pref1 = 'Préférence d\'appel 1';
  pref2 = 'Préférence d\'appel 2';
  pref3 = 'Préférence d\'appel 3';
  QUEBEC = 'Québec';

  TELEPHONE_PRINCIPAL = 'Tél. principal';
  TELEPHONE_SECONDAIRE = 'Tél. secondaire';
  CELLULAIRE = 'Cellulaire';
  EMAIL = 'Courriel';
  PROFESSIONAL_EMAIL = 'Courriel Professionnel';
  PAGE = 'Pagette';
  SMS = 'SMS';

  RemunerationDetail = 'Modification de la rémunération';
  hiringSalary = 'Salaire d\'embauche ($/h)';
  originalSalary = 'Salaire courant';
  currentSalary = 'Salaire courant';
  calculatedSalary = 'Salaire recalculé avec la modification'

  adjustDt = 'Date d\'ajustement';
  SalaryIncrease = 'Augmentation du salaire';
  SalaryIncreasePercent = 'Augmentation du salaire en pourcentage';
  SalaryDecrease = 'Diminution du salaire';
  SalaryDecreasePercent = 'Diminution du salaire en pourcentage';
  nextAdjustDt = 'Prochaine date d\'ajustement';
  note = 'Note';


  RemunerationAndBonus = 'Rémunération et Primes';
  RemunerationAndCumulativeBonus = 'Rémunération et Primes Cumulatives';
  Bonus = 'Primes associées';
  bonus1 = 'Prime Hor. 1';
  bonus2 = 'Prime Hor. 2';
  bonus3 = 'Prime Hor. 3';
  bonus4 = 'Prime Hor. 4';
  bonus5 = 'Prime Hor. 5';
  bonus6 = 'Prime Hor. 6';
  bonus7 = 'Prime Hor. 7';
  bonus8 = 'Prime Hor. 8';
  bonus9 = 'Prime Hor. 9';
  bonus10 = 'Prime Hor. 10';
  bonus11 = 'Prime Hor. 11';
  bonus12 = 'Prime Hor. 12';
  bonus13 = 'Prime Hor. 13';
  bonus14 = 'Prime Hor. 14';
  bonus15 = 'Prime Hor. 15';
  bonus16 = 'Prime Hor. 16';
  bonus17 = 'Prime Hor. 17';
  bonus18 = 'Prime Hor. 18';
  bonus19 = 'Prime Hor. 19';
  bonus20 = 'Prime Hor. 20';


  Adjustment = 'Ajustement';
  Percentage = 'Ajustement %';
  Responsable = 'Responsable';
  RemunerationDetails = 'Ajustements de la rémunération';
  NoRemunerationDetails='Aucun ajustement';


  EMBAUCHE = 'Embauche';
  DEPART = 'Départ';
  ARRET_TRAVAIL = 'Arrêt Travail';
  RETOUR_TRAVAIL = 'Retour Travail';
  'A_MANQUE_TRAVAIL' = 'A - Manque de travail';
  'B_GREVE_LOCKOUT' = 'B - Grêve ou Lock-out';
  'C_RETOUR_ETUDES' = 'C - Retour aux études';
  'D_MALADIE_BLESS' = 'D - Maladie ou blessure';
  'E_DEPART_VOLONTAIRE' = 'E - Départ volontaire';
  'F_GROSSESSE_PAR' = 'F - Maternité';
  'G_RETRAITE' = 'G - Retraite';
  'H_TRAVAIL_PARTAGE' = 'H - Travail partagé';
  'J_FORMATION' = 'J - Formation';
  'K_AUTRE' = 'K - Autre';
  'M_CONGEDIEMENT' = 'M - Congédiement';
  'N_CONGE_SANS_SOLDE' = 'N - Congé sans solde';
  'P_PARENTAL' = 'P - Parental';
  'Z_COMPASSION' = 'Z - Compassion';

  Inactive = 'Inactif';
  Active = 'Actif';
  Terminated = 'Terminé';
  matricule = 'Matricule';
  currentHiringStatus = 'Statut';
  hiringStatus = 'Type d\'emploi';
  scheduleStatus = 'Type d\'horaire';
  HiringInformation = 'Embauche';
  HiringDetails = 'Détails';
  type = 'Type';
  CONTRACTUEL = 'Contractuel';
  PERMANENT = 'Permanent';
  PROBATION = 'Probation';
  STAGIAIRE = 'Stagiaire';
  SUBVENTIONNE = 'Subventionné';
  TEMPORAIRE = 'Temporaire';
  OCCASIONNEL = 'Occasionnel';
  TEMPORAIRE80 = 'Temporaire (80 jours et +)';
  SUR_APPEL = 'Sur appel';
  TEMPS_COMPLET = 'Temps complet';
  TEMPS_PARTIEL = 'Temps partiel';
  HiringDetail = 'Détail de l\'embauche';
  eventDt = 'Date';
  reason = 'Raison';
  endOfContract = 'Date de fin de contrat';
  backToWorkDate = 'Date prévue du retour';
  NoHiringInformation = 'Aucune information sur l\'embauche';

  StartDate = 'Date de début';
  EndDate = 'Date de fin';
  AllowedInMinutes = 'Minutes accordées';
  UsedInMinutes = 'Minutes utilisées';
  Balance = 'Solde';
  Duration = 'Durée';
  BalanceInMinutes = 'Solde';
  SickDaysAllowed = 'Durée accordée (hh:mm)';
  EmployeeSickDays = 'Congé Maladie';
  AbsencesInformation = 'Congés maladies et vacances';
  AbsencesInformationAndBankType = 'Congés maladies, vacances et banques de temps personnalisées';
  SickDaysTitle = 'Congés maladies';
  NoSickDays ='Pas de congés maladies';

  DoYouReallyWantToDeleteThisSickDays='Voulez-vous vraiment supprimer ces congés maladies?';

  PeriodStart = 'Début de période';
  PeriodEnd = 'Fin de période';
  AllowedVacation = 'Indemnité Accordée';
  DaysAvailable = 'Jours disponibles';

  // 'holiday.allowance' = 'L\'indemnité prévue par {{location}} propose d\'utiliser {{val}}% ou plus.';
  // DurationInYearMonthDay = '{{y}} an(s), {{m}} mois, {{d}} jour(s)';
  // NoSeniority = 'Aucune ancienneté';
  'ca.QC' = 'Québec';
  'ca.ON' = 'Ontario';
  'ca.AB' = 'Alberta';
  'ca.BC' = 'Colombie-Britannique';
  'ca.MB' = 'Manitoba';
  'ca.NB' = 'Nouveau-Brunswick';
  AllowanceGrantedShouldBe = 'L\'indemnité accordée devrait être de {{p}}%.';
  GrantedVacationDaysShouldBe = 'Le nombre de jours disponibles est {{should}} :  (accumulés pour la période précédente \'{{won}}\') MOINS' +
    ' (anticipés de la période précédente \'{{prevAhead}}\') PLUS (reportés de la période précédente \'{{prevDeferred}}\')' +
    ' MOINS (anticipés de la période courante \'{{currentAhead}}\') PLUS (reportés de la période courante \'{{currentDeferred}}\')';

  Seniority = 'Ancienneté';
  WorkCodeFrom = 'Loi du travail (Entreprise de paie)';
  AllowanceGranted = 'Indemnité accordée';
  PeriodStartGranted = 'Nb Jours Accordés';
  PeriodStartAhead = 'Jours anticipés';
  PeriodStartDeferred = 'Jours reportés';
  BadgeWillBeGenerated = 'Le numéro de badge sera généré lors de l\'enregistrement.';

  PunchAndPortalParameters = 'Paramètres du Poinçon et des applications Web et Mobile';
  UserParameter = 'Paramètres de l\'usager';
  UserName = 'Code de l\'usager';
  Password = 'Mot de passe';
  PunchParameter = 'Paramètres du Poinçon';

  BDateIsVisibleOnPunch = 'Affichage de l\'anniversaire.';
  ContactsVisibleOnPunch = 'Affichage des contacts.';
  ScheduleVisibleOnPunch = 'Affichage de l\'horaire.';
  TakePhotoOnPunch = 'Prise de photos.';
  PortalParameter = 'Paramètres des applications Web et Mobile';
  ShowPersonalInfosOnPortal = 'Affichage des infos personnelles.';
  ShowBanksOnPortal = 'Affichage des banques de l\'employé.';
  ShowClassicTimeBankOnPortal='Affichage de la banque de temps.';
  ShowSickDaysBankOnPortal='Affichage des journées maladies.';

  ShowPersonalScheduleOnPortal = 'Affichage de l\'horaire personnel.';
  ShowGeneralScheduleOnPortal = 'Affichage de l\'horaire général.';
  ShowGeneralScheduleOnPortalWithSamePosition='Seulement les horaires avec les mêmes postes.';

  ShowTimesheetsOnPortal = 'Affichage des feuilles de temps.';
  ShowMessagesOnPortal = 'Affichage des messages.';


  EmployeeContactsList = 'Contacts en cas d\'urgence';
  EmployeeContactTitle = 'Personne à contacter en cas d\'urgence';
  AddContact='Ajouter';
  Firstname = 'Prénom';
  Lastname = 'Nom';
  ContactType = 'Lien';
  HomePhone = 'Maison';
  OfficePhone = 'Bureau';
  CellPhone = 'Cellulaire';

  BonusPerJob = 'Prime par poste ($/h)';
  BonusPerJobInPercent = 'Prime par poste (% de $/h)';

  Level = 'Échelon';
  LevelShort = 'Echel.';
  EmployeeJobIsActive = 'Le poste de l\'employé est actif.';
  Department = 'Département';
  SubDepartment = 'Sous-département';
  Departments = 'Départements';
  SubDepartments = 'Sous-départements';
  Service = 'Service';
  JobInformation = 'Poste';
  EmployeeJobInformation = 'Information sur le poste occupé';
  JobLevel = 'Échelon';
  JobBonus = 'Prime ($/h)';
  JobBonusPerJob = 'Prime par poste ($/h)';
  DB_STATUS_ACTIVE = 'Actif';
  DB_STATUS_INACTIVE = 'Inactif';
  ThisIsTheDefaultJobForTheEmployee = 'Ce poste est le poste par défaut de l\'employé.';
  Default = 'Défaut';
  Status = 'Statut';
  EmployeeJobList = 'Liste des postes de l\'employé';


  PlanningManager = 'Gestionnaire de planifications';
  PlanningManagerShort = 'Gérer les planifications';
  Planning = 'Planifications';
  NoJobsPlannedUseAdd = 'Aucun poste dans ce plan pour {{d}}.';
  AddPlanningDetail = 'Ajouter des postes';
  Monday = 'Lundi';
  Tuesday = 'Mardi';
  Wednesday = 'Mercredi';
  Thursday = 'Jeudi';
  Friday = 'Vendredi';
  Saturday = 'Samedi';
  Sunday = 'Dimanche';

  'StartTime-EndTime' = 'Début - Fin de quart (HH:MM-HH:MM)';
  HowManyJob = 'Nombre de postes';
  JobLabel = 'Poste';
  NbJobs = 'Quantité';
  Schedule = 'Horaire';
  EditPlanningAggregation = 'Modification du plan';
  PlanningName = 'Nom du plan';
  UsersWithAccess = 'Usagers pouvant utiliser ce plan';
  Users = 'Usagers';
  EditPlanningDetail = 'Modification du détail d\'un plan';
  EditPlanningUser = 'Sélection d\'un usager';
  AddAPlan = 'Ajouter un nouveau plan';
  PlanningNotes = 'Notes';
  PlanningCreatedBy = 'Auteur du plan';
  CreateAPlanningToUseTheScheduling = 'Afin d\'utiliser le plus efficacement Emprez, vous pouvez créer un plan pour mieux vous guider lors de la création des horaires.';

  HasMoreJobs = 'Cet employé a d\'autres postes.';
  EmployeeWontBeExportedInThePaySystem = 'Cet employé ne sera pas exporté dans la paie.';
  ToStartProcessingYourBatchWeNeedAnEmailAddress = 'Pour débuter le traitement en lot (ref. {{batchId}}), vous devez ajouter un courriel de correspondance.';
  NbLineToBeRead = ' {{nbObjects}} lignes vont être lues depuis le fichier tranféré, les erreurs et les succès seront envoyées par courriel. ';
  SaveBatchEmail = 'Démarrage du traitement en lot';
  EmailToUpdateWhenBatchIsDone = 'Courriel de correspondance';
  BatchErrorOnWholeLine = 'Il était attendu {{expectedNbOfFields}} éléments, il en a été lu {{actualNbOfFields}}.';
  BatchErrorOnField = 'L\'élément \'{{fieldName}}\' à l\'index {{fieldIndex}} contient \'{{valueRead}}\' et il est attendu \'{{expectedFormat}}\'';
  String = 'Chaine de charactères';
  FormatErrorWithFormat = 'Un élément \'{{fieldName}}\' de type \'{{fieldType}}\' selon le format ou avec les valeurs \'{{expectedFormat}}\'.';
  FormatError = 'Un élément \'{{fieldName}}\' de type \'{{fieldType}}\'.';

  EmployeeParameters = 'Paramètres de l\'employé';

  EmployeeWillBeExportedInThePaySystem = 'L\'employé sera exporté dans la paie';
  Enterprise = 'Entreprise';

  EmployeeSchedule = 'Horaire';
  EmployeeTimesheet = 'Feuille de temps';
  EmployeeExport = 'Exportation';

  SubjectToApprovalByAManager = 'Les requêtes devront être approuvées par un responsable.';
  EmployeeCanModifyItsAvailability = 'L\'employé peut faire une requête de modifications de disponibilité via son application mobile ou le portail employé.';
  EmployeeCanRequestForVacation = 'L\'employé peut faire une demande de vacances via son application mobile ou le portail employé.';
  EmployeeCanExchangeShift = 'L\'employé peut échanger ses quarts de travail avec d\'autres employés.';

  SortingOrder = 'Dossier Employé (Utilisé pour les tris)';

  GraceStartBefore = 'Ajustement automatique: Arrivée Avant';
  RoundingStartBefore = 'Arrondissement';
  RoundingStartBeforeMode = 'Type d\'arrondissement';

  GraceStartAfter = 'Ajustement automatique: Arrivée Après';
  RoundingStartAfter = 'Arrondissement';
  RoundingStartAfterMode = 'Type d\'arrondissement';

  GraceEndBefore = 'Ajustement automatique: Départ Avant';
  RoundingEndBefore = 'Arrondissement';
  RoundingEndBeforeMode = 'Type d\'arrondissement';

  GraceEndAfter = 'Ajustement automatique: Départ Après';
  RoundingEndAfter = 'Arrondissement';
  RoundingEndAfterMode = 'Type d\'arrondissement';


  GraceMealShorter = 'Ajustement: Repas Plus Court';
  GraceMealLonger = 'Ajustement: Repas Plus Long';
  RoundingMeal = 'Arrondissement';
  RoundingMealMode = 'Type d\'arrondissement';

  GraceBreak = 'Ajustement: Pause Plus Longue';
  RoundingBreak = 'Arrondissement';
  RoundingBreakMode = 'Type d\'arrondissement';


  RoundingStartNoSchedule = 'Arrondissement Arrivée Sans Horaire';
  RoundingStartNoScheduleMode = 'Type d\'arrondissement';
  RoundingEndNoSchedule = 'Arrondissement Départ Sans Horaire';
  RoundingEndNoScheduleMode = 'Type d\'arrondissement';

  BreakDuration = 'Durée de la pause par défaut';
  MealDuration = 'Durée du repas par défaut ';
  HolidayCalculationType = 'Méthode de calcul des fériés';
  HolidayMinutes = 'Quantité (hh:mm)';
  HolidayMinutesDuration = 'Nombre de minutes';

  HolidayAlternateExportCode='Code export pour la Paie';
  UseHolidayAlternateExportCode='Utiliser ce code';
  HolidayMaxMinutes = 'Nb maximum de minutes';


  FamilyDaysCalculationType = 'Méthode de calcul des journées familiales';
  FamilyDaysMinutesDuration='Nombre de minutes';
  FamilyDaysAlternateExportCode='Code export pour la Paie';
  UseFamilyDaysAlternateExportCode='Utiliser ce code';
  FamilyDaysMaxMinutes='Nb maximum de minutes';

  HOLIDAY_CALCULATION_TYPE_1 = '1/10 (Dernière paie)';

  HOLIDAY_CALCULATION_TYPE_3 = '1/16 (4 semaines)';
  HOLIDAY_CALCULATION_TYPE_2 = '1/20 (4 semaines)';
  HOLIDAY_CALCULATION_TYPE_6 = '1/60 (12 semaines)';
  HOLIDAY_CALCULATION_TYPE_S = 'Fixe';
  HOLIDAY_CALCULATION_TYPE_ONTARIO_2018 = 'Ontario (2018)';
  HOLIDAY_CALCULATION_TYPE_NOVA_SCOTIA = 'Nouvelle Écosse';
  HOLIDAY_CALCULATION_TYPE_ONE_20_4_PAY_W_BANKS = '1/20 (4 semaines) + Banques';

  HOLIDAY_CALCULATION_TYPE_BRITISH_COLUMBIA = 'Colombie-Britannique';
  HOLIDAY_CALCULATION_TYPE_ALBERTA = 'Alberta';
  HOLIDAY_CALCULATION_TYPE_PEI = 'P.E.I.';
  HOLIDAY_CALCULATION_TYPE_NEW_BRUNSWICK = 'Nouveau-Brunswick';
  HOLIDAY_CALCULATION_TYPE_NEWFOUNDLAND = 'Terre-Neuve';
  HOLIDAY_CALCULATION_TYPE_NUNAVUT = 'Nunavut';
  HOLIDAY_CALCULATION_TYPE_YUKON = 'Yukon';
  HOLIDAY_CALCULATION_TYPE_ONTARIO = 'Ontario';

  HOLIDAY_CALCULATION_TYPE_CALC_FROM_LAST_PAY='Basé sur la dernière paie';
  HOLIDAY_CALCULATION_TYPE_CALC_4_WEEKS_PAY='1/20 (4 semaines) - Paie'
  HOLIDAY_CALCULATION_TYPE_ONE_12_4_WEEK_3DAY='1/12 (4 semaines)';
  HOLIDAY_CALCULATION_TYPE_MANITOBA = 'Manitoba';




  MealDurationType = 'Référence pour la durée réelle du repas';
  MEAL_DURATION_TYPE_PUNCH_DURATION = 'Poinçon';
  MEAL_DURATION_TYPE_DEFAULT_DURATION = 'Durée par défaut';
  MEAL_DURATION_TYPE_PUNCH_DURATION_WITH_MIN = 'Poinçon avec minimum';
  BreaksArePaidEvenWhenNotScheduled = 'Les pauses seront payées même si elles n\'ont pas été prévues à l\'horaire. Les minutes excédant la durée de la pause par défaut seront soustraites des heures travaillées.';


  HORAIRE_ROUNDING_MODE_UP = 'Plus grand';
  HORAIRE_ROUNDING_MODE_DOWN = 'Plus petit';
  HORAIRE_ROUNDING_MODE_HALF_UP = 'Plus près';

  EmployeeWillBeExported = 'Le dossier de l\'employé sera exporté';
  JobStatus = 'Statut d\'emploi';
  JOB_STATUS_1 = 'Taux régulier';
  JOB_STATUS_2 = 'Taux réduit';
  UsableWage = 'Taux utilisable';
  USABLE_WAGE_1 = 'Manuel';
  USABLE_WAGE_2 = 'Rémunération';
  USABLE_WAGE_3 = 'Salaire par période';
  PaymentMethod = 'Mode de paiement';
  PayProvince = 'Province de paie';
  BankId = 'Institution bancaire';
  BankTransit = 'Transit';
  BankAccount = 'Numéro de compte';
  FederalExemptionType = 'Exemption de base (Fédéral)';

  BASE_FEDERAL_EXEMPTION_1 = 'Montant de base';
  BASE_FEDERAL_EXEMPTION_2 = 'Aucun imp\u00F4t';
  BASE_FEDERAL_EXEMPTION_3 = 'Aucune exemption';
  BASE_PROVINCE_EXEMPTION_1 = 'Montant de base (QC)';
  BASE_PROVINCE_EXEMPTION_2 = 'Aucun imp\u00F4t (QC)';
  BASE_PROVINCE_EXEMPTION_3 = 'Aucune exemption (QC)';
  BASE_PROVINCE_EXEMPTION_4 = 'Montant de base';
  BASE_PROVINCE_EXEMPTION_5 = 'Aucun imp\u00F4t';
  BASE_PROVINCE_EXEMPTION_6 = 'Aucune exemption';


  ProvincialExemptionType = 'Exemption de base (Provincial)';
  Function = 'Fonction';
  Classe = 'Classe';
  Workgroup = 'Groupe de travail';
  HourPerPay = 'Nombre d\'heures par paie';
  DisplayPayCode = 'Affiche Salaire (Code)';
  EmployeeHasAFixedPay='L\'employé a une paie fixe';


  NoDocumentsAttached = 'Aucun document joint.';
  DocumentsAttached = '{{nb}} document(s) joint(s)';

  DAY_TYPE_MONDAY = 'Lundi';
  DAY_TYPE_MONDAY_SHORT = 'Lu';
  DAY_TYPE_TUESDAY = 'Mardi';
  DAY_TYPE_TUESDAY_SHORT = 'Ma';
  DAY_TYPE_WEDNESDAY = 'Mercredi';
  DAY_TYPE_WEDNESDAY_SHORT = 'Me';
  DAY_TYPE_THURSDAY = 'Jeudi';
  DAY_TYPE_THURSDAY_SHORT = 'Je';
  DAY_TYPE_FRIDAY = 'Vendredi';
  DAY_TYPE_FRIDAY_SHORT = 'Ve';
  DAY_TYPE_SATURDAY = 'Samedi';
  DAY_TYPE_SATURDAY_SHORT = 'Sa';
  DAY_TYPE_SUNDAY = 'Dimanche';
  DAY_TYPE_SUNDAY_SHORT = 'Di';
  EMPLOYEE_AVAILABLE = 'Disponible';
  EMPLOYEE_NOT_AVAILABLE = 'Non disponible';
  EmployeeAvailabilitiesList = 'Liste des disponibilités de l\'employé'
  AvailabilitiesOfTheEmployee = 'Liste des groupes de disponibilités de l\'employé';
  SpecialDatesWhenTheEmployeeIsNotAvailable = 'Indisponibilités de l\'employé pour des dates spécifiques';
  ActiveStartingDate = 'Début effectif';
  RefDateNotAvailable = 'Date';
  StartTimeEndTimeAvailability = 'Début - Fin de disponibilité (HH:MM-HH:MM)';
  EditEmployeeAvailabilityAndDetails = 'Modification des disponibilités';
  activeStartingDate = 'Date du début effectif';
  Remove = 'Supprimer';
  AllDay = 'Toute la journée';
  StartTimeEndTimeUnAvailability = 'Début - Fin de l\'indisponibilité (HH:MM-HH:MM)';
  EditEmployeeAvailabilitySpecial = 'Indisponibilité temporaire d\'un employé'
  refDateUnavailability = 'Date de l\'indisponibilité'
  FileName = 'Document';
  FileUploadedBy = 'Par';
  AddDocumentToSign='Ajouter un document à signer';

  EditEmployeeDocument = 'Document associé à l\'employé';
  ChooseFile = 'Sélectionnez le fichier à joindre.';
  ChosenFile = 'Fichier sélectionné:';
  EmployeeCanSeeTheFile = 'Le document est visible par l\'employé'
  NoDefaultJob = 'Aucun poste par défaut';
  HasNoActiveJobs = 'Aucun poste actif';
  Close = 'Fermer';
  JobString = 'Poste';

  PAYMENT_MODE_1 = 'Chèque';
  PAYMENT_MODE_2 = 'Dépôt';
  PAYMENT_MODE_3 = 'Mémo';
  ALBERTA = 'Alberta';
  BRITISH_COLUMBIA = 'Colombie Britannique';
  MANITOBA = 'Manitoba';
  NEW_BRUNSWICK = 'Nouveau Brunswick';
  NEWFOUNDLAND = 'Terre-Neuve';
  NOVA_SCOTIA = 'Nouvelle Écosse';
  PEI = 'Ile du Prince Edouard';
  SASKATCHEWAN = 'Saskatchewan';
  ONTARIO = 'Ontario';
  NUNAVUT='Nunavut';
  NORTHERN_TERRITORY = 'Territoires du Nord-Ouest';
  YUKON='Yukon';
  EmployeeDocumentList = 'Liste des documents associés à l\'employé';
  refDate = 'Date de référence';
  EmployeeInactive = 'Employé est inactif';
  sex = 'Sexe';
  MALE = 'Homme';
  FEMALE = 'Femme';
  FRANCAIS = 'Français';
  ENGLISH = 'Anglais';
  ESPAGNOL = 'Espagnol';
  OnlineTraining = 'Formations en ligne';
  EnterPunchName = 'Entrez le nom de l\'horodateur à chercher';
  NoPunchFound = 'Aucun horodateur trouvé.';
  PunchName = 'Nom de l\'horodateur';
  DeviceId = 'Device Id';
  Remuneration = 'Rémunération';
  EmployeeVacation = 'Vacances de l\'employé';
  NewEmployee = 'Nouvel employé';
  Load = 'Charger';
  EmployeeFound = '{{nb}} employés trouvés';
  'Use the buttons there' = 'Utilisez les boutons ci-contre';
  EmployeePunchIsNotActive = 'L\'employé ne peut pas poinçonner.';
  CopyTo = 'Copier vers';
  PlanningIsActive = 'La planification est active.';
  LunchStartEndTime = 'Début - Fin du repas (HH:MM-HH:MM)';
  SupperStartEndTime = 'Début - Fin du repas (HH:MM-HH:MM)';
  days = 'jour(s)';
  NoEmergenciesContacts = 'Aucun contact en cas d\'urgence';
  AddAvailabilitiesForTheEmployee = 'Aucune disponibilité pour l\'employé';
  QuestionTitle = 'Question';
  DoYouReallyWantToDelete = 'Voulez-vous vraiment supprimer votre sélection?';
  ServiceDepartement = 'Service, Département';
  TooManyScheduleForThisDay = 'Trop d\'employés sélectionnés, il est planifié seulement {{nbPlanned}} postes';
  NotAvailable = 'Non disponible';
  Available = 'Disponible';
  PlannedPostes = 'Postes à remplir selon le Plan';
  EmployeeHasAlreadyAShift = 'L\'employé {{fullName}} a déjà un quart de travail le {{refDate}}.';
  EmployeeHasAlreadyAShiftHours = 'L\'employé {{fullName}} a déjà un quart de travail de {{startDate}} à {{endDate}}.';
  SeniorityInDays = 'Ancienneté (jrs)';
  SeniorityInDaysShort = 'Ancien. (jrs)';
  DoYouWantToNotifyYourEmployeesAboutTheChangeInTheirSchedule = 'Voulez-vous signaler le changement d\'horaire aux employés concernés? ';
  DoYouWantToNotifyYourEmployeesAboutTheChangeInTheirScheduleAndSomeShiftToBeFilled = 'Voulez-vous signaler le changement d\'horaire et les quarts à combler aux employés concernés?';
  DoYouWantToNotifyYourEmployeesAboutSomeShiftToBeFilled = 'Voulez-vous signaler les quarts à combler aux employés concernés?';
  ScheduleIsPublished = 'Le quart de travail est publié. (Visible par l\'employé.)';
  EmployeeIsVisible = 'L\'employé est visible.';
  EmployeeIsHidden = 'L\'employé n\'est pas visible.';
  NoSchedulePlannedForThisDay = 'Aucun poste à remplir selon la planification';
  HasUnpublishedSchedules = 'Des quarts de travail ne sont pas publiés.';
  Yes = 'Oui';
  No = 'Non';
  HORARIUS_LOCALE_fr_CA = 'Français (Canada)';
  HORARIUS_LOCALE_en_CA = 'Anglais (Canada)';
  HORARIUS_LOCALE_es = 'Spanish';


  HORARIUS_TZ_CA_EASTERN = 'Canada/Est';
  HORARIUS_TZ_CA_ATLANTIC = 'Canada/Atlantique';
  HORARIUS_TZ_CA_CENTRAL = 'Canada/Central';
  HORARIUS_TZ_CA_MOUNTAIN = 'Canada/Montagne';
  HORARIUS_TZ_CA_PACIFIC = 'Canada/Pacifique'
  HORARIUS_TZ_CENTRAL_EUROPEAN = 'Europe/Central';
  HORARIUS_TZ_EUROPE_MOSCOW='Europe/Moscou';
  HORARIUS_TZ_CA_YUKON = 'Canada/Yukon';
  HORARIUS_TZ_CA_EAST_SASKATCHEWAN = 'Canada/East-Saskatchewan';
  HORARIUS_TZ_CA_SASKATCHEWAN = 'Canada/Saskatchewan';
  HORARIUS_TZ_CA_NEWFOUNDLAND = 'Canada/Newfoundland';
  HORARIUS_TZ_WEST_AFRICA='Afrique Ouest';

  CA_EASTERN = 'Canada/Est';
  CA_ATLANTIC = 'Canada/Atlantique';
  CA_CENTRAL = 'Canada/Central';
  CA_MOUNTAIN = 'Canada/Montagne';
  CA_PACIFIC = 'Canada/Pacifique'
  CENTRAL_EUROPEAN = 'Europe/Central';
  EUROPE_MOSCOW='Europe/Moscou';
  CA_YUKON = 'Canada/Yukon';
  CA_EAST_SASKATCHEWAN = 'Canada/East-Saskatchewan';
  CA_SASKATCHEWAN = 'Canada/Saskatchewan';
  CA_NEWFOUNDLAND = 'Canada/Newfoundland';
  WEST_AFRICA='Afrique Ouest';



  MealWasScheduled = 'a été prévu de {{start}} à {{end}}.';
  MealWasNotScheduled = 'n\'a pas été prévu.';
  AccountedMealDuration = 'Durée (hr:min)';
  BreakWasScheduled = 'a été prévue à {{start}}.';
  BreakNotScheduled = 'n\'a pas été prévue.';
  AccountedBreakDurationToBeRemoved = 'Durée retranchée au temps de travail (hr:min)';
  AccountedMealDurationToBeRemoved = 'Durée retranchée au temps de travail (hr:min)';

  ShiftWasScheduled = 'a été prévu à {{start}}.';
  ShiftNotScheduled = 'n\'a pas été prévu.';
  ShiftEndWasScheduled = 'a été prévue à {{start}}.'
  ShiftEndNotScheduled = 'n\'a pas été prévue.'

  PunchedShiftStart = 'Poinçonné';
  AccountedShiftStart = 'Utilisé par la paie';
  AdjustedPunchedShiftStart = 'Arrondissement';
  PunchedShiftEnd = 'Poinçonné';
  AccountedShiftEnd = 'Utilisé par la paie';
  AdjustedPunchedShiftEnd = 'Arrondissement';
  EmployeeDescription = 'Employé';
  UnFoldAll = 'Déplier tous';
  FoldAll = 'Plier tous';
  AddEditWorkshift = 'Quarts de travail';
  WorkshiftStartEndTime = 'Début - Fin du quart (HH:MM-HH:MM)';
  BreakStartEndTime = 'Début de la pause (HH:MM)';
  EditWorkshift = 'Modifier';
  AddWorkshift = 'Ajouter';
  ModifyWorkshift = 'Modifier';
  'wrong.format.HH:MM' = 'Le format est HH:MM';
  'wrong.format.HH:MM-HH:MM' = 'Le format est \'HH:MM - HH:MM\'';
  ScheduleType = 'Type de Quart';
  NoDataFound = 'Aucune information trouvée.'
  DisplaySchedulePerDay = 'Affichage d\'une journée';
  PlanningCanBeValidated = 'Vérification automatique';
  WarnWhenMoreTimeIsScheduled = 'Avertir quand trop d\'horaires';
  WeeklyMinimum = 'Horaire minimal hebdomadaire (0 => aucun)';
  WeeklyMaximum = 'Horaire maximal hebdomadaire (0 => aucun)';
  PlanningValidation = 'Vérifications de la planification';
  EmployeeScheduleValidation = 'Vérification des horaires des employés';
  PLANNING_ERROR_TYPE_MORE_THAN_PLANNED = 'Trop';
  PLANNING_ERROR_TYPE_LESS_THAN_PLANNED = 'Pas assez';
  PLANNING_ERROR_TYPE_NONE = 'N/A';
  EMPLOYEE_ERROR_TYPE_SCHEDULE = 'Horaire';
  EMPLOYEE_ERROR_TYPE_AVAILABILITY = 'Dispo.';
  EMPLOYEE_ERROR_TYPE_OVERTIME_BY_LAW = 'Temps Supl.';
  EMPLOYEE_ERROR_TYPE_MORE_THAN_EXPECTED = 'Trop d\'heures';
  EMPLOYEE_ERROR_TYPE_LESS_THAN_EXPECTED = 'Manque d\'heures';
  EMPLOYEE_ERROR_TYPE_NONE = 'N/A';
  WowAllVerificationsWorked = 'Bravo! Tout est parfait.';
  ErrorMessage = 'Description'
  'employees.with.job.and.unit' = 'Liste des employés ayant le poste \'{{job}}\' dans l\'unité \'{{unit}}\'';
  ShowAllSchedulesByJobUnit = 'Tous les horaires pour ce poste';
  ShowAllSchedulesForEmployee = 'Tous les horaires de cet employé';
  ShowAllSchedulesForEmployeeNamed = 'Tous les horaires de {{employee}}';
  SchedulesPlanning = 'Horaires / Planification';

  PunchInformation = 'Poinçonnage';
  EmployeeCanPunchWithBadge = 'L\'employé utilise le code {{badge}}.';
  EmployeeCanPunchOnTheMobileAndWeb = 'L\'employé peut poinçonner avec l\'application mobile et le portail employé.';
  EmployeeCanPunchOnTheMobile  = 'L\'employé peut poinçonner avec l\'application mobile.';
  EmployeeCanPunchOnTheWeb = 'L\'employé peut poinçonner avec le portail employé.';
  PunchingMultipleTaskAtOnceIsPermitted='L\'employé peut démarrer plusieurs tâches en parallèle.';

  EmployeeIsPunching = 'L\'employé poinçonne.';
  EmployeeIsPunchingOntheWeb = 'L\'employé peut poinçonner avec le portail employé.';
  EmployeeIsPunchingOntheMobile = 'L\'employé peut poinçonner avec l\'application mobile.';



  APictureIsTakenWhenEmployeeIsPunching = 'Prise de photo (Horodateur physique).';
  Documents = 'Documents';
  AllHiringInformation = 'Dossier d\'emploi';
  HiringStatus = 'Statut';
  EmployeeJob = 'Poste(s)';
  TimeInBank = 'Banque de temps travaillé';
  SickDaysUsed_SickDaysLeft = 'Autres Banques (solde)';
  VacationLeft = 'Jours de vacances restants';
  Availabilities = 'Disponibilités';
  ParametersInformation = 'Paramètres';
  WebAndMobileAccess = 'Accès Mobile et Web';
  ExportInThePaySystem = 'Exportation vers la paie'

  CopyWorkshift = 'Copie d\'horaires';
  NoticeCopyWorkshift = 'Attention, vous allez copier (et ajouter!) les horaires vers la ou les semaines suivantes:';
  NoticeCopyWorkshiftScheduleTypes = 'Seuls les horaires avec les types sélectionnés ci-dessous seront copiés.';
  WeekFrom = 'Semaine du ';
  WeekTo = 'au';
  PeriodFrom = 'Période du ';
  PeriodTo = 'au';
  DoYouReallyWantToDeleteTheWorkshift = 'Voulez-vous vraiment supprimer l\'horaire et les poinçons de la feuille de temps sélectionnée ? ';
  inboxMessage = 'Messages'
  ExplanationOfMemos = 'Les messages internes à l\'application permettent une communication plus efficace. Vous pouvez mettre des dates d\'expirations, les faire afficher sur les poinçons et savoir s\'ils ont été vus, lus ou supprimés. Ne pas les confondre avec des courriels. '
  Inbox = 'Réception';
  SentMessages = 'Envoyés';
  NewWorkShift = 'Quart à combler';
  NewPlainMessage = 'Nouveau';
  PlainMessage = 'Message Texte';
  Recipients = 'Destinataires';
  ExpiryDate = 'Date d\'expiration du message'
  title = 'Titre';
  content = 'Corps du message (max {{maxLength}} caractères.)'
  NoMessageReceived = 'Aucun message reçu.';
  NoMessageSent = 'Aucun message envoyé.';
  Error = 'Erreur';
  'Schedule.is.overlapping' = 'Le quart est déjà occupé.'
  YouCantSeeThePasswordWithYourUserLevel = 'Vous ne pouvez voir le mot de passe avec votre niveau d\'usager.';
  OtherEmployeesParameters = 'Autres paramètres de l\'employé';
  EmployeeHasNotThisJob = '{{employee}} n\'a pas le poste {{job}} dans l\'unité {{unit}}';
  MEMO_INFO_TYPE_WORK_SHIFT = 'Quart de travail';
  MEMO_INFO_TYPE_REQUEST_VACATION = 'Demande de vacances';
  MEMO_INFO_TYPE_PLAIN = 'Texte';
  MEMO_INFO_TYPE_WORK_SHIFT_EXCHANGE = 'Échange de quart';
  MEMO_INFO_TYPE_AVAILABILITIES_SE = 'Disponibilité spéciale';
  MEMO_INFO_TYPE_AVAILABILITIES_PERIODIC = 'Disponibilité périodique';

  MEMO_EMP_STATUS_READ = 'Mémo lu';
  MEMO_EMP_STATUS_SEEN = 'Mémo vu';
  MEMO_EMP_STATUS_SEEN_PUNCH = 'Mémo vu sur le punch';
  MEMO_EMP_STATUS_DELETED = 'Mémo supprimé';


  WorkShiftMessage = 'Quart à combler';
  EmployeeAppliedOnWorkshiftRequest = '<span style="font-size:larger; font-weight: 600;">{{employee}}</span> est intéressé(e) au quart de travail en tant que <span style="font-size:larger; font-weight: 600;">{{job}}</span> <span class=muted>({{unit}})</span> le {{eventDt}} entre {{schedule}}.<div class="muted">{{note}}</div>';
  EmployeeAppliedForExchangeWorkshiftRequest = '<span style="font-size:larger; font-weight: 600;">{{employee}}</span> est prêt(e) à remplacer <span style="font-size:larger; font-weight: 600;">{{requester}}</span> pour le quart de travail à la demande de ce dernier: <span style="font-size:larger; font-weight: 600;">{{job}}</span> <span class=muted>({{unit}})</span> le {{eventDt}} entre {{schedule}}.<div class="muted">La note du demandeur: {{note}}</div>';
  EmployeeAppliedForExchangeWorkshiftRequestNoNote = '<span style="font-size:larger; font-weight: 600;">{{employee}}</span> est prêt(e) à remplacer <span style="font-size:larger; font-weight: 600;">{{requester}}</span> pour le quart de travail à la demande de ce dernier: <span style="font-size:larger; font-weight: 600;">{{job}}</span> <span class=muted>({{unit}})</span> le {{eventDt}} entre {{schedule}}.';
  EmployeeWorkshiftExchangeRequest = 'Votre collègue <span style="font-size:larger; font-weight: 600;">{{requester}}</span> cherche un(e) remplaçant(e) pour le quart de travail: <span style="font-size:larger; font-weight: 600;">{{job}}</span> <span class=muted>({{unit}})</span> le {{eventDt}} entre {{schedule}}.';
  Accept = 'Accepter';
  Reject = 'Refuser';
  Apply = 'Appliquer';
  EmployeeRequestsSomeVacation = '<span style="font-size:larger; font-weight: 600;">{{employee}}</span> aimerait prendre des vacances du <span style="font-size:larger; font-weight: 600;">{{startDt}}</span> au <span style="font-size:larger; font-weight: 600;">{{endDt}}</span> inclusivement.<div class="muted">{{note}}</div>'
  EmployeeDeletedMemo = '{{employee}} a supprimé le message le {{date}}.';
  EmployeeSeenMemo = '{{employee}} a vu le message le {{date}}.';
  EmployeeSeenPunchMemo = '{{employee}} a vu le message sur le poinçon le {{date}}.';
  EmployeeReadMemo = '{{employee}} a lu le message le {{date}}.';
  EmployeeAcknowledgedMemo='{{employee}} a confirmé le message le {{date}}.';

  CantFindAttachment = 'Impossible de trouver l\'élément joint [{{memoId}}].';
  ManagementOfThisTypeIsNotSupported = 'Nous ne supportons pas les messages du type \'{{memoType}}\'.';
  To = 'À';
  Title = 'Titre';
  MemoAggregation = 'Conversation';
  From = 'De';
  Reply = 'Répondre';
  WorkshiftRequestDate = 'Date';
  SaveAndSend = 'Enregistrer et envoyer';
  PublishAll = 'Tout publier';
  UnPublishAll = 'Tout \'dépublier\'';
  MissingWorkShift = 'Quart manquant';
  Importing = 'Importer';
  VacationsLeft = 'Jours de vacances disponibles';
  SchedulePerPlanPurpose = 'Vous êtes dans la section <b>Horaires par Planification</b>.<br>Vous pouvez choisir une planification et faire <b>Charger</b>.<p>Si vous n\'avez pas encore de plan, vous pouvez en créer un en utilisant le <b>Gestionnaire de planifications</b>.</p>';
  SchedulePerPlanHowToFill = '<span style="font-style: italic; font-size: smaller" class="muted">Selon le Plan choisi, vous devez assigner les quarts de travails marqués par un <i class="fa fa-certificate"></i></span>';

  'schedule.start.different.punch.start' = 'Le début du quart était prévu à {{scheduled}} au lieu de {{punched}}';
  'schedule.end.different.punch.end' = 'La fin du quart était prévue à {{scheduled}} au lieu de {{punched}}';
  Approve = 'Approuver';
  ApproveToday = 'Aujourd\'hui';
  ApproveYesterday = 'Hier';
  NoTimesheetsFound = 'Aucune feuille de temps.';
  VisibleOnPunch = 'Visible sur le poinçon';
  DoYouReallyWantToDeleteThePlan = 'Voulez-vous vraiment supprimer le plan \'{{plan}}\'? ';
  PayingEnterprise = 'L\'employé sera payé par';
  seniorityDate = 'Date d\'ancienneté';
  hiringDate = 'Date d\'embauche';
  CANADA = 'Canada';
  FRANCE = 'France';
  USA = 'USA';
  Reporting = 'Rapports';
  parametersForReport = 'Paramètres du rapport {{name}}';
  CreateReport = 'Créer le rapport';
  ReportPDF = 'Rapport en Pdf';
  ReportXLS = 'Rapport en Excel';
  ExportExcel = 'Export Excel';
  NoStatusYet = 'Aucun statut pour le moment';

  AvailabilityForDay = '<li>{{dayType}}: {{schedule}}</li>';
  AvailabilityChange = 'Changement valide à partir du <span style="font-size:larger; font-weight: 600;">{{startingDt}}</span><br><ul>{{details}}</ul>';
  EmployeeRequestChangeAvailabilities = '<span style="font-size:larger; font-weight: 600;">{{employee}}</span> demande une modification de ses disponibilités:<br>{{data}}<br>{{noteFromApprover}}';
  EmployeeRequestChangeAvailabilitiesHeader = '{{employee}} demande une modification de ses disponibilités à partir du {{dateDebut}}';

  EmployeeRequestSpecialAvailability = '<span style="font-size:larger; font-weight: 600;">{{employee}}</span> demande une non-disponibilité le <span style="font-size:larger; font-weight: 600;">{{eventDt}}</span> de {{schedule}}.<br>{{note}}<br>{{noteFromApprover}}';
  EmployeeRequestSpecialAvailabilityHeader = '{{employee}} demande une non-disponibilité le {{eventDt}} de {{schedule}}';

  RequestCreatedOn='<span style="font-size:smaller; font-weight: 200;" class="muted">Envoyé le {{createdDt}}.</span>';

  Language = 'Langue';
  ANGLAIS = 'Anglais';

  EmployeeAppliedOnWorkshiftProvide = '<span style="font-size:larger; font-weight: 600;">{{provider}}</span> recherche une personne pour le poste de <span style="font-size:larger; font-weight: 600;">{{job}}</span> <span class=muted>({{unit}})</span> le {{eventDt}} entre {{schedule}}.<div class="muted">{{note}}</div>';

  Punches = 'Informations transmises par le poinçon';
  StartShift = 'Début de quart';
  NoPunch = 'Aucun poinçon';
  EndShift = 'Fin de quart';
  StartMeal1 = 'Début de repas';
  EndMeal1 = 'Fin de repas';
  StartMeal2 = 'Début de repas';
  EndMeal2 = 'Fin de repas';
  StartBreak1 = 'Début de pause';
  EndBreak1 = 'Fin de pause';
  StartBreak2 = 'Début de pause';
  EndBreak2 = 'Fin de pause';


  EmployeesPanel = 'Employés';
  PunchesPanel = 'Poinçons';
  UnitsPanel = 'Structures';
  EnterUnitName = 'Rechercher une unité par description/nom'

  JobInTheUnit = 'Postes associés à l\'unité';
  EmployeeWithDirectAccess = 'Usagers ayant accès à cette unité<br><span class="muted emprez-smaller-font">( pour les horaires et les feuilles de temps ) </span>';
  AddAccessToEmployees = 'Ajouter un accès à des employés';
  AddJobToUnit = 'Ajouter un poste';
  Templates = 'Gabarits';
  JobDescription = 'Poste';
  Week = 'Semaine';
  AllTemplates = 'Tous les gabarits';
  firstWeekOfCycle = 'Référence pour la première semaine du cycle (Optionnel)';
  CurrentWeekAccordingToCycle = 'Semaine courante selon le cycle';
  ChooseATemplateForEmployee = 'Gabarits de l\'employé';
  ChooseATemplateForEmployeeNamed = 'Gabarits de {{employee}}';
  Info = 'Information';
  NoTemplatesForEmployee = 'Cet employé n\'a pas de gabarit.';
  NoTemplatesAvailableForThisJob = 'Aucun gabarit disponible pour ce poste';
  PeriodStartAmountGranted = 'Montant accordé';
  PeriodStartAheadAmount = 'Montant anticipé';
  PeriodStartDeferredAmount = 'Montant reporté';
  BackgroundColor = 'Couleur de fond';
  ClickToChangeTheColor = 'Cliquez pour changer la couleur';
  EmployeeVacationAmountIsNullOrNegative = 'Le montant accordé ou restant aux vacances est negatif ou nul.';
  UserDeactivatedNoConnectionToApplications = 'Compte désactivé, aucun accès aux applications.';
  UserIsActive = 'Compte activé, accès aux applications autorisées.';
  NoWorkDataFoundSoNoDaysVerification = 'Impossible de charger la loi du travail. Pas de vérifications possibles.'
  PreviousVacationHasDeferredAmount='Un montant de {{amount}} provenant de la dernière période de vacances sera automatiquement ajouté.';
  NoPreviousVacationFoundNoDaysOfVacationAreRequired = 'Aucun historique de vacances, aucun jour de vacances n\'est requis.'
  NbVacationsRequiredByLaw = 'La loi requiert {{nb}} jour(s) de vacances';
  UsedDaysInThePeriod = 'Jours utilisés durant la période';
  UsedAmountInThePeriod = 'Montant utilisé';
  PeriodBalance = 'Jours disponibles (restants)';
  PeriodBalanceAmount = 'Montant restant';
  CalculatedAmountGrantedForPeriod = 'Montant accordé (Calculé)';
  ChooseColorTitle = 'Choisissez la couleur désirée';
  SelectThisWeek = 'Sélectionner cette semaine';
  Delete = 'Supprimer';
  HowManyWeeks = 'Nombre de semaines visibles';
  HowManyWeeksShort = 'Nb Semaines Visibles';
  OneWeek = '1 semaine';
  TwoWeeks = '2 semaines';
  ThreeWeeks = '3 semaines';
  FourWeeks = '4 semaines';
  FoldAllSchedules = 'Plier tous les horaires';
  UnFoldAllSchedules = 'Déplier tous les horaires';
  FoldAllTimesheets = 'Plier toutes les feuilles de temps';
  UnFoldAllTimesheets = 'Déplier toutes les feuilles de temps';

  VacationCantBeZero = 'Aucun temps de vacances disponible.';
  NotEnoughSickDaysLeft = 'Dépassement de la banque de maladie.';
  HolidayCantBeZero = 'Vérifiez le calcul du jour férié';

  EmployeeIsLate = '{{fn}} est en retard de {{nbMin}} min.';
  NoEmployeesAreLate = 'Tout le monde est à l\'heure.';
  LateEmployeesValidation = 'Retards & Présences';
  LateMessage = 'Messages';
  WageUsedInCalculation = 'Taux horaire utilisé: ';
  WageOfDefaultJobUsedInSomeCalculation = 'Taux horaire du poste par défaut: ';
  LastNote = 'Dernière note';
  EmployeeNoteList = 'Liste des notes à propos de l\'employé';
  Manager = 'Responsable';
  ModifDate = 'Dernière modification';
  EmployeeNote = 'Note  à propos de l\'employé';
  NoteVisibility = 'Visibilité de la note';
  DocumentVisibility = 'Visibilité du document';
  Visibility = 'Visibilité';
  NOTE_VISIBILITY_ALL = 'Tous';
  NOTE_VISIBILITY_ADMIN = 'Administrateurs';
  NOTE_VISIBILITY_PRIVATE = 'Privé';
  DOCUMENT_VISIBILITY_ALL = 'Tous';
  DOCUMENT_VISIBILITY_ADMIN = 'Administrateurs';
  DOCUMENT_VISIBILITY_PRIVATE = 'Privé';


  AddManualTimesheet = 'Ajouter une feuille de temps';
  AccountedBreak1Duration = 'Durée Retranchée Pause1 (hr:min)';
  AccountedBreak2Duration = 'Durée Retranchée Pause2 (hr:min)';
  AccountedMeal1Duration = 'Durée Retranchée Repas1 (hr:min)';
  Meal1IsPaid = 'Repas1 est payé';
  AccountedMeal2Duration = 'Durée Retranchée Repas2 (hr:min)';
  Meal2IsPaid = 'Repas2 est payé';
  TotalTime = 'Total (hr:min)';
  NoMeal1Information = 'Aucun Repas1';
  NoMeal2Information = 'Aucun Repas2';
  NoBreak1Information = 'Aucune Pause1';
  NoBreak2Information = 'Aucune Pause2';
  VacationDaysLeft = 'Jours de vacances restants: ';
  ValueOfDayOfVacationInMinutes = '1 jour est équivalent à ';
  AllowedTime = 'Temps accordé (hr:min)';
  UsedTime = 'Temps utilisé (hr:min)';
  Administrator = 'Administrateur';

  UserPreferences = 'Préférences';
  PREFS_WORKSHIFT_DEFAULT_START_TIME = 'Début de quart par défaut';
  PREFS_WORKSHIFT_DEFAULT_END_TIME = 'Fin de quart par défaut';

  PREFS_LATE_MIN_TIME = 'Nombre de minutes minimal considéré comme retard (> 15 min)';
  PREFS_LATE_MAX_TIME = 'Nombre de minutes maximal de retard à rapporter.';
  PREFS_RUN_VALIDATION_PLAN_NB_WEEK = 'Nombre de semaines à considérer pour la vérification des plans.';
  PREFS_RUN_VALIDATION_EMPLOYEE_NB_WEEK = 'Nombre de semaines à considérer pour la vérification des employés.';
  PREFS_NB_WEEK_FOR_SCHEDULE = 'Nombre de semaines à afficher pour les horaires par employé.';
  PREFS_NB_DAY_FOR_TIMESHEET = 'Nombre de jours à considérer pour approuver les feuilles de temps';
  PREFS_NB_DAY_FOR_EXPENSE = 'Nombre de jours à considérer pour approuver les dépenses';

  PREFS_ESTABLISHMENT_DONE = 'Implantation terminée';
  PREFS_USE_TIMED_TASKS = 'Gestionnaire de Projets';
  PREFS_USE_ALTERNATE_UI = 'Nouvelle interface (nécessite de se re-connecter.)';
  PREFS_UI_VERSION = 'Interface Utilisateur (nécessite de se re-connecter.)';

  PREFS_SHOW_CCQ_OPTION = 'Afficher les options CCQ.';
  PREFS_DEFAULT_SORT_ORDER = 'Tri par défaut';
  PREFS_USE_UDATA_SERVICE = 'UData Service (RPA360)';
  PREFS_USE_ALLIERH_SERVICE = 'Folks Service';
  PREFS_USE_RETAIL_NEXT_SERVICE = 'RetailNext Service';
  PREFS_VALIDATE_OVERTIME = 'Vérifier temps supplémentaire';
  PREFS_INCLUDE_VACATION_IN_AMOUNT_WHEN_AVAILABLE = 'Inclure les vacances dans le calcul des montants';
  PREFS_DISPLAY_SCHEDULE_TO_FILL = 'Afficher les quarts à combler';
  PREFS_DISPLAY_AMOUNT = 'Afficher les montants';
  PREFS_SHOW_PARAMS_PROFILE = 'Afficher les praramètres de profil';
  PREFS_DISPLAY_DAY_SALES_COST_OBJECTIVE = 'Afficher les objectifs de coûts';
  PREFS_DISPLAY_EMPLOYEE_PROFILE_IMAGE = 'Afficher les photos des employés';
  PREFS_USE_SHIFT_BONUS = 'Utilisation des primes sur les quarts de travail';
  PREFS_DISPLAY_PLAN_IN_SCHEDULE_PER_POSITION = 'Afficher les plans dans les horaires par poste';
  PREFS_USE_BANK_TYPE = 'Banques de temps personnalisées';
  PREFS_USE_GEO_FENCE = 'Zones GPS';
  PREFS_USE_SURVEYS = 'Questionnaires';
  PREFS_USE_SURVEYS_EXTRA = 'Questionnaires Extra (COVID)';

  PREFS_USE_API_ACCESS = 'Accès API';
  PREFS_USE_CUSTOM_PREMIUM = 'Accès Primes Cumulatives Personnalisées';
  PREFS_DEMO_ACCOUNT = 'Compte DEMO';
  PREFS_USE_REPORT_TO_EMAIL = 'Rapports par courriel';
  PREFS_CAN_MODIFY_COST_DISTRIBUTION = 'Modification des Distributions de Coûts';
  PREFS_USE_SYNC_API = 'Sync API';
  PREFS_HIDE_INFORMATION_FOR_DEMOS = 'Cacher des informations en mode démo';
  PREFS_MANUAL_VALIDATION_SCHEDULE='Validation manuelle des horaires';
  PREFS_CAN_MODIFY_ALL_PAST_TS='Peut modifier toutes les FDTs dans le passé';
  PREFS_CAN_MODIFY_ALL_PAST_SCHEDULES='Peut modifier tous les horaires dans le passé';

  PREFS_DISPLAY_MEMOS_BY_TYPE='Afficher les mémos par type';

  PREFS_ACCOUNT_CAN_ADD_TEST_PUNCH='Peut ajouter des horaires et des poinçons (Jerome Only!)';
  PREFS_ACCOUNT_CAN_DELETE_UNAPPROVED_TS_IN_BATCH='Peut supprimer des feuilles de temps en lot (Jerome Only!)';

  PREFS_AUTO_SAVE_SCHEDULES='Sauvegarde automatique des horaires';
  PREFS_MAX_MENU_600='Menus Max 600';
  PREFS_MAX_MENU_800='Menus Max 800';
  PREFS_MAX_MENU_900='Menus Max 900';

  PREFS_DISPLAY_REQUEST_LIST='Afficher les requêtes reçues';
  PREFS_USE_INTUIT_API='Intuit API';
  PREFS_FAVORITE_MENU='Menu Favoris';
  PREFS_DEFAULT_MEAL_DURATION='Durée repas par défaut';
  PREFS_DEFAULT_BREAK_DURATION='Durée pause par défaut';
  PREFS_CAN_READ_CONFIGURATION_API_V2='Accès à la configuration API V2';
  PREFS_SMART_SEARCH='Recherche intuitive des employés';
  PREFS_EDIT_IN_PLACE='Modification rapide (Horaires & FdTs)';

  PREFS_COPY_ONLY_SCHEDULE_WITH_DND="Glisser/Déposer fait toujours une copie";
  PREFS_EMPLOYEE_FILE_PANEL_OPEN_V2='Panneaux ouverts - V2'
  PREFS_CUSTOM_GROUP_CARBUR ='Menu - Group Carbur';
  PREFS_IMPORT_SCHEDULES_FROM_ON_TRACK='Importer les horaires OnTrack - Menu';



  EmployeeWillPunch = 'L\'employé pourra poinçonner.';
  EmployeeWillPunchOnTheWeb__ = 'L\'employé pourra poinçonner sur l\'internet et l\'application mobile.';
  EmployeeWillPunchOnTheWeb = 'L\'employé pourra poinçonner avec le portail employé.';
  EmployeeWillPunchOnTheMobile= 'L\'employé pourra poinçonner avec l\'application mobile.';
  TasksAndFunction = 'Tâches et Fonction';
  Task1 = 'Tâche 1';
  Task2 = 'Tâche 2';
  Task3 = 'Tâche 3';
  Task4 = 'Tâche 4';
  Task5 = 'Tâche 5';
  Task6 = 'Tâche 6';
  Task7 = 'Tâche 7';
  Task8 = 'Tâche 8';
  Task9 = 'Tâche 9';
  Task10 = 'Tâche 10';
  Pay = 'Paie';
  PayManagement = 'Gestion de la Paie';
  Enterprises = 'Entreprises';
  Periode = 'Période de paie';
  EXPORT_PAY_TYPE_1 = 'Nethris';
  EXPORT_PAY_TYPE_2 = 'Acomba';
  EXPORT_PAY_TYPE_3 = 'Avantage';
  EXPORT_PAY_TYPE_4 = 'Desjardins';
  EXPORT_PAY_TYPE_5 = 'Paie PC';
  EXPORT_PAY_TYPE_6 = 'Pay Web';
  EXPORT_PAY_TYPE_7 = 'Simple Comptable';
  EXPORT_PAY_TYPE_8 = 'ADP';
  EXPORT_PAY_TYPE_9 = 'Sage (PJC)';
  EXPORT_PAY_TYPE_10 = 'Rocheleau';
  EXPORT_PAY_TYPE_11 = 'Cytronics';
  EXPORT_PAY_TYPE_12 = 'SCQC';
  EXPORT_PAY_TYPE_13 = 'Hopem';
  EXPORT_PAY_TYPE_14 = 'MagicPay'
  EXPORT_PAY_TYPE_15 = 'SCQC GC';
  EXPORT_PAY_TYPE_16 = 'Acceo';
  EXPORT_PAY_TYPE_17 = 'PowerPay (Ceridian)';
  EXPORT_PAY_TYPE_18 = 'EasyPay';
  EXPORT_PAY_TYPE_19 = 'Ogasys';
  EXPORT_PAY_TYPE_20 = 'Azur';
  EXPORT_PAY_TYPE_21 = 'Hopem+';
  EXPORT_PAY_TYPE_22 = 'Ultimate';
  EXPORT_PAY_TYPE_23 = 'Nethris (Assiduité)';
  EXPORT_PAY_TYPE_24 = 'Desjardins (Assiduité)';
  EXPORT_PAY_TYPE_25 = 'Hopem (Valeo-Sedna)';
  EXPORT_PAY_TYPE_26 = 'PayWorks';
  EXPORT_PAY_TYPE_27 = 'Titan';
  EXPORT_PAY_TYPE_28 = 'Sage50';
  EXPORT_PAY_TYPE_29 = 'QuickBooks Time';
  EXPORT_PAY_TYPE_30 = 'Emprez';
  EXPORT_PAY_TYPE_32 = 'On Track';
  EXPORT_PAY_TYPE_33 = 'ADP - CSV';
  EXPORT_PAY_TYPE_34 = 'Harvest';



  PAY_PERIOD_TYPE1 = 'Par semaine';
  PAY_PERIOD_TYPE2 = 'Aux deux semaines';

  PAY_COMPILATION_TYPE_WEEKLY = 'Par semaine';
  PAY_COMPILATION_TYPE_TWO_WEEK = 'Par deux semaines';
  PAY_COMPILATION_TYPE_WEEK_1_ONLY = 'Semaine 1 seulement';
  PAY_COMPILATION_TYPE_WEEK_2_ONLY = 'Semaine 2 seulement';

  SaveConfiguration = 'Enregistrer la configuration';
  PAY_SUMMARY_SORT_ALPHABETICAL = 'Ordre alphabétique';
  PAY_SUMMARY_SORT_BADGE_ID = 'Numéro de matricule';
  PAY_SUMMARY_SORT_SENIORITY = 'Année de service';
  PAY_SUMMARY_SORT_DEFAULT_JOB = 'Poste par défaut';
  PAY_SUMMARY_SORT_SERVICE = 'Service';
  ExportingPay = 'Exportation';
  PaySystem = 'Système de paie';
  EnterpriseCode = 'Code d\'entreprise';
  PayCompilation = 'Compilation';
  PayWorkedHours = 'Heures travaillées';
  HolidayHours = 'Fériés';
  VacationHours = 'Vacances';
  SickLeaveHours = 'Congés maladie';
  PaidAbsenceHours = 'Congé avec solde';
  PaidLeaveHours = 'Absences payées';
  _PaidAbsenceHours = 'Absences payées';
  _PaidLeaveHours = 'Congé avec solde';

  TimeBankUtil = 'Utilisation de la banque de temps';
  TimeBankCumul = 'Cumul dans la banque de temps';
  ExportPayFile = 'Générer';
  ExportPayFileAndTransmit = 'Générer et Envoyer';
  ExportingPaySummary = 'Sommaire de paie';
  ExportPaySummaryFile = 'Générer';
  IncludeTerminatedEmployees = 'Inclure les employés terminés';
  ExportingEmployees = 'Exportation des dossiers des employés';
  ExportEmployeeFile = 'Générer';
  ExportEmployeeFileAndTransmit = 'Générer et Envoyer';
  SortOrder = 'Tri par';
  ImportingPayStubs = 'Import des talons de paie';
  ImportPayStubs = 'Importer';
  ExportType = 'Type d\'export';
  EXPORT_EMPLOYEE_FORMAT_ADP = 'ADP';
  EXPORT_EMPLOYEE_FORMAT_NETHRIS = 'Desjardins-Nethris';
  EXPORT_EMPLOYEE_FORMAT_AZUR = 'Azur';
  EXPORT_EMPLOYEE_FORMAT_HOPEM = 'Hopem';
  EXPORT_EMPLOYEE_FORMAT_HOPEM_VALEO_SEDNA = 'Hopem (Valeo-Sedna)';
  EXPORT_EMPLOYEE_FORMAT_ON_TRACK = 'On Track';


  PayStubFormatType = 'Format des talons de paie à importer';
  DropPayStubsHere = 'Déposer le fichier contenant le ou les talons de paie ici.'
  PAY_STUB_FORMAT_TYPE_NETHRIS_ = 'Nethris-Desjardins';
  PAY_STUB_FORMAT_TYPE_NETHRIS = 'Standard';
  ImportFile = 'Importer le fichier';
  WeekCompilation = 'Semaine';
  'Week 1' = 'Semaine 1';
  'Week 2' = 'Semaine 2';
  APIUserName = 'Usager (Accès Services Web)';
  APIPassword = 'Mot de passe';
  ApiEnterpriseCode = 'Code entreprise (Services Web)';
  ApprobationDoneAndWhen = 'Approuvé par {{approvedBy}} le {{approvedOn}}';
  LockedByAndWhen = 'Verrouillé par {{lockedBy}} le {{lockedOn}}';
  ReadyToBeApproved = 'Prêt à être approuvé';
  ErrorsCantBeApproved= 'Trop d\'erreurs';
  AlreadyApprovedCantBeDisapprovedLocked='Approuvé & Vérouillé';
  AlreadyApprovedCanBeDisapproved='Désapprouver';
  Approved='Approuvé'


  ForThePayPeriode = 'Pour la période de paie';
  ForTheWeekPeriode = 'Pour la période';
  OrForThisDayOnly = 'Ou seulement pour';
  EmployeeRights = 'Droits associés';
  RightsPerUnit = 'Accès seulement aux unités sélectionnées.';
  RightsPerEnterprise = 'Accès seulement aux entreprises sélectionnées.'
  ApproveAll = 'Tout approuver';
  UnApproveAll = 'Tout dé-approuver';


  'Cant.approve.not.between.dates' = 'On ne peut approuver que les feuilles de temps comprises entre {{from}} et {{to}}';
  'Cant.approve.no.job' = 'La feuille de temps n\'a pas de poste associé.';
  'NotTheRightRole.to.approve' = 'Ce n\'est pas le bon rôle pour approuver les feuilles de temps.';
  PeriodeWeek = 'Période'

  RawInformationForEmployee = 'Information \'brute\' pour la paie de l\'employé';
  RawPayPeriod = 'Période de paie';
  RawDisclaimer = 'Attention les heures sont en dixièmes (1,5 signifie 1h 30min)';
  PayEntryCode = 'Code';
  PayEntryName = 'Desc.'
  DivisionCode = 'Div.';
  ServiceCode = 'Serv.';
  DepartmentCode = 'Dept.';
  SubDepartmentCode = 'S-Dept.';
  HoursDecimal = 'Heures (10)';
  Wage = 'Taux';
  PayAmount = 'Montant';
  BonusManagement = 'Gestion des primes';
  JobBonusPerDayAndHour = 'Primes horaires';
  DefaultBonus = '(Par défaut)';
  BonusPerHour = '{{value}}/h';
  BonusFixed='{{value}}';
  BonusFixedInPercent='{{value}}';
  BonusPercentHour = '{{value}} %/h';
  EveryDayFrom = 'Tous les jours';
  ExplainJobBonus = '{{when}} de {{start}} à {{end}}, {{bonus}}. (Code Heures: {{hourCode}}, Code Prime: {{bonusCode}}).<br> <span style="font-style: italic">{{divisions}}</span>';
  ExplainShiftBonus = 'Bonus: {{bonus}}. (Code Heures: {{hourCode}}, Code Prime: {{bonusCode}}).{{bonusPoste}}<br> <span style="font-style: italic">{{divisions}}</span>';
  WillAddJobBonusIfThereIsOne = ' (La prime de poste sera ajoutée.)';
  BonusIsDeactivated = ' <span class="emprez-orange-fiesta">La prime est désactivée.</span>'

  ExpensesTypes='Type de dépenses';
  ExplainExpenseType='Dépense en {{unitName}} dont le coefficient multiplicateur est {{valuePerUnit}}, exporté dans la paie avec le code {{payExportCode}} <br> <span style="font-style: italic">{{divisions}}</span>';
  ExplainExpenseTypeDeactivated='<span class="emprez-orange-fiesta">Dépense désactivée en {{unitName}} dont le coefficient multiplicateur est {{valuePerUnit}}, exporté dans la paie avec le code {{payExportCode}} <br> <span style="font-style: italic">{{divisions}}</span></span>';

  CumulativeBonus = 'Primes cumulatives';
  CUMULATIVE_BONUS_TYPE_OVERTIME = 'Supplémentaire';
  CUMULATIVE_BONUS_TYPE_FIX = 'Forfaitaire';
  CUMULATIVE_BONUS_TYPE_HOLIDAY = 'Férié';

  CUMULATIVE_BONUS_PERIOD_DAILY = 'Quotidienne';
  CUMULATIVE_BONUS_PERIOD_HEBDO = 'Hebdomadaire';
  CUMULATIVE_BONUS_PERIOD_FORTNIGHT = 'Par quinzaine';

  CUMULATIVE_BONUS_CONDITION_LESSER = 'plus petit que';
  CUMULATIVE_BONUS_CONDITION_GREATER = 'plus grand que';
  CUMULATIVE_BONUS_CONDITION_EQUALS = 'égal à';
  CUMULATIVE_BONUS_CONDITION_DIFFERENT = 'différent de';
  CUMULATIVE_BONUS_CONDITION_TO_A_MAX_OF = 'au maximum de';
  CUMULATIVE_BONUS_CONDITION_GREATER_OR_EQUALS='plus grand ou égal à';

  CumulativeBonusWorkedHour = 'Heures travaillées';
  CumulativeBonusTraining = 'Formation';
  CumulativeBonusTraineeship = 'Entraînement';
  CumulativeBonusHoliday = 'Férié';
  CumulativeBonusVacation = 'Vacances';
  CumulativeBonusPaidDayOff = 'Congé payé';
  CumulativeBonusPaidFamily = 'Abs. Famille payée';

  CumulativeBonusBonus = 'Ajouter la prime par poste';

  CumulativeBonusForHoliday = 'Prime de jour férié de {{bonus}}, pour les horaires de type {{schedules}}. (Code paie: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>';
  CumulativeBonusForHolidayWithCondition = 'Prime de jour férié de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures ({{accumulation}}) est {{condition}}. (Code paie: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>';
  CumulativeBonusFix = 'Prime de {{bonus}}, pour les horaires de type <span style="font-style: italic">({{schedules}})</span>, lorsque le total des heures <span style="font-style: italic">({{accumulation}})</span> est {{condition}}. (Code paie: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>';
  CumulativeBonusOvertime = 'Prime de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures ({{accumulation}}) est {{condition}}. (Code paie: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>';
  CumulativeBonusToAMaxOf = 'Prime de {{bonus}}, pour les horaires de type <span style="font-style: italic">({{schedules}})</span>, jusqu\'à un maximum de {{condition}} <span style="font-style: italic">({{accumulation}})</span>. (Code paie: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>';
  EditCumulativeBonus = 'Prime cumulative';
  BonusWontApplyOnHolidays = '<span class="emprez-orange">(Ne s\'appliquera pas lors d\'un jour férié)</span>';
  CumulativeBonusApplyEvenOnHoliday = 'S\'applique lors d\'un jour férié (En général doit être activé)';
  CumulativeBonusDaysOfTheWeekExplanation='La prime utilisera seulement les feuilles de temps pour les jours de la semaine sélectionnés ci-dessous.';
  TSWillApplyOnlyOn='La prime utilisera seulement les feuilles de temps pour les  <span style="font-style: italic">{{daysOfTheWeek}}</span>.';
  WillBeUsedInSomeHolidayCalculation='La prime sera utilisée dans certaines méthodes de calcul des fériés.';

  bonusName = 'Nom';
  payExportCode = 'Code Paie';
  CumulativeBonusPercent = 'Primes';
  CumulativeBonusAmount = 'Primes';
  CumulativeBonusDefault = 'Prime par défaut';
  CumulativeBonusUseInSomeHolidayCalculation='Utilisée dans certaines méthodes de calcul des fériés';
  bonusType = 'Type de prime';
  bonusPeriod = 'Période'
  condition = 'Quand le total des heures'
  conditionAmount = 'HH:mm';

  PunchTakesPhoto = 'Prise de photo';
  PhotoRetention = 'Retention des photos';
  PunchID = 'Punch Id';
  PunchAdminCode = 'Punch Admin Code';
  StartOfWeek = 'Début de la semaine';
  startOfWeekForSchedule = 'Début de la semaine (Horaires)';
  TimeZone = 'Fuseau Horaire';
  LoadingDataDelayInMinute = 'Délai Chargement (min)';
  SendingDataDelayInMinute = 'Délai Envoi (min)';
  BreakMaxDelayInMin = 'Délai Affich. Exédent. Pause (min)';
  MealMaxDelayNoScheduleInMin = 'Délai Affich. Exédent. Repas sans horaire (min)';
  MealMaxDelayInMin = 'Délai Affich. Exédent. Repas (min)';
  PunchCheckSequence = 'Vérif. Séquence';
  PunchCheckBreak = 'Valid. les pauses';
  PunchCheckMeal = 'Valid. les repas';
  DisplayBirthday = 'Aff. Anniversaire';
  DisplayClock = 'Aff. Horloge';
  DisplaySchedule = 'Aff. Horaire';
  DisplayEmergency = 'Aff. Urgences';
  DisplayEmployeeSchedule = 'Aff. Horaire Employé';
  DisplayEmployeeMessages = 'Aff. Message Employé';
  DisplayEmployeeTasks = 'Aff. Tâches Employé';
  DisplayClose = 'Aff. Bouton Fermeture';
  IsItASmallScreenTAG = 'Petit Écran (TAG)';
  DisplayMealButton = 'Aff. Bouton Repas';
  DisplayBreakButton = 'Aff. Bouton Pauses';
  DisplayJobChangeButton = 'Aff. Bouton Changement Poste';
  DisplayTimesheetButton = 'Aff. Bouton FDT';

  ShowAttendance='Aff. Présences';
  ShowAbsence='Aff. Absences';


  PunchIsVisible = 'L\'horodateur est visible';
  SearchByPunchName = 'Recherche par le nom de l\'horodateur';
  DisconnectedPunches = 'Liste des horodateurs déconnectés';
  createPunch = 'Création d\'un horodateur';
  punchName = 'Nom de l\'horodateur';
  EnterprisesPanel = 'Entreprises';
  EnterpriseGroupsPanel = 'Groupes d\'entreprises';
  NoEnterpriseFound = 'Aucune Entreprise';
  EnterpriseName = 'Nom de l\'entreprise';
  SearchEnterprise = 'Recherche d\'entreprise';
  EnterEnterpriseNameOrCode = 'Entrez le nom ou le code de l\'entreprise recherchée';

  UnitNotFound = 'Unité non trouvée';
  UNIT_TYPE_DIVISION = 'Division';
  UNIT_TYPE_SERVICE = 'Service';
  UNIT_TYPE_DEPARTEMENT = 'Département';
  UNIT_TYPE_SOUS_DEPARTEMENT = 'Sous-Département';
  AddSubUnit = 'Ajouter une sous-unité';
  EditDivision = 'Division';
  CreateUnit = 'Créer une unité';
  description = 'Description';
  CreateJob = 'Créer un poste';
  SearchUnit = 'Recherche d\'une unité';
  ShowDivisions = 'Toutes les divisions';
  CreateNewDivision = 'Créer une nouvelle division';
  unitCode = 'Unit Id';
  startOfWeek = 'Début de la semaine';
  zohoId = 'CRM Id (Zoho Id)';
  ZohoName = 'CRM Nom (Zoho Name)';
  NoteSysAdmin = 'Note (Half-God)';

  EditHourBonus = 'Prime horaire';
  startTime = 'Heure de début';
  endTime = 'Heure de fin';
  JobBonusPercent = 'Pourcent. de la prime';
  JobBonusAmount = 'Montant de la prime'
  PayExportHour = 'Code des heures';
  PayExportBonus = 'Code de la prime';

  CreateNewEnterprise = 'Nouvelle entreprise';
  ThisPunchHasNoConfigVeryWrong = 'Quelquechose ne fonctionne pas avec ce punch. Aucune configuration n\'a été trouvée.';
  ImportEmployeeNethrisFormat = 'Import des employés (Format 1)';
  UploadCSVFile = 'Sélectionner le ficher au format CSV';
  EmployeeInserted = '{{nbSuccess}}/{{nbObjects}} employés ont été ajoutés.';

  ShowFormat = 'Afficher le format';
  HideFormat = 'Cacher';
  MandatoryField = 'Champ obligatoire.';
  CreateEmployee = 'Créer un nouvel employé';
  ImportEmployeeFromFile = 'Importer des employés depuis un fichier';
//  ImportEmployeeFromAPI = 'Importer des employés avec le service Web';
  ImportEmployeeFromAPI = 'Service Web: Importer de nouveaux employés à partir du système de paie';
  ImportEmployeeWithNethrisAPI = 'Import avec l\'entreprise {{name}}';
  SearchLNameNethris = 'Recherche exacte (Limitation du service Web) par nom de famille';

  ApiUserName = 'Usager Service Web';
  ApiPassword = 'Mot de passe Service Web';
  APIUseTheTestMode = 'Service Web de Test';

  ExportationCodes = 'Codes par défaut pour la paie';
  UploadStructureAsCSV = 'Importer Structure (.csv)';
  ExcelTemplate = "Gabarit Excel";
  AutomaticTimesheetValue = 'Paramètres Repas (Auto TS) ';
  EntityCode = 'Code Entité';
  CreateAdmin = 'Création d\'un usager Administrateur';

  SchedulePrintConfig = "Options du rapport";
  ShowDivision = "Afficher la division";
  ShowHeader = "Afficher l\'entête";
  ShowColor = 'Afficher les couleurs';
  ShowTraining = 'Afficher les entraînements';
  ShowTimeOff = 'Afficher les congés';
  ShowTel = 'Afficher le téléphone';
  ShowTotal = 'Afficher le total';
  ShowJob = 'Afficher le poste';
  ShowFunction = 'Afficher la fonction';
  ShowNoSchedule = 'Afficher sans schedule';
  ShowMeal = 'Afficher les repas';
  ShowBreak = 'Afficher les pauses';
  ShowDailyPercentage = 'Afficher le pourcentage par jour';
  ShowTasks = 'Afficher les tâches';
  ShowEmployeeWithoutSchedule='Afficher les employés sans horaires';
  ShowWorkShiftBonus='Afficher les primes pour les quarts de travail';


  // SendToPayRoll = 'Envoyer vers le système de paie';
  //
  // retrieveFromPayRoll',{payRoll: this.translate.instant(this.enterprise.systemType.toTranslateKey())});
  RetrieveFromPayRoll = 'Lire depuis {{payRoll}}';
  RetrieveFromPayRollThenUpdateEmprez = 'Lire depuis {{payRoll}} et mettre à jour le dossier employé';
  MatchingFromPayRoll = 'Trouvé dans {{payRoll}}';
  MatchEmployeeWithAllieRH='Folks: Associer avec les employés d\'Emprez';
  ImportEmployeeFromAllieRH='Folks: Importer les employés dans Emprez';

  MatchEmployeeWithFolks = 'Association avec {{name}}';
  ImportEmployeeWithFolks='Importer avec {{name}}';

  SendToPayRoll = 'Envoyer vers {{payRoll}}';
  DifferentSalary = 'Salaire sur {{payRoll}} est {{salary}}';
  DownloadMyStructure = 'Télécharger ma structure';
  EditEmployeeNow = 'Modifier l\'employé';
  Year = 'Année';
  AbsCode = 'Code';
  AbsType = 'Type';
  Description = 'Description';
  BalanceHours = 'Solde Hres';
  BalanceAmount = 'Solde';
  PaidHours = 'Payé Hres';
  PaidAmount = 'Payé';
  BanksInformation = 'Information sur les banques d\'absences';
  UsingTheTimeBank = 'Utilisation de la banque de temps travaillé';
  PunchMessages = 'Messages apparaissant sur le poinçon';
  NoMessageForPunches = 'Aucun message n\'a été créé.';
  PunchMessageDisclaimer = 'Prévoir 1 heure de délai entre le moment où vous enregistrez le message et sa disponibilité sur le poinçon.';

  Author = 'Auteur';
  Batching = 'Traitements en lot';
  RetrieveInformation = 'Rechercher';
  Import = 'Importer';
  ImportSelectedBalance = 'Importer le solde sélectionné';
  CreateVacationRecord = 'Ajouter les vacances en lot';
  CreateOrDeleteVacationRecord = 'Ajouter ou supprimer les vacances en lot';
  CreateOrRemoveEvaluationsInBatch='Ajouter ou supprimer des évaluations en lot';
  AddEvaluationToEmployee='Ajouter une évaluation (si aucune pour la même échéance)';
  RemoveEvaluationFromEmployee='Supprimer une évaluation (si aucune réponse enregistrée)';

  SearchForEmployeePlaceHolder = '<Nom> <Prenom> ou #<Matricule>';
  UpdateVisibleEmployee = 'Modifier la visibilité des employés en lot';
  CreateSickDays = 'Ajouter les jours de maladie en lot';
  CreateOrDeleteSickDays = 'Ajouter ou supprimer les jours de maladie en lot';

  SelectAll = 'Tout sélectionner';
  UnSelectAll = 'Tout dé-sélectionner';
  SickDaysInMin = 'Jour Maladie en HH:MM';
  UpdateSalaryInBatch = 'Ajuster le salaire des employés en lot';
  WithSalaryGreaterThan = 'Employés avec un salaire supérieur à';
  WithSalaryLessThan = 'Employés avec un salaire inférieur à';
  AdjustmentDate = 'Date de l\'ajustement';
  SalaryAdjustment = 'Ajustement du salaire';
  SalaryAdjustmentPercent = 'Ajustement du salaire en pourcentage';
  EmployeeTerminated = 'Terminé(e)';
  ExternalCalendariCal = 'Lien pour (Google Calendar,...)';
  CopyCalendarLinkToClipboard='Copier le lien pour le Calendrier Google';
  SendCalendarLinkToEmployee='Envoyer le lien pour le Calendrier Google';

  CopyToClipboard = 'Copier';
  SendToEmployee = 'Envoyer par courriel';
  DoYouWantUsToSendYouANewPassword = 'Voulez-vous que nous vous envoyons un nouveau mot de passe?';
  NewPasswordSentTo = 'Un nouveau mot de passe a été envoyé à {{recipient}}';
  SearchLName = 'Recherche par nom d\'employés';
  'Remember me' = 'Se souvenir de moi';
  'Forgot Password?' = 'Mot de passe oublié ?';
  'Login' = 'Se Connecter';
  Report1010 = 'Sommaire des heures travaillées';
  Report1014 = 'Absences collectives';
  Report1015 = 'Absences individuelles';
  Report1016 = 'Exceptions par employé';
  Report1017 = 'Exceptions par subdivision';
  Report1018 = 'Badges';
  Report1019 = 'Codes d\'usagers';
  Report1020 = 'Années de service';
  Report1021 = 'Présence horaire';
  Report1022 = 'Présence quotidienne';
  Report1023 = 'Sommaire hebdomadaire';
  Report1024 = 'Sommaire individuel';
  Report1025 = 'Calendrier de vacances';
  Report1026 = 'Compétences Expirées';
  Report1027 = 'Feuilles de temps en lot';
  Report1028 = 'Feuilles de temps';
  Report1029 = 'Inter-Division';
  Report1030 = 'Formations';
  Report1031 = 'Sommaire individuel en lot';
  Report1032 = 'Heures supplémentaires';
  Report1033 = 'Salaire';
  Report1035 = 'Liste téléphonique';
  Report1036 = 'Poinçons par employé';
  Report1037 = 'Poinçons modifiés';
  Report1038 = 'Poinçons modifiés par employé';
  Report1039 = 'Anniversaires';
  Report1041 = 'Banque de temps';
  Report1042 = 'Ancienneté en heures par employé et par poste';
  Report1043 = 'Bonus par employé et par date';
  Report1045 = 'Sommaire des banques';
  Report1046 = 'Contacts d\'urgence';
  Report1047 = 'Compétences Courantes';
  Report1048 = 'Export des Absences';
  Report1049 = 'Retards et Absences Individuels';
  Report1050 = 'Retards et Absences Collectifs';
  Report1051 = 'Sommaire réel';
  Report1052 = 'Calcul de f\u00E9ri\u00E9s';
  Report1053 = 'Liste des f\u00E9ri\u00E9s';
  Report1056 = 'Disponibilités des employés';
  Report1057 = 'Horaire hebdomadaire';
  Report1058 = 'Coûts par jour';
  Report1059 = 'Soldes des banques personnalisées';
  Report1060 = 'Détails des banques personnalisées';
  Report1061 = 'Taux de roulement du personnel'
  Report1062 = 'Liste des employés avec au moins un horaire par date';
  Report1063 = 'Liste des employés avec au moins une FDT approuvée par date';
  Report1064 = 'Nombre distinct d\'employés avec au moins une FDT approuvée ou un horaire actif';
  Report1065 = 'Liste des primes associées aux employés';
  Report1066 = 'Travail, absences et rémunération par employé';
  Report1067 = 'Rémunérations par entreprise de paie';
  Report1068 = 'Travail, absences et rémunération par employé - Sélection par groupe et structure';
  Report1069 = 'Absentéisme et retards par structure';
  Report1070 = 'Retards par structure';
  Report1071 = 'Comparaison des rémunérations pour une période de paie';
  Report1073 = 'Liste détaillée des FDTs par entreprise de paie';
  Report1074 = 'Liste détaillée des FDTs par structure';
  Report1076 = 'Tous les courriels des responsables et des administrateurs';
  Report1077 = 'Tâches par projet et par date';
  Report1078 = 'Horaires affichés par unité';
  Report1079 = 'Statut d\'embauche modifié par dates';
  Report1080 = 'Dépenses';
  Report1081 = 'Feuilles de temps pour les employés inactifs ou cachés';
  Report1082 = 'Évaluations par employé';
  Report1083 = 'Évaluations à faire par employé';
  Report1085 ='Emplоyés terminés';
  Report1086='Requêtes des employés'
  Report1087='Droits sur les structures et les entreprises par employé';
  Report1088='Droits sur les structures et les entreprises par employé';
  Report1089='Requêtes des employés en attente de réponse (par unité)';
  Report1090 = 'Sommaire hebdomadaire (structure)';
  Report1091='Postes des employés (Structure)';
  Report1092='Coûts de formation';
  Report1094='Horaires ou feuilles de temps supprimés';
  Report1095='Employés avec au moins une feuille de temps approuvée';
  Report1096='Calendrier des banques de temps personnalisées';




  ReportW9001 = 'Feuille de temps (Armoires Cuisines Action)';
  ReportW9002 = 'Temps Approuvé (La Cordée)';
  ReportW9003 = 'Feuille de temps (PicNik)';
  ReportW9004 = 'Calcul Maladie GBDA';
  ReportW9007 = 'Rapport Mortagne';
  ReportW9010 = 'Rapport HART';
  ReportW9011 = 'Rapport Esterel - Coûts';
  ReportW9012 = 'Heures travaillées avec totaux par poste et département (9012)';
  ReportW9013 = 'Sommaire individuel en lot (9013)';
  ReportW9014 = 'Rapport Primeau Vélo';
  ReportW9015 = 'Cumul des Heures';
  ReportW9016 = 'R. des batisseurs - Heures travaillees (9016)';
  ReportW9017 = 'WongWing - Sommaire individuel par groupe (9017)';
  ReportW9018 = 'Horaires vides (9018)';
  ReportW9019 = 'Salaire (9019)';
  ReportW9020 = 'Liste des feuilles de temps non verrouillées (9020)';
  ReportW9021 = 'Absences personnel de soutien (9021)';
  ReportW9022 = 'Feuilles de temps et Primes (9022)';
  ReportW9023 = 'Sommaire de paie - Limité (9023)';
  ReportW9024 = 'Schedules per Function (9024)';
  ReportW9025 = 'Horaires Prévus - Horaires Réels (9025)';
  ReportW9026 = 'Feuilles de temps (9026)'
  ReportW9027 = 'Sommaire des heures travaillées (9027)';
  ReportW9028 = 'Azoulay - Sommaire des heures (9028)';
  ReportW9029 = 'Sommaire des heures travaillées par poste (9029)';
  ReportW9030 = 'Heures par employé et par segment (9030)';
  ReportW9031 = 'Heures travaillées (9031)';
  ReportW9032 = 'Maison Riviera Heures travaillées (9032)';
  ReportW9033 = 'La Cordée - Formation (9033)';
  ReportW9034 = 'MSB Design - Sommaire individuel annuel (9034)';
  ReportW9035 = 'Sommaire de paie - Colonnes (9035)';
  ReportW9036 = 'Horaire hebdomadaire (9036)';
  ReportW9037 = 'Coûts par jour et par subdivision (9037)';
  ReportW9038 = 'Statuts des mémos - Usager courant (9038)';
  ReportW9039 = 'Absences et retards (9039)';
  ReportW9040 = 'Liste détaillée des FDTs par date (9040)';







  AllEmployeeReports = 'Rapports - Employés';
  AllCostReports = 'Rapports - Coûts';
  AllTimesheetReports = 'Rapports - Feuilles de temps';
  AllScheduleReports = 'Rapports - Horaires';
  TimedTasksReports = 'Rapports - Projets';


  NewWage = 'Nouveau Taux';
  ChooseTheEmployeeToExport = 'Choisir les employés à exporter';
  GroupCreatedBy = 'Auteur';
  GroupName = 'Nom';
  GroupNotes = 'Notes';
  AddGroup = 'Nouveau';
  EditGroupEmployeAggregation = 'Groupe d\'employés';
  GroupIsVisible = 'Le groupe est visible';
  EmployeeGroups = 'Groupes d\'employés';
  GroupManager = 'Gestionnaire de groupe d\'employés';
  GroupManagerShortName = 'Gérer les groupes';

  ChooseEmployee = 'Sélectionnez un employé';
  SelectElement = 'Sélection';
  unscheduledStart = 'D\u00E9but de quart de travail non prévu';
  unscheduledEnd = 'Fin de quart de travail non prévue';
  missingStart = 'D\u00E9but de quart de travail manquant';
  missingEnd = 'Fin de quart de travail manquante';
  startDiff = 'D\u00E9but de quart de travail diff\u00E9rent';
  endDiff = 'Fin de quart de travail diff\u00E9rente';
  mealMissingStart = 'D\u00E9but de repas manquant';
  mealMissingEnd = 'Fin de repas manquante';
  mealNotSameLength = 'Dur\u00E9e de repas diff\u00E9rente';
  mealPunchedNotSameLength = 'Durée de repas poinçonnée différente';
  mealUnscheduledStart = 'D\u00E9but de repas non prévu';
  mealUnscheduledEnd = 'Fin de repas non prévue';
  pauseMissingStart = 'D\u00E9but de pause manquant';
  pauseMissingEnd = 'Fin de pause manquante';
  pauseNotSameLength = 'Dur\u00E9e de pause diff\u00E9rente';
  pauseUnscheduledStart = 'D\u00E9but de pause non prévu';
  pauseUnscheduledEnd = 'Fin de pause non prévue';

  ALL_ARE_SELECTED = 'Tous';
  UpdateFromWebService = 'Récupérer les informations de {{payRoll}} et mettre à jour les employés'
  ChooseTheEmployeeToUpdate = 'Choisir les employés à mettre à jour.';
  NoEmployeesCanBeUpdated = 'Aucun employé ne peut être mis à jour.';

  DayStartLocation = 'Début de quart';
  DayEndLocation = 'Fin de quart';
  Meal1StartLocation = 'Début Repas 1';
  Meal1EndLocation = 'Fin Repas 1';
  Meal2StartLocation = 'Début Repas 2';
  Meal2EndLocation = 'Fin Repas 2';
  Break1StartLocation = 'Début Pause 1';
  Break1EndLocation = 'Fin Pause 1';
  Break2StartLocation = 'Début Pause 2';
  Break2EndLocation = 'Fin Pause 2';
  UserNameAndPasswordIsRightNoRightsOnAnyUnit = 'Votre usager et mot de passe sont fonctionnels. Cependant vous n\'avez pas de droits associés à votre compte. Veuillez communiquer avec votre administrateur.';
  UserNameAndPasswordIsRightNoRightsOnAnyEnterprise = 'Votre usager et mot de passe sont fonctionnels. Cependant vous n\'avez pas d\'entreprises associées à votre compte. Veuillez communiquer avec votre administrateur.';
  CanModifyOtherAdmins = 'Peut modifier les autres admins';
  NbDistinctEmployeesWithSchedule = 'Nombre d\'employés avec au moins 1 horaire';
  ReturnToWorkOn = 'Retour au travail le ';
  MatriculeUsedToMatch = 'Matricule';
  FoundInEmprez = 'Trouvé dans Emprez';
  FoundInFolks = 'Trouvé dans Folks';

//  ImportEmployeeWithMatriculeFromAPI = 'Importer des employés par matricule';
  ImportEmployeeWithMatriculeFromAPI = 'Service Web: Vérifier si certains employés dans EMPREZ ne sont pas harmonisés avec ceux du système de paie';
  UserHasTimesheetAccess = 'Peut ajouter ses propres feuilles de temps.';
  StructureErrorJobInTooManyUnit = 'Erreur dans la structure, le poste {{job}} doit être associé à une seule unité ({{units}})';
  NoUnitFound = 'Aucune unité trouvée';
  MatchSelection = 'Harmoniser';

  SORT_ORDER_SENIORITY = 'Années de service';
  SORT_ORDER_PREDEFINED_SORT_ORDER = 'Dossier d\'employé';
  SORT_ORDER_EMPLOYE_ID = 'Numéro de matricule';
  SORT_ORDER_ALPHABETICAL = 'Ordre alphabétique';
  SORT_ORDER_DEFAULT_JOB = 'Poste par défaut';
  SORT_ORDER_SCREEN_ORDER = 'Ordre comme à l\'écran';
  SORT_ORDER_ECHELON_LEVEL='Échelon - Poste';

  WatchVideos = 'Voir les vidéos';
  RetrieveAndUpdateInfoFromPayroll = 'Récupérer les informations du système de paie pour mettre à jour les employés';
  StatusForTheMessage = 'Statuts du message';
  PayConfigurationFrom = 'La configuration de la paie provient de l\'entreprise <span style="font-weight: bolder; font-size: larger">{{configFrom}}</span>.<br>Les entreprises suivantes sont comprises dans le groupe: <span style="font-weight: lighter" class="emprez-gris-granit">{{inGroup}}</span>.';

  VacationFromForXdays = '<span class="emprez-vert-agrume">Congés à partir du {{from}} pour {{nbDays}} jour(s).</span>';
  VacationFromFor1day = '<span class="emprez-vert-agrume">Jour de congé le {{from}}.</span>';
  VacationFromFromForMinutes = '<span class="emprez-vert-agrume">Jour de congé le {{from}} pour {{duration}} (heures:minutes).</span>';
  LastModificationOnAndBy = 'Dernière modification par {{modifBy}} le {{modifOn}}';
  LastTimeSeenByEmployee = 'Affiché par l\'employé le {{lastTimeSeen}}';
  ApprovedOnAndBy = 'Approuvé par {{modifBy}} le {{modifOn}}';

  PeriodeVacance = 'Période des vacances';
  LastModification = 'Dernière modification';
  LastModificationAndApprobation = 'Dernière modification & Approbation';
  AddVacation = 'Ajouter des vacances';
  NoCurrentVacation = 'Aucune période de vacances';
  FromVacationDate = 'Premier jour le';
  ToVacationDate = 'Dernier jour le';
  VacationType = 'Type';

  EmployeeHasNoVacationPeriod = '<span class="emprez-orange-fiesta">Vous n\'avez pas encore ajouté de période de vacances.</span>';
  WarningEmployeeDaysLeft = '<span class="emprez-orange-fiesta">Attention, lorsque tous les congés suivants seront comptabilisés (approuvés pour la paie) alors le solde sera {{nbDaysLeft}} jour(s).</span>';
  EmployeeDaysLeft = '<span class="emprez-vert-agrume">Lorsque tous les congés suivants seront comptabilisés (approuvés pour la paie) alors le solde sera {{nbDaysLeft}} jour(s).</span>';

  LastConnectionOK = '<span class="emprez-vert-agrume">Dernière connexion {{dt}}, dernière ip connue: {{ip}}.</span>';
  LastConnectionWarning = '<span class="emprez-orange-fiesta">Dernière connexion {{dt}}, dernière ip connue: {{ip}}.</span>';
  LastConnectionError = '<span class="emprez-rouge-matador">Dernière connexion {{dt}}, dernière ip connue: {{ip}}.</span>';

  SelectEnterprise = 'Sélectionner une entreprise';
  SelectPayPeriod = 'Sélectionner une période de paie';
  RemoveColor = 'Supprimer la couleur';
  Select = 'Sélectionner';
  BreakPaid = 'Pause payée';
  DangerCreatingDuplicates = 'Attention: danger de créer des dossiers en double. Assurez-vous d\'harmoniser TOUT dossier existant (Voir vidéo de formation à ce sujet).';

  BreakIsPaid = 'Pause payée de {{breakDuration}}';
  BreakIsPaidAsNormal = 'Pause payée comme une pause normale de {{normalBreakDuration}}';
  BreakIsPaidFor = 'Pause payée de {{normalBreakDuration}} et non payée pour le reste de {{notPaid}}';
  BreakIsPaidButNotTaken = 'Une pause payée de {{normalBreakDuration}} n\'a pas été prise. Néanmoins {{notPaid}} sera non payé.';
  BreakIsPaidAsNormalButSomeWontBePaid = 'Pause payée comme une pause normale de {{normalBreakDuration}}. Néanmoins {{notPaid}} sera non payé.';
  BreakIsNotPaid = 'Pause de {{breakDuration}} non payée a été prise, {{notPaid}} sera non payé.';
  EmployeeStatus = 'Statut';
  RetrieveAllTerminatedAndVisible = 'Terminé(e) & Visible';
  MyEmployeeProfile = 'Mon profil employé';

  PREFS_HIDE_LATE_ARRIVAL_PANEL = 'Cacher \'Retards & Présences\' dans le tableau de bord';
  PREFS_HIDE_PLAN_VALIDATION_PANEL = 'Cacher la vérification des plans dans le tableau de bord';
  PREFS_HIDE_SCHEDULE_VALIDATION_PANEL = 'Cacher la vérification des employés dans le tableau de bord';
  PREFS_SHOW_HELP_WHEN_AVAILABLE = 'Afficher le bouton d\'aide lorsque disponible';
  PREFS_HIDE_TIMESHEET_PANEL = 'Cacher les feuilles de temps à approuver dans le tableau de bord';
  PREFS_HIDE_EXPENSE_PANEL='Cacher les dépenses à approuver dans le tableau de bord';
  PREFS_HIDE_BIRTHDAYS_VALIDATION_PANEL='Cacher les \'Fêtes\' dans le tableau de bord';
  PREFS_HIDE_SKILLS_VALIDATION_PANEL='Cacher les \'Compétences\' dans le tableau de bord';


  PREFS_SAVED_TZ = 'Fuseau Horaire par défaut';
  PREFS_USE_SCHEDULE_ALIAS = 'Utiliser les Quarts prédéfinis (Horaires)';
  ChooseTimeZone = 'Changer de fuseau horaire';

  EmployeeSkills = 'Compétences';
  nbSkills = '{{nb}} compétences';
  nbSkill = '{{nb}} compétence';
  nbActiveSkills = '<span class="emprez-vert-agrume">{{nb}} compétences actives</span>';
  nbActiveSkill = '<span class="emprez-vert-agrume">{{nb}} compétence active</span>';
  nbExpiredSkills = '<span class="emprez-orange-fiesta">{{nb}} compétences expirées</span>';
  nbExpiredSkill = '<span class="emprez-orange-fiesta">{{nb}} compétence expirée</span>';

  skillName = 'Compétence';
  expiryDate = 'Expiration';
  EmployeeSkillList = 'Compétences de l\'employé';
  skillLastUpdate = 'Mise à jour le {{on}} par {{by}}.';

  LearnHowToLinkYourEnterpriseWithAPI = 'Regardez la vidéo afin de savoir comment connecter électroniquement votre entreprise <span style="font-size: larger;">{{name}}</span> avec <span style="font-size: larger;">{{payRoll}}</span>.'

  StartMeal1Time = 'Repas 1';
  Meal1Duration = 'Durée (min)';
  StartMeal2Time = 'Repas 2';
  Meal2Duration = 'Durée (min)';
  StartBreak1Time = 'Pause 1';
  Break1Duration = 'Durée (min)';
  StartBreak2Time = 'Pause 2';
  Break2Duration = 'Durée (min)';
  OnlyOneJobMustBeDefault = '<div class="emprez-orange-fiesta">Un seul poste doit être par défaut.</div>';
  AtLeastOneJobMustBeActiveAndDefault = '<div class="emprez-orange-fiesta">Au moins un poste doit être actif et par défaut.</div>';

  CustomReports = 'Rapports Personnalisés';
  CustomReportsTab='Personnalisés';

  WebReportCode = 'Code Rapport Emprez';
  ReportClass = 'Rapport Type';
  ReportName = 'Nom du rapport';
  CustomReport = 'Rapport Personnalisé';
  ReportType = 'Type de rapport';
  ReportIsActive = 'Le rapport est actif.';
  AllActiveCustomReports = "Rapports - Personnalisés";
  CanModifyStructure = 'L\'usager peut modifier la structure.';
  CanModifyEnterprise = 'L\'usager peut modifier les entreprises.';
  CanModifyCustomReport = 'L\'usager peut modifier les rapports personnalisés.';
  CanModifyJob = 'L\'usager peut modifier les postes.';

  jobLinkedToSeveralUnit = 'Le poste {{job}} est associé à plusieurs services/départements. Veuillez limiter votre sélection des services/départements afin d\'éviter une confusion.[{{jobKey}}]';

  WarningVacationsExistWithSameStartingDate = 'Attention, vous avez déjà une banque de vacances commençant le même jour: <span style="font-size: larger; font-weight: bolder">{{dt}}</span>.';
  WarningSeveralVacationsExistWithSameStartingDate = 'Attention, vous avez plusieurs banques de vacances commençant le même jour: <span style="font-size: larger; font-weight: bolder">{{dt}}</span>.';

  Webinars = 'Webinaires';
  RegisterHere = 'S\'inscrire';
  Overnight = 'La prime s\'applique de nuit';


  MealIsPaid = 'Le repas est payé normalement.';
  MealIsPaidBut = 'Le repas est normalement payé pour {{normalDuration}}, mais il a duré {{currentDuration}}, {{shouldNotBePaid}} ne devrait pas être payé, {{willNotBePaid}} ne sera pas payé.';
  MealIsNotPaidDefaultDuration = 'Le repas utilise la durée par défaut, {{shouldNotBePaid}} ne devrait pas être payé, {{willNotBePaid}} ne sera pas payé.';
  MealIsNotPaidPunchDuration = 'Le repas utilise la durée poinçonnée, {{shouldNotBePaid}} ne devrait pas être payé, {{willNotBePaid}} ne sera pas payé.';
  MealIsPaidWithMax = 'Le repas est payé pour une durée max de {{max}}';
  MealIsPaidButNotSome = 'Le repas est payé mais {{willNotBePaid}} ne sera pas payé.';

  ExportPayToPDF = 'Exporter en PDF';
  ExportPayToExcel = 'Exporter en Excel';
  ExportPayToXML = 'Exporter en XML';
  ExportPayToCSV = 'Exporter en CSV';
  ExportPayToJSON = 'Exporter en JSon';
  ExportPayStandard = 'Exporter dans le format normal.';
  ExportPayStandardThenSend = 'Exporter dans le format normal puis envoyer électroniquement';

  TemplateWeek = 'Semaine des gabarits';
  CreatedDt = 'Création';
  Activate = 'Activer';
  Deactivate = 'Désactiver';
  JobActive = 'Actif?';
  Defaultjob = 'Défaut';
  EmployeeWithThisJobList = 'Employés avec le poste et l\'unité sélectionnés';
  EmployeesPaidBy = 'Employés + Postes payés par {{name}}';
  EmployeePaidByThisEnterprise = 'Employés';
  RemoveExternalID = 'Supprimer \'External ID\'';
  EmployeesAvailableToPunchToday = 'Employés qui peuvent poinçonner aujourd\'ui.';
  WillTakePicture = 'Prise de photo?';
  CreateNewUser = 'Créer un nouvel usager'
  AddAnyHiringType = 'Faire Shift+Click pour pouvoir choisir parmi tous les types de statut';
  'Not.Enough.VacationsLeft' = 'Il ne reste pas assez de vacances dans la banque.';
  UseNbOfDaysInBankToCalculateAllowance = 'Calcul à partir de la banque d\'heures';
  AddJobInBatch = 'Ajouter des postes aux employés';
  AddHourlyBonusInBatch = 'Ajouter des primes horaires aux employés';
  AddModifyJobAndHourlyBonusInBatch = 'Ajouter ou modifier des postes et des primes horaires aux employés';
  JobDefault = 'Le poste sera le poste par défaut';
  DoYouReallyWantToDeleteTheGroup = 'Voulez-vous vraiment supprimer ce groupe? ';
  DoYouReallyWantToDeleteThisEmployeeJob = 'Voulez-vous vraiment supprimer le poste de cet employé?';
  DeleteEmployeeJob = 'Supprimer';
  FormatTaskToDisplayInDailyReport = 'En cliquant sur ce bouton, un masque de saisie vous permettra de spécifier un horaire pour vos tâches. Très utile pour le rapport quotidien.';
  CompanyNumber = 'Entreprise #';
  EmployeeId = 'Id Externe'
  HireDate = 'Embauche';
  DepartureDate = 'Départ';
  Edit = 'Modifier';
  SomeModificationsHaveBeenDoneDoYouWantToContinueWithoutSavingFirst = 'Attention! Des modifications n\'ont pas encore été enregistrées et seront perdues, voulez-vous néanmoins continuer?';
  UnionRelated = 'Syndicat';
  OtherType = 'Autre';
  elements = '{{nb}} élément(s)';
  SchedulesAndTimeSheets = '{{nbSch}} horaires et {{nbTs}} feuilles de temps';
  EmployeeHasNoOtherActiveJob = 'Aucun autre poste actif.';
  ApplyToAllEmployee = 'Appliquer à tous les employés';
  SelectEmployee = 'Sélectionner';
  BeCarefulThePayingEnterpriseWontExportTimeBank = 'Attention l\'entreprise de paie <span style="font-size: x-large">{{name}}</span> n\'est pas configurée pour exporter les banques de temps dans la paie.<br>Toutes les heures mises en banque seront exportées comme des heures régulières.';
  Rights = 'Droits Associés';
  PunchConfiguration = 'Configuration de l\'horodateur';
  LoadAllEmployeeWorkingInUnit = 'Charger tous les employés de l\'unité';
  LoadAllEmployeeWithTheJobs = 'Charger tous les employés avec les postes';
  ChooseJobsIfNecessary = 'Choix de postes';
  SchedulesPerEmployeeTitle = 'Horaires par employé';
  SchedulesPerEmployeeTitleSideBySide = 'Horaires par employé';
  SchedulesPerPlan = 'Horaires par plan';
  SchedulesPerJobs = 'Horaires / Structure';
  SchedulesPerJobsTitle = 'Horaires par structure';
  SchedulesForOneJob='Horaires / Poste';

  SchedulesPerJobTitle = 'Horaires par poste';
  SchedulesPerPlanTitle = 'Horaires par planification';
  CurrentEtagSession = 'Ma Session!';
  CreatedDate = 'Date création';
  LastAccess = 'Dernier accès';
  MaxInactive = 'Inactivité max.';
  DisplaySchedulesInfo = 'Afficher les informations supplémentaires des horaires.';
  SpifTypeTitle = 'Type de Bonus';
  AddSpifTitle = 'Ajouter un Bonus';
  SpifType = 'Type de Bonus';
  SpifDate = 'Date du Bonus';
  AddOtherTypes = 'Ajouter d\'autres types'
  AddSpif = 'Ajouter un bonus';
  SpifLabel = 'Nom du Bonus';
  PayRollCode = 'Code de Paie';
  By = 'Par {{modifBy}} le {{modifOn}}'
  NoSpifForThisPeriod = 'Aucun Bonus pour la période';
  NoSpifTypeYet = 'Aucun Type de Bonus.';
  EmployeeSpifs = 'Bonus';
  ApplyTimesheetParams = 'Appliquer les paramètres \'Feuille de temps\' à tous les employés.';
  DoYouReallyWantToApplyTSParamsToEmployeePaidBy = 'Voulez-vous vraiment appliquer les paramètres à tous les employés payés par {{name}}?';
  DoYouReallyWantToRemoveAllAccessToThisUnit  = 'Voulez-vous vraiment supprimer tous les accès à cette unité?';
  RemoveAllEmployeeAccessToUnit='Supprimer tous les accès à cette unité.';
  RemoveAllEmployeeAccessToDivision='Supprimer tous les accès à cette division et ses sous-unités.';
  CarefulDefaultBonusHaveBeenAddedYouShoudlSaveIfYouDontWantToLoseYourChanges = 'Des primes par défaut ont été sélectionnées, vous devriez enregistrer pour ne pas perdre vos informations.';
  AddCumulativeBonusInBatch = 'Ajouter des primes cumulatives';
  SelectTheCumulativeBonusToApplyToTheSelectedListBelow = 'Sélectionnez les primes cumulatives à ajouter';
  SearchAgain = 'Nouvelle recherche';

  CanReceiveMemo = 'Peut recevoir les messages.';
  CanReceiveVacationRequest = 'Peut recevoir les demandes de vacances.';
  CanReceiveAvailabilitiesRequest = 'Peut recevoir les demandes de dispo.';
  CanReceiveWorkshiftExchangeRequest = 'Peut recevoir les échanges de quart.';
  CanReceiveInitialWorkshiftExchange= 'Peut recevoir les demandes initiales d\'échanges de quart.';

  CanReceiveFamilyDaysRequest='Peut recevoir les demandes de journées familiales.';

  SendNotification = 'Envoyer une notification';
  NotificationExplain = 'Une notification sera envoyée par courriel ou directement dans l\'application mobile en fonction des choix de l\'utilisateur. Une notification sur le mobile ignorera le corps du message.<br><b>Emprez ne peut garantir la livraison du message.</b>';
  Notify='Envoyer';
  NotificationTitle = 'Sujet (Utilisé par les courriels ET l\'application mobile)';
  NotificationBody = 'Corps du message (ignoré par l\'application mobile)';

  NotificationCenterFor = 'Paramètres des notifications pour {{name}}';
  DeviceAssociatedWithTheEmployee = 'Appareils mobiles liés avec l\'employé';
  AllowsNotification = 'Peut-être notifié';
  DeviceType = 'Type';
  DeviceInfo = 'Information de l\'appareil';
  DEVICE_TYPE_IOS = 'iOS';
  DEVICE_TYPE_ANDROID = 'Android';
  DEVICE_TYPE_GENERIC = 'P. of S.';

  NotificationDataSentToTheEmployee = 'Notifications envoyées à l\'employé pendant la période suivante:';
  fromDt = 'Depuis';
  toDt = 'À';
  CommunicationType = 'Type';
  SentDt = 'Envoi';
  Email = 'Courriel';
  Phone = 'Tél.';
  ExternalSystemId = 'Ext. Id.';
  ExternalSystemResp = 'Resp. Ext.';

  NOTIFICATION_STATUS_AWAITING_DISTRIBUTION = 'Attente Dist.';
  NOTIFICATION_STATUS_DISTRIBUTED = 'Distribué';
  NOTIFICATION_STATUS_ACCEPTED = 'Accepté';
  NOTIFICATION_STATUS_QUEUED = 'En attente';
  NOTIFICATION_STATUS_SENDING = 'Envoi en cours';
  NOTIFICATION_STATUS_SENT = 'Envoyé';
  NOTIFICATION_STATUS_RECEIVING = 'En reception';
  NOTIFICATION_STATUS_RECEIVED = 'Reçu';
  NOTIFICATION_STATUS_DELIVERED = 'Livré';
  NOTIFICATION_STATUS_UNDELIVERED = 'Non livré';
  NOTIFICATION_STATUS_FAILED = 'Echec';

  COMMUNICATION_TYPE_EMAIL = 'Courriel';
  COMMUNICATION_TYPE_PHONE = 'Tél.';
  COMMUNICATION_TYPE_DEVICE_NOTIFICATION = 'Notif. App.';
  COMMUNICATION_DEVICE_NOTIFICATION = 'Notif. App.';

  AddPunch = 'Ajouter un poinçon pour des tests';
  ShowBoss = 'Afficher la liste des supérieurs hierarchiques';
  ManageCustomReports = 'Gestion des rapports personalisés';
  AddTimeInBank = 'Ajuster la banque de temps';
  ConnectToEmprez = 'Se connecter à Emprez';
  ManageEmployeeRights = 'Gestion des droits';
  ConnectInEmployeePortal = 'Se connecter au portail de l\'employé';
  EmployeeNotificationCenter = 'Gestion des notifications';
  ExplainHolidayCalculation = 'Explication du calcul des fériés';
  HolidayCalculation = 'Calcul des fériés';

  NbMinutesForHolidayOn = 'Le calcul de la journée fériée du {{dt}} donne {{min}} minutes soit <b>{{nb}}</b>.';
  DisplayEmployeeThatCanPunch = 'Employés pouvant utiliser cet horodateur';
  ManageRights = 'Gestion des droits';

  ApplyScheduleParams = 'Appliquer les paramètres \'Horaire\' (sauf Dossier Employé) à tous les employés.';
  DoYouReallyWantToApplyScheduleParamsToEmployeePaidBy = 'Voulez-vous vraiment appliquer les paramètres à tous les employés payés par {{name}}?';
  ApplyToAllEmployees = 'Appliquer à tous les employés';
  DoYouReallyWantToApplyPortalParamsToEmployeePaidBy = 'Voulez-vous vraiment appliquer les paramètres à tous les employés payés par {{name}}?';
  DoYouReallyWantToApplyPunchParamsToEmployeePaidBy = 'Voulez-vous vraiment appliquer les paramètres à tous les employés payés par {{name}}?';
  EnterpriseWithPayAnticipation = 'Entreprises ayant l\'anticipation de la paie';
  MoveJobFrom = '<span class="emprez-jaune-soleil">Déplacement du poste \'{{job}}\' depuis l\'unité \'{{unit}}\'</span>';
  UnitToMoveTo = 'Unité cible';

  ExportStructure = 'Exporter la structure';
  DisplayNbDistinctSchedules = 'Afficher le nombre distincts d\'employés avec au moins un horaire.';
  AddRightsToMultipleUnits = 'Ajouter des droits aux sous-unités';
  ShowEmployeeWithJob = 'Afficher les employés avec le poste';
  MoveJobToAnotherUnit = 'Déplacer le poste vers une autre unité';
  MoveJob = 'Déplacer un poste';
  Move = 'Déplacer';

  EditNamedWorkShift = 'Modification d\'un quart prédéfini';
  NamedWorkShiftName = 'Nom du quart prédéfini';
  NamedWorkshiftIsActive = 'Le quart prédéfini est actif';
  NamedWorkShiftType = 'Type';
  NamedWorkShiftNotes = 'Notes';
  NamedWorkShiftCreatedBy = 'Auteur';
  NamedWorkShiftHours = 'Horaire';
  NoUserFoundOtherThanYourself = 'Aucun autre utilisateur';
  ScheduleNote = 'Note sur l\'horaire';
  AliasManager = 'Gestionnaire des quarts prédéfinis';
  ScheduleAlias = 'Quart prédéfini';
  UsersWithAccessToAlias = 'Usagers pouvant utiliser ce quart prédéfini';
  DisplayUserPreferences = 'Préférences de l\'usager';
  UnitCode = 'Code de l\'unité';
  UnitType = 'Type d\'unité';
  RemoveRightOnUnit = 'Supprimer l\'accès';
  PrefName = 'Nom';
  PrefType = 'Type';
  PrefValue = 'Valeur';

  EstablishmentStructureCreation = 'Étape 1: Création de la structure';
  YourStructureHasBeenCreatedNowProceedWithOtherSteps = 'Votre structure a été créée, vous pouvez maintenant continuer avec l\'étape suivante.';
  EstablishmentEmployeeCreation = 'Étape 2: Ajouter des employés';
  AddEmployeeToYourStructure = 'Vous pouvez maintenant ajouter des employés dans votre structure. <a class="naked" target="_blank" href="https://emprez.zohodesk.com/portal/fr/kb/articles/recherche-et-cr%C3%A9ation-de-dossier-d-employ%C3%A9">Comment créer des employés ?</a>';
  YouHaveAddedEmployeesNowProceedWithOtherSteps = 'Vous avez ajouté des employés, vous pouvez maintenant continuer avec l\'étape suivante.'
  GoToCreateEmployeePage = 'Ajouter des employés';
  EstablishmentScheduleCreation = 'Étape 3: Faire les horaires';
  AddSchedulesToYourEmployees = 'Vous pouvez maintenant faire les horaires de vos employés. <a class="naked" target="_blank" href="https://emprez.zohodesk.com/portal/fr/kb/articles/ajout-modification-d-un-quart-de-travail#Crer_un_quart_de_travail">Comment faire les horaires ?</a>'
  GoToCreateScheduleByEmployee = 'Faire les horaires par employé';
  GoToCreateScheduleByJob = 'Faire les horaires par poste';
  YouHaveCreatedSchedulesNowProceedWithOtherSteps = 'Vous avez ajouté des horaires à vos employés, vous pouvez continuer avec l\'étape suivante et approuver les feuilles de temps';
  EstablishmentTimesheetCreation = 'Étape 4: Approuver les feuilles de temps';
  ApproveTimesheetForYourEmployees = 'Après avoir fait les horaires de vous employés, vous pouvez approuver les feuilles de temps. <a class="naked" target="_blank" href="https://emprez.zohodesk.com/portal/fr/kb/articles/feuille-de-temps-approuv%C3%A9es">Comment approuver les feuilles de temps ?</a>'
  YouHaveApprovedSomeTimesheetsNowProceedWithOtherSteps = 'Vous avez approuvé des feuilles de temps, vous pouvez continuer avec l\'étape suivante.';
  GoToTimesheetCreation = 'Approuver des feuilles de temps';
  EstablishmentPayRoll = 'Étape 5: Exporter vers la Paie';
  GoToPayRoll = 'Exporter vers la Paie';
  YouAreNowReadyToExportToPayRoll = 'Toutes les étapes sont franchies, vous pouvez maintenant exporter vers la Paie.';
  HideTheGuide = 'Bravo, vous pouvez maintenant utiliser Emprez.';
  AlwaysPayMeals = 'Toujours payer les repas';
  NeverPayMeals = 'Ne jamais payer les repas';
  MealsAreNeverPaid = 'Les repas ne sont jamais payés';
  MealsAreAlwaysPaid = 'Les repas sont toujours payés';
  ExplainEmployeeTimesheetParams = '<span style="font-weight: bold;">Gestion des règles d’affaires de l’entreprise</span><br><br>Établissez ici les règles d’affaires quant aux arrivées, départs, repas, et pauses pour cet(te) employé(e) en particulier.<br>Vous pourrez ensuite, si vous le souhaitez, appliquer ces paramètres à tous vos employés, en cliquant sur le lien “Appliquer les paramètres ‘Feuille de temps’ à tous les employés” au bas de cette page.<a target="_blank" href="https://desk.zoho.com/portal/emprez/kb/articles/comprendre-les-ajustements-automatiques">Plus d\'information ici.</a>';

  EnterpriseId = 'Identifiant Unique';
  DumpRawInfo = 'Information Service Web';
  AddAccessToUser = 'Ajouter l\'accès à cette entreprise à des utilisateurs';
  ZohoId = 'CRM Id';
  AllowPayStubs = 'Importation des talons de paie';
  Country = 'Pays';
  State = 'Province';
  TypePeriod = 'Type de paie';
  Period = 'Période de paie';
  DisplayImplementationCursus = 'Afficher le cursus d\'implantation.';
  AddSpifTypeTitle = 'Ajouter un type de bonus';

  TimedTasksManager = 'Gestionnaire de projets';
  TimedTaskGroupDescription = 'Nom';
  TimedTaskGroupCreatedBy = 'Auteur';
  TimedTaskGroupNbTasks = 'Nombre de tâches';
  TimedTaskGroupTitle = 'Modifier un Projet';
  TimedTaskGroupIsActive = 'Le projet est actif';
  UsersWithAccessToTaskGroup = 'Utilisateurs ayant accès au projet'
  TasksInTaskGroup = 'Tâches associées au projet';
  NoTimedTaskFound = 'Aucune tâche associée.';
  TimedTaskTitle = 'Modifier une tâche';
  TimedTaskDescription = 'Nom';
  TimedTaskExternalCode = 'Code externe';
  ExternalCode = 'Code externe';
  TimedTaskScheduledDuration = 'Durée estimée par défaut (Min)';

  AssociatedWithScheduleOf = 'Tâche associée avec l\'horaire de {{start}} à {{end}}.';
  NoScheduleAssociated = 'Tâche non associée avec un horaire';
  EmployeeTimedTasks = 'Tâches associées';
  NoTimedTaskForThisEmployee = 'Aucune tâche associée.';
  Project = 'Projet';
  Task = 'Tâche';
  Scheduled = 'Horaire';
  AddProject = 'Ajouter une tâche d\'un projet.';
  DoYouReallyWantToDeleteTheEmployeeTimedTaskParams = 'Voulez-vous vraiment supprimer cette tâche associée ?';
  NoDateAssociated_Always = 'Toujours';
  AddTaskToEmployee = 'Tâche de l\'employé';
  TimedTasks = 'Association avec un Projet';
  TimedTaskGroup = 'Projets';
  AddTimedTaskGroup = 'Ajouter un projet';
  DoYouReallyWantToDeleteTheTimedTaskGroup = 'Voulez-vous vraiment supprimer le projet \'{{name}}\'? ';
  SomeTasksHaveBeenDone = '( {{nb}} tâches ont déjà été effectuées. )';
  BackToProjectList = 'Retour aux Projets';
  TaskDescription = 'Tâche';
  RefDate = 'Dates';
  StartStopDates = 'Début - Fin';
  chartsForTaskFromProject = 'Distribution des tâches pour le projet {{projectDescription}}';
  BackToProject = 'Retour au Projet';
  NoBossProbablyNoActiveJob = 'Aucun manager. Vérifier que l\'employé a au moins un poste actif.';
  DoYouReallyWantToDeleteTheEmployee = 'Voulez-vous détruire l\'employé {{fullName}}, son profil, ainsi que tous ses horaires / feuilles de temps ?';
  DoYouReallyWantToDeleteThePunch='Voulez-vous détruire l\'horodateur {{fullName}} avec le deviceId {{deviceId}} ?';
  DoYouReallyWantToDeleteTheEnterprise='Voulez-vous détruire l\'entreprise {{fullName}} ?';

  EmployeeWithNoJob = 'Employés sans poste.';
  EmployeeWithNoActiveJob = 'Employés sans poste actif.';
  TotalDestruction = 'Destruction totale de l\'employé.';
  AddJob = 'Ajouter un poste';

  HourlyBonus1 = 'Prime horaire 1';
  HourlyBonus2 = 'Prime horaire 2';
  HourlyBonus3 = 'Prime horaire 3';
  HourlyBonus4 = 'Prime horaire 4';
  HourlyBonus5 = 'Prime horaire 5';
  HourlyBonus6 = 'Prime horaire 6';
  HourlyBonus7 = 'Prime horaire 7';
  HourlyBonus8 = 'Prime horaire 8';
  HourlyBonus9 = 'Prime horaire 9';
  HourlyBonus10 = 'Prime horaire 10';
  HourlyBonus11 = 'Prime horaire 11';
  HourlyBonus12 = 'Prime horaire 12';
  HourlyBonus13 = 'Prime horaire 13';
  HourlyBonus14 = 'Prime horaire 14';
  HourlyBonus15 = 'Prime horaire 15';
  HourlyBonus16 = 'Prime horaire 16';
  HourlyBonus17 = 'Prime horaire 17';
  HourlyBonus18 = 'Prime horaire 18';
  HourlyBonus19 = 'Prime horaire 19';
  HourlyBonus20 = 'Prime horaire 20';


  CumulativeBonus1 = 'Prime cumulative 1';
  CumulativeBonus2 = 'Prime cumulative 2';
  CumulativeBonus3 = 'Prime cumulative 3';
  CumulativeBonus4 = 'Prime cumulative 4';
  CumulativeBonus5 = 'Prime cumulative 5';
  CumulativeBonus6 = 'Prime cumulative 6';
  CumulativeBonus7 = 'Prime cumulative 7';
  CumulativeBonus8 = 'Prime cumulative 8';
  CumulativeBonus9 = 'Prime cumulative 9';
  CumulativeBonus10 = 'Prime cumulative 10';
  CumulativeBonus11 = 'Prime cumulative 11';
  CumulativeBonus12 = 'Prime cumulative 12';
  CumulativeBonus13 = 'Prime cumulative 13';
  CumulativeBonus14 = 'Prime cumulative 14';
  CumulativeBonus15 = 'Prime cumulative 15';
  CumulativeBonus16 = 'Prime cumulative 16';
  CumulativeBonus17 = 'Prime cumulative 17';
  CumulativeBonus18 = 'Prime cumulative 18';
  CumulativeBonus19 = 'Prime cumulative 19';
  CumulativeBonus20 = 'Prime cumulative 20';
  HourlyBonuses = "Primes horaires";
  CumulativeBonuses="Primes cumulatives";
  HourlyBonusesMore = "Primes horaires+";
  CumulativeBonusesMore="Primes cumulatives+";


  AllBanksInformation = 'Information sur les banques disponibles';
  RetrieveBanks = 'Récupérer les banques';
  DisplayAllBanks = 'Information sur les banques disponibles dans le système de paie.';
  NoInformationAboutBanks = 'Aucune information sur les banques';
  StartTask = 'Début de Tâche';
  EndTask = 'Fin de Tâche';
  BackToEmployee = 'Retour';
  MinuteApproved = '<div class="muted" style="display: inline">{{approved}} approuvées.</div>';
  WhatTimeSheetsWillBeConsidered = '<span>Type des feuilles de temps à utiliser pour les calculs</span>';
  PasswordChangeTitle = 'Changement du mot de passe';
  PasswordShouldBeChanged = 'Le mot de passe est expiré et a besoin d\'être changé.';
  CurrentPassword = 'Mot de passe courant';
  NewPassword = 'Nouveau mot de passe';
  RepeatNewPassword = 'Répétez le nouveau mot de passe';
  PasswordStrength = 'Sécurité du mot de passe';
  ExpirationPasswordEveryDays = 'Expiration tous les';
  PasswordWontExpire = 'Pas d\'expiration du mot de passe';
  passwordExpiredOn = 'expire le {{dt}}.';

  NoSecretNeedsToGenerateOne = 'Cliquez ici pour générer une double authentification ( i.e. \'Two-Factor\')';
  LinkToQRCodeForGoogleAuthenticator = 'Cliquez ici pour voir le code à insérer dans Google Authenticator';
  ActivateTwoFactorAuthentication = 'Activer la double authentification.';
  GenerateNewSecret = 'Re-Générer';
  TwoFactorAuthentication = 'Double authentification';
  Authentication = 'Votre Jeton Virtuel';
  AuthenticateYourSelf = 'Deuxième Authentification';
  ChooseUnitContainingNewJob = 'Choisissez une unité';
  CreateNewJob = 'Créer un nouveau poste';
  EditTwoFactor = 'Gestion Double Authentification';
  EditModules = 'Gestion Modules';
  ModuleUserList = 'Liste des modules';
  ModuleExpiryDate = 'Expire le';
  ModuleType = 'Type de Module';
  ModuleUserEdit = 'Module';
  ModuleIsActive = 'Le module est actif';
  MODULE_TYPE_SCHEDULE_MODULE = 'Horaire';
  MODULE_TYPE_TIMESHEET_MODULE = 'Feuille de Temps';
  MODULE_TYPE_PAY_MODULE = 'Paie';
  MODULE_TYPE_PERFORMANCE_MODULE = 'Emprez BI';
  MODULE_TYPE_EXPENSE_MODULE = 'Dépenses';
  MODULE_TYPE_HR_MODULE='Ressources Humaines';
  NoExpiration = 'Aucune Exp.';
  CarefulNotAProVersion = 'Pas la version Pro d\'Emprez!';
  AccessToSchedule = 'Accès au Module d\'Horaires';
  AccessToTimesheet = 'Accès au Module de Feuille de temps';
  AccessToPay = 'Accès au Module de Paie';
  AllEmployees = 'Tous les employés';

  TemplatesAll = 'Présentation Actuelle';
  TemplatesAllClassic = 'Nouvelle Présentation';
  LastSearchResult = 'Résultats de la recherche';
  SearchForEmployees = 'Rechercher';
  CreateOrImportAnEmployee = 'Créer / Importer un employé';
  PunchParameters = 'Paramètres Poinçons';
  WarningWillOverrideParametersOfAllEmployees = 'Les informations appliquées, remplaceront les informations de chaque employé.';
  MobileAndPortalAccesForEmployees = 'Accès mobiles et portail des employés';

  SchedulesParametersAndMore = 'Horaires: Configuration des options des employés '
  TimesheetsParametersAndMore = 'Feuilles de Temps: Arrondis, Temps de grâce, Calcul des Fériés';
  DownloadCurrentStructureInXLS = 'Exporter la structure en Excel';
  StructureAndJobs = 'Structures & Postes';
  JobManagement = 'Gérer les postes dans la structure';
  ManageUserAccessToUnits = 'Gérer les accès des usagers';
  Units = 'Unités';
  ChooseAUnit = 'Choisissez une unité';
  CurrentPayPresentation = 'Général';
  UpdateFromPayRoll = 'Récupérer les informations de la paie et mettre à jour les employés';
  Parameters = 'Paramètres';
  CopyTemplate = 'Copie de gabarit';
  NoticeCopyTemplates = 'Attention, vous allez copier (et ajouter!) les horaires d\'un gabarit à l\'autre.';
  FromTemplate = 'Copier depuis le gabarit';
  ToTemplate = 'Vers le gabarit';
  DoYouReallyWantToDeleteTheTemplate = 'Voulez-vous vraiment détruire tous les horaires visibles à l\'écran ?';
  ApprovingTimesheets = 'Approbation des feuilles de temps';
  ApprovingExpenses = 'Approbation des dépenses';
  EmployeesFile = 'Dossier des Employés';
  TemplatesManager = 'Gestion des gabarits';
  AddSpifInBatch = 'Ajouter des bonus en lot';
  SpifValue = 'Bonus';
  ShowSideBar = 'Afficher la barre de sélection';
  HideSideBar = 'Cacher la barre de sélection';

  ConfigureCCQConfigurationForEmployee = 'Modifier les informations CCQ';
  CreateOrActivateCCQConfigurationForEmployee = 'Ajouter ou activer les informations CCQ';
  ConfigurationCCQActive = 'Les informations CCQ seront utilisées dans l\'export vers la paie.';
  CCQWorkedHourCodeForPayRoll = 'Code Export des Heures travaillées';
  EnterpriseGroup = 'Groupe d\'entreprises';
  TooManyEnterpriseSelected = 'Sélection trop importante';
  MaximumSelectionOfEnterpriseIs = 'Pour des raisons de performance, vous ne pouvez pas sélectionner plus de {{max}} entreprises';

  ExportPaySummaryInSingleFile = 'Générer un seul fichier avec la sélection';
  ExportPaySummaryFilePerEnterprise = 'Générer un fichier par entreprise';
  SaveAndApplyToAllEmployeeShort = 'Enregistrer & Appliquer';
  SaveAndApplyToAllEmployee = 'Enregistrer & Appliquer à tous les employés';
  FailedAuthentications = 'Erreurs authentifications';
  FailedAuthenticationOlderThan = 'Erreurs d\'authentification depuis le';
  NoFailedAuthentication = 'Aucune erreur d\'authentification';
  FAILED_AUTHENTICATION_TYPE_WRONG_USER = 'Mauvais utilisateur';
  FAILED_AUTHENTICATION_TYPE_WRONG_PWD = 'Mauvais mot de passe';
  FAILED_AUTHENTICATION_TYPE_WRONG_DOUBLE_AUTHENTICATION = 'Mauvaise Double authentification';

  FAILED_AUTHENTICATION_TYPE_INACTIVE_USER = 'Usager désactivé';
  FAILED_AUTHENTICATION_TYPE_USER_HAS_NO_ENTITY='Pas d\'entité'
  FAILED_AUTHENTICATION_TYPE_PASSWORD_EXPIRED  = 'Mot de passe expiré';
  FAILED_AUTHENTICATION_TYPE_WRONG_ROLE  = 'Mauvais rôle';
  FAILED_AUTHENTICATION_TYPE_USER_TERMINATED  = 'Terminé';
  FAILED_AUTHENTICATION_TYPE_USER_ENTERPRISE_INACTIVE  = 'Enterprise est désactivée';
  FAILED_AUTHENTICATION_TYPE_USER_HAS_NO_PAY_PARAMETERS  = 'Pas de paramètres de paie';
  FAILED_AUTHENTICATION_TYPE_USER_HAS_NO_ENTERPRISES  = 'Aucun accès aux entreprises';
  FAILED_AUTHENTICATION_TYPE_USER_HAS_NO_UNIT  = 'Aucun accès aux unités';



  EventDate = 'Date de l\'évènement';
  RemoteInfo = 'Provenance';
  UserAgent = 'Navigateur'
  DeleteExpired = 'Supprimer';
  DeleteExpiredTooltip = 'Supprimer les sessions expirées';

  SecurityPerEnterpriseTitle = 'Paramètres de sécurité par défaut pour les nouveaux employés';
  PasswordWillExpire = 'Le mot de passe expire';
  PasswordExpirationInDays = 'Délai d\'expiration du mot de passe en jours';
  FailedLoginDeactivateAccount = 'Trop d\'échecs de connexion bloquera l\'usager.';
  NbMaxOfFailedLogin = 'Nombre maximum d\'échecs de connexion';
  MinSizePwd = 'Taille min. du mot de passe';
  MinNbUpperCase = 'Nombre min. de majuscules';
  MinNbLowerCase = 'Nombre min. de minuscules';
  MinSpecialChar = 'Nombre min. de caractères spéciaux';
  MinNumberDigit = 'Nombre min. de chiffres';
  SecurityPerUser = 'Paramètres de sécurité';
  PasswordWillExpireAfter = 'Le mot de passe expire après {{passwordExpirationInDays}} jours.<br>';
  PasswordWillNotExpire = 'Le mot de passe n\'expire pas.<br>';
  AccountWillBeDeactivated = 'Le compte sera désactivé après {{nbMaxOfFailedLogin}} échecs.<br>';
  NoLimitForFailedLogin = 'Aucune limite d\'échecs de connexion.<br>';
  PasswordRules = 'Le mot de passe doit avoir une longueur minimale de {{minSizePwd}} caractères.<br>Il doit contenir au minimum {{minNbUpperCase}} majuscule(s) , {{minNbLowerCase}} minuscule(s), {{minSpecialChar}} caractére(s) spécial(aux) et {{minNumberDigit}} chiffre(s).';
  PasswordRulesLen = 'Le mot de passe doit avoir une longueur minimale de {{minSizePwd}} caractères.';
  NoPasswordRules = 'Aucune règle spéciale pour la définition du mot de passe.';
  EditSecurityForUser = 'Modifier les règles de sécurité';
  PasswordValidationNoPassword = 'Aucun mot de passe';
  PasswordValidationMinLen = 'Longueur min. {{minLen}}';
  PasswordValidationMinUpper = 'Il manque {{need}} majuscule(s)';
  PasswordValidationMinLower = 'Il manque {{need}} minuscule(s)';
  PasswordValidationMinNumberDigit = 'Il manque {{need}} chiffre(s)';
  PasswordValidationMinSpecialChar = 'Il manque {{need}} caractère(s) spécial(aux)';
  ReactivateAccount = 'Réactiver le compte';
  PrintingSortOrder = 'Tri (Impression)';
  RetrieveAllAccessibleEmployees = 'Tous les employés';
  ApproveScheduledTime = 'Approuver l\'horaire prévu.';
  DoYouReallyWantToDeleteTheNamedWorkShift = 'Voulez-vous vraiment supprimer ce quart prédéfini?';
  NoteOnAddOrModifyJobAndHourlyBonusesBatch = 'Le poste de l\'employé aura exactement les primes sélectionnées et sera activé s\'il était inactif.';
  GoToDivision = 'Voir la division';
  PaidFamilyLeaveType = 'Méthode de calcul';
  Calculate = 'Calculer';
  ExplainMinutesToPayForFamily = '{{minutes}} min. devraient être payées.';
  EmployeeIsTerminated = 'Employé est terminé.';
  SearchEmployeePlaceHolderClient = 'Par <Nom, Prénom>, par < , Prénom>, par #<Matricule> ou par !<Badge>';
  TemporaryInternetConnectionError = 'Problème temporaire de connexion.';
  ParamsProfileManager = 'Gestionnaire des profils de paramètres employés';

  ParamsProfileDescription = 'Description';
  ParamsProfileCreatedBy = 'Créé par';
  AddParamsProfile = 'Ajouter un profil de paramètres';
  EmpoyeeParamsForPunchPortalAndMobile = 'Paramètres pour l\'horodateur, le portail web et l\'application mobile';
  ParamsProfileAggregation = 'Profil de paramètres (Si aucune sélection, vos paramètres par défaut seront utilisés.)';
  ParamsProfileIsActive = 'Le profil est actif';
  UsersWithAccessToThisParamsProfile = 'Utilisateurs ayant accès à ce profil';
  ParametersForPunch = 'Paramètres pour l\'horodateur';
  InformationAvailableOnPortalAndMobile = 'Informations disponibles sur le portail web et l\'application mobile';
  EmployeeJobAndBonusAndEnterprise = 'Poste, Primes et Entreprise de paie';
  ShowPayStubsOnPortal = 'Affichage des talons de paie (si disponible)';
  AddParamsProfileAggregation = 'Ajouter un profil';
  YourDefaultParameters = 'Vos paramètres par défaut';
  ParamsProfileInformation = 'Un profil de paramètres permet de <u><b>copier</b></u> rapidement un ensemble de configurations afin d\'<b>accélérer</b> la création d\'employés, <i>spécialement si vous embauchez beaucoup de nouveau personnel</i>.'

  ChangeUsernameOrBadgeTitle = 'Changement pour ';
  ChangeUsernameOrBadge = 'Changement d\'usager ou de badge';
  NewBadgeNumber = 'Nouveau Badge';
  ChangeBadgeNumber = 'Enregistrer';
  NewUsername = 'Nouveau nom d\'usager';
  ChangeUserName = 'Enregistrer'

  SELECT_CUSTOM_CODE = 'Multi-choix';
  TIMEZONE = 'Fuseau Horaire';
  BOOLEAN = 'Booléen';
  INTEGER = 'Nombre entier';
  HOUR = 'Heures:Minutes';
  CreateUDataExportFileForEmployee = 'Exporter fichier pour RPA360';
  SendUDataExportFileForEmployee = 'Envoyer vers RPA360';
  NbDistinctEmployeesWithApprovedTimesheets = 'Nb d\'employés avec au moins 1 FDT approuvée';


  UDataUserCredentials = 'Usager - Connexion RPA360';
  UDataPwdCredentials = 'Mot de passe - Connexion RPA360';
  UDataAdministrativeUnit = 'Unité administrative';
  UDataUserInCharge = 'Usager en charge du processus';
  SendEmployeeToUData = 'Envoyer les informations des employés vers RPA360';
  ChooseTheEmployeeToSendToUData = 'Choisir les employés dont les informations seront envoyées';
  SendToUData = 'Envoyer';
  VerifyEmployeeInformation = 'Vérification des employés';
  LaunchVerificationOfEmployeesInformation = 'Démarrer la vérification';
  DetectedIssue = 'Description d\'un problème potentiel';
  ExplainVerifyEmployee = 'La vérification est faite sur les dossiers des employés actifs et visibles pour la période du {{start}} au {{end}}.';
  NoIssuesFound = 'Aucun problème détecté.';
  PaidBy = 'Payé par';
  ContactUs = 'Contactez-nous';
  DesjardinsContactUsButtonLabel = 'Contactez-Nous';

  DesjardinsContactUsButtonContent = '<p>Ligne support Modules GT :  1-800-361-1324 #1 #5 #2<br>Ligne support Horodateur :  1-800-361-1324 #1 #5 #6<p>';
  DesjardinsLoginSubTitleContent = 'Planification d\'horaires - Espace Gestionnaire';
  NethrisContactUsButtonLabel = 'Contactez-Nous';
  NethrisLoginSubTitleContent = 'Planification d\'horaires - Espace Gestionnaire';
  NethrisContactUsButtonContent = '<p>Ligne support Modules GT :  1-800-361-5001 #1 #5 #2<br>Ligne support Horodateur :  1-800-361-5001 #1 #5 #6<p>';

  PREFS_HOUR_FORMAT = 'Format des heures';
  HOUR_FORMAT_HOUR_24 = '24h';
  HOUR_FORMAT_HOUR_AM_PM = 'am/pm';

  PunchCanAutoUpdate = 'L\'horodateur peut se mettre à jour';
  PunchAutoUpdateUrl = 'Url de mise à jour';
  WorkShifts = 'Quart de travail';
  RetailNextPosStoreId = 'Magasin Id (POS)';
  EmployeePOSId = 'Identifiant POS';

  ExportToRetailNext = 'Générer un fichier d\'export pour RetailNext';
  UDataServiceMenuLabel = 'Envoyer vers RPA360';
  RetailNextMenuLabel = 'Générer export vers RetailNext';
  GenerateExportFile = 'Générer';

  BudgetTimeAndAmount = 'Paramètres de budget';
  ExplainUsagerBudget = 'Nombre maximal d\'heures par semaine: {{budgetInMinutes}}, Montant maximal par semaine: {{budgetAmount}}';
  ExplainUsagerBudgetNoAmount = 'Nombre maximal d\'heures par semaine: {{budgetInMinutes}}';
  UsagerBudgetNotUsedInDashboard = 'Non utilisé.';
  UsagerBudget = 'Budget';
  UsagerBudgetExplanation = 'Créer un budget hebdomadaire qui avertira l\'usager lorsqu\'il le dépassera. Les avertissements apparaîtront dans le panneau principal.<br>À noter: cet outil fait la somme en heures de tous les horaires (publiés ou non) de tous les départements auxquels l\'usager à droit (voir droits associés de l\'usager).<br>Également, si vous modifiez le budget de l\'utilisateur actuellement connecté, vous devrez quitter et vous reconnecter pour voir les modifications.';
  BudgetInMin = 'Nombre maximal d\'heures par semaine';
  BudgetAmount = 'Montant maximal par semaine ($)';
  BudgetValidation = 'Vérification du budget';
  CRMPanel = 'CRM - Clients';
  OnBoarding = 'Créer un Client (Enterprise, Structure and Administrator)';
  SearchByCRM = 'Recherche par le numero du CRM';
  EnterCRMId = 'Entrez l\'identifiant du client dans le CRM';
  NoCRMBeanFound = 'Aucun élément trouvé.';
  CRMId = 'CRM Id';
  ZohoConfiguration = 'Configuration pour intéragir avec Zoho';
  EnterZohoAuthorizationToken = 'Code d\'autorisation applicatif Zoho';
  RetrieveAuthorizationToken = 'Générer un code d\'autorisation';
  AuthorizeAccessToZoho = 'Finaliser l\'autorisation';
  ZohoAccessAuthorizedFor1Hour = 'Accès à Zoho autorisé pour 1 heure.';
  EnterZohoAccountName = 'Entrez le nom du compte Zoho';
  ExactZohoAccountNameOrStartsWith = 'Le nom exact ou alors le DÉBUT du nom.';
  SearchZohoAccount = 'Rechercher';
  GetZohoAccount = 'Récupérer le Compte';
  EnterZohoId = 'Zoho Unique Id';
//  res += bean.vacationInDays + bean.aheadDay - bean.deferredDay - bean.nbDayUsed + '<span class="muted"> (' + bean.vacationInDays + ' + ' + bean.aheadDay + ' - ' + bean.deferredDay + ' - ' + bean.nbDayUsed + ')</span>';

  ExplainVacationsLeft = 'Jours Disponibles = Accordés ( + Reportés période précédente - Anticipés période précédente ) + Anticipés - Reportés - Utilisés';

  PreviousPeriodHasRemainingDays = 'Attention, la période précédente a {{nb}} jours disponibles.';
  PreviousPeriodHasAheadDays = 'Attention, la période précédente a {{nb}} jours anticipés, ils seront automatiquement retranchés aux jours disponibles pour la période courante.';
  PreviousPeriodHasDeferredDays = 'Attention, la période précédente a {{nb}} jours reportés, ils seront automatiquement ajoutés aux jours disponibles pour la période courante.';
  PreviousPeriodHasRemainingAmount = 'Attention, la période précédente a un montant non utilisé de {{nb}}.';

  PreviousPeriodHasAheadAmount='Attention, la période précédente a un montant anticipé de {{nb}}, il sera automatiquement retranché au montant disponible pour la période courante.';
  PreviousPeriodHasDeferredAmount='Attention, la période précédente a un montant reporté de {{nb}}, il sera automatiquement ajouté au montant disponible pour la période courante.'

  AllPunches = 'Tous les horodateurs';
  Refresh = 'Rafraîchir';
  AutoUpdate = 'Mise à jour automatique (V2 & V3)';
  AutoUpdateUrl = 'Url pour la mise à jour automatique (V2 & V3)';
  LastSeen = 'Dernière Connexion';
  SurveyManager = 'Gestionnaire d\'enquêtes';
  SurveyManagerNbQuestions = 'Nombre de questions';
  AddSurveyAggregation = 'Ajouter une nouvelle enquête';
  SurveyAggregationTitle = 'Enquête';
  SurveyTitle = 'Nom';
  SurveyIsActive = 'Active';
  SurveyDescription = 'Description (sera affichée à l\'utilisateur)';
  SurveyQuestions = 'Questions';
  NoSurveyQuestionsFound = 'Aucune question';
  SurveyQuestionTitle = 'Question';
  SurveyQuestionDescription = 'Libellé';
  SurveyQuestionIsActive = 'Active';
  SurveyQuestionType = 'Type';
  SURVEY_QUESTION_TYPE_YES_NO = 'Oui/Non';
  SURVEY_QUESTION_TYPE_CHECK_CHOICE = 'Multi-Choix';
  SURVEY_QUESTION_TYPE_RADIO_CHOICE = 'Multi-Choix (Exclusif)';
  SURVEY_QUESTION_TYPE_ONE_TO_FIVE = 'Echelle 1 à 5';
  SurveyAnswerChoices = 'Choix de réponses';
  NoSurveyAnswerChoicesFound = 'Aucun choix';
  AnswerChoiceTitle = 'Choix de réponse';
  AnswerChoice = 'Réponse';
  SurveyTargetUnits = 'Cibles/Enquêtes completées';
  SurveyTargetPopulation = '{{nb}} employés ciblés ({{completed}}% de réponses)';
  EmployeeTargetedByThisSurvey = 'Choisir les employés ciblés pour l\'enquête.';
  UseUnitsOrEnterpriseToSelectEmployeesToTarget = 'Choisissez des unités et/ou des entreprises pour déterminer quels employés seront ciblés par cette enquête.';
  EmployeesTarget = 'Définir la cible';
  DoYouReallyWantToResetTheSurveyResults = 'Voulez-vous re-soumettre l\'enquête \'{{name}}\' à tous les employés y compris ceux ayant déjà répondu?';
  DoYouReallyWantToDeleteTheSurveyAggregation = 'Voulez-vous supprimer l\'enquête \'{{name}}\'?';
  ResetSurveyResults = 'Re-soumettre l\'enquête.';
  ExportResultsInJson = 'Exporter les résultats de l\'enquête (JSON)';
  ExportResultsInXls= 'Exporter les résultats de l\'enquête (XLS)';
  ExportResultsInJsonIfShift = 'Exporter les résultats de l\'enquête (XLS), pour JSON faire Shift+Click.';
  NoSurveyTargetUnitsFound = 'Aucune cible définie.';
  EmployeeCompletedSurvey = 'Employé a déjà soumis ses résultats.';
  RetrieveEmployees = 'Récupérer les employés';

  API_ACCESS_TYPE_CIBLE_RECHERCHE = 'Cible Recherche';
  API_ACCESS_TYPE_ALLIE_RH = 'Folks';
  API_ACCESS_TYPE_EMPREZ = 'Emprez';
  ApiAccesses = 'Gestion Accès API';
  ApiAccessesManager = 'Liste des accès autorisés à des fonctionnalités externes';
  ApiAccessType = 'Type de fonctionnalité';
  ApiKey = 'Identifiant unique';
  AllApiAccess='Accès API';
  ListReportToEmail='Rapport par courriel';

  AddApiAccess = 'Ajouter un accès';
  ApiAccessIsActive = 'Accès autorisé et actif';
  ApiAccessToUser = 'Accès';
  delayBetweenConnectionsInMs='Délai entre connexions (ms)';
  delayBetweenQueriesInMs='Délai entre requêtes (ms)';
  DelayInMs='Délai en ms';
  ApplyModification = 'Appliquer les modifications';
  CancelModification = 'Annuler les modifications';

  DoYouReallyWantToDeleteTheApiAccessToUser = 'Voulez-vous vraiment supprimer cet accès?';

  PrintAsXLS = 'Rapport Excel';
  PrintAsPDF = 'Rapport PDF';
  PrintAsPDFPlanning = 'Rapport PDF, Shift + Click pour un rapport par plan.';
  DeleteWorkshift = 'Supprimer tous les horaires';
  CopyTemplates = 'Copier les gabarits';
  DeleteTemplates = 'Supprimer tous les gabarits';
  ShowPayInformation = 'Afficher les informations pour la paie';
  ShowTimeBankInformation = 'Afficher les banques de temps';
  Modify = 'Modifier';
  ApproveUnApproveTS = 'Approuver ou dé-approuver la feuille de temps';
  DoYouReallyWantToDeleteTheParamsProfile = 'Voulez-vous supprimer ce profil de paramètres?';

  IncludeSpifInHolidayCalculation = 'Doit être inclus dans le calcul des jours fériés';
  IncludeSpifInVacationCalculation = 'Doit être inclus dans le calcul des vacances';
  WillBeIncludedInHolidayCalculation = 'Sera inclus dans le calcul des jours fériés.';
  WontBeIncludedInHolidayCalculation = 'NE sera PAS inclus dans le calcul des jours fériés.';
  WillBeIncludedInVacationCalculation = 'Sera inclus dans le calcul des vacances.';
  WontBeIncludedInVacationCalculation = 'NE sera PAS inclus dans le calcul des vacances.';
  SpifTypeManagement = 'Gestion des Type de Bonus';
  HolidayManagement='Gestion des jours fériés';
  ManageStatutoryHolidays='Gestion des jours fériés';

  DoYouReallyWantToDeleteThisLine = 'Voulez-vous vraiment supprimer cette ligne?';
  AddOrModifyBonusBatch = 'Ajouter ou modifier des primes horaires aux employés';
  SelectedEmployeeWillBePaidByTheEnterprise = 'Les employés sont payés par l\'entreprise';
  SelectedEmployeeWillHaveTheFollowingJob = 'Les employés ont le poste suivant:';
  ChangeToOtherLanguage = 'English';
  Reload = 'Rafraîchir les informations';
  ReloadWithInactive = 'Rafraichîr + Inactifs';

  DoYouReallyWantToDeleteThisContact = 'Voulez-vous vraiment supprimer ce contact?';
  DoYouReallyWantToDeleteThisDocument = 'Voulez-vous vraiment supprimer ce document?';
  AddOrUpdateEmailToAccount = 'Courriel dans votre compte';
  ShouldAddOrUpdateAnEmailToYourAccount = 'Ajouter ou vérifier le courriel associé à votre compte, cela vous permettra de retrouver facilement votre mot de passe en cas d\'oubli.';

  Update = 'Enregistrer';
  JobIncludedInTimesheetConsideredInCalculationForCumulativeBonus = 'Seules les feuilles de temps associées aux postes suivants seront utilisées.';
  JobExcludedInTimesheetConsideredInCalculationForCumulativeBonus = 'Les feuilles de temps qui NE sont PAS associées aux postes suivants seront utilisées.';
  HasJobIncludedExcludingJobWontBeApplied = 'Cette condition se sera pas appliquée si la condition précédente est utilisée.';
  IncludingJobs = 'La prime n\'utilisera que les feuilles de temps associées aux postes ({{included}}).';
  ExcludingJobs = 'La prime utilisera toutes les feuilles de temps qui NE sont PAS associées aux postes ({{excluded}}).';
  OverrideJobExportStructure = 'Les codes d\'exportation pour la division, le service, le département et le sous-département associés au poste et à l\'employé seront respectivement remplacés par {{division}}, {{service}}, {{department}} et {{subDepartment}}';
  UnitAndJob = 'Unité / Poste';
  PayExportCode = 'Code de paie';
  TimesheetCode = 'Type de feuille de temps';
  UnitJobCustomPayExportTitle = 'Association spécifique d\'un code de paie à un poste particulier';
  EditUnitJobCustomPayExport = 'Association d\'un code de paie à un poste';
  OverrideJobExportStructureCodes = 'Remplacer les codes associés aux employés par les informations suivantes';
  JobSortingOrder = 'Ordre de tri du poste: {{tri2}}';
  SortingOrderJobHighNumberWillBeFirst = 'Ordre de tri (croissant)';
  NoUnitJobCustomPayExportBeans = 'Aucune information';

  TotalMinutesOtherSchedules = 'Autres heures prévues: {{min}}';
  TotalAmountOtherSchedules = 'Autre montant prévu: {{info}}';
  TotalAmountWithVacationOtherSchedules = 'Autre montant prévu avec vacances: {{info}}';
  SchedulesToBeFilled = 'Quart à combler';
  EmployeHoraireToFillValidation = 'Validation des Quarts à combler';

  NoAnswerReceivedYet = 'Aucune réponse pour le moment';

  APPROVAL_STATE_WAITING_APPROVAL = 'Attente d\'approbation';
  APPROVAL_STATE_APPROVED = 'Approuvé';
  APPROVAL_STATE_REJECTED = 'Refusé';

  ShowApprovableWorkShiftsForWorkShift = 'Quarts à combler';
  ShowApprovableExchangeWorkshift = 'Échange de quarts';
  ApprovableShiftHeader = '{{job}} <span class="muted">{{unit}}</span> le {{event}}, de {{start}} à {{end}}.';
  ApprovableShiftScheduleFound = 'Horaire existant le {{event}}, de {{start}} à {{end}}.';
  ApprovableShiftScheduleFoundNoHours = 'Horaire existant {{eventType}}, le {{event}}.';

  NoApprovableWorkShiftsYet = 'Aucune réponse pour le moment.';
  NoApprovedWorkShiftsYet = 'Aucune approbation pour le moment.';
  NoAnswersYet= 'Aucune réponse pour le moment.';
  NoApprovedWorkShiftsYetButAnswersReceived = 'Aucune approbation pour le moment, {{nbAnswers}} réponse(s) reçue(s).';
  WorkShiftHasBeenAssignedTo = 'Le quart de travail a été attribué à {{fn}}';


  EmployeeVacationHourIsNullOrNegative = 'Le nombre d\'heures de vacances disponibles est négatif ou nul.';
  VacationsLeftInMinutes = 'Vacances disponibles';

  WarningEmployeeMinutesLeft = '<span class="emprez-orange-fiesta">Attention, lorsque tous les congés suivants seront comptabilisés (approuvés pour la paie) alors le solde sera {{nbMinutesLeft}}.</span>';
  EmployeeMinutesLeft = '<span class="emprez-vert-agrume">Lorsque tous les congés suivants seront comptabilisés (approuvés pour la paie) alors le solde sera {{nbMinutesLeft}}.</span>';
  VacationDurationIs = '{{duration}}'
  AverageWageForVacations = 'Taux moyen utilisé pour les vacances';
  UseCCQParametersWhenExportingInPay = 'Utilisez les paramètres suivants pour l\'exportation dans la paie.';
  UseStructureWhenExportingInPay='Utilisez les paramètres suivants pour l\'exportation dans la paie.';
  UseSegmentsWhenExportingInPay='Utilisez les paramètres suivants pour l\'exportation dans la paie.';
  UseSageIntacctWhenExportingInPay='Utilisez les paramètres suivants pour l\'exportation vers Sage-Intacct.';


  EnterpriseVacationsAreInHoursMinutes = 'Les vacances sont en heures.';
  VimInitialMinutes = 'Vacances en Heures:Minutes (initial)';
  VimBalanceMinutes = 'Solde de vacances en Heures:Minutes';
  VimDayOfVacationInMinutes = 'Equivalent d\'un jour de vacances en Heures:Minutes';
  VimAverageRate = 'Taux horaire moyen à appliquer';
  BalanceVacationInMinutes = 'Solde de vacances en Heures:Minutes';
  DisplayBonusPartOnly = 'Utilisez seulement la partie Prime';
  UsePartialHiringToAddEmployeeToPayroll = 'Utiliser \'Embauche partielle\'';

  ShowApprovableVacationRequest = 'Demande de Vacances';
  ApprovableVacationRequestHeader = '{{employeeFullName}} voudrait des vacances du {{start}} au {{end}}. (requête envoyée le {{createdDate}})';
  ApprovableVacationRequestHeaderHour = '{{employeeFullName}} voudrait des vacances le {{dayOfVacation}} de {{start}} à {{end}}. (requête envoyée le {{createdDate}})';
  RequestApproved = 'Demande Approuvée';
  RequestRejected = 'Demande Refusée';
  VacationsInMinutesLeftForEmployee = 'Il reste {{leftTime}} Hr:min de vacances, 1 journée de vacance équivaut à {{oneDayInMin}}';
  VacationsInDaysLeftForEmployee = 'Il reste {{left}} jour(s) de vacances.';
  ActiveScheduleHasBeenFoundOn = 'Un horaire \'{{label}}\' est prévu le {{refDt}} de {{startHour}} à {{endHour}}.';
  ActiveScheduleHasBeenFoundOnNoHours = 'Un horaire \'{{label}}\' de type {{typeHoraire}} est prévu le {{refDt}}.';
  UnitJobCustomPayExport = 'Les informations suivantes sont associées uniquement avec l\'entreprise de paie \'{{name}}\'';
  ExportHourlyRate = 'Exporter le taux horaire';
  WontExportHourlyRate = 'Le taux horaire ne sera pas exporté.';
  NoVacationsInMinutesForEmployee = 'Aucune information sur les vacances n\'est disponible.';
  AllMemos = 'Tous les messages';

  NoCurrentWorkshiftToApprove = 'Aucun quart à combler.';
  NoCurrentWorkshiftToExchange = 'Aucun quart à échanger.';
  NoCurrentVacationRequest = 'Aucune requête de vacances.';
  ImportDone = 'Import réussi sans erreurs.';
  PayStubFileName = 'Talon de paie: \'{{fileName}}\'';

  SearchForEmployee = 'Rechercher employé(s)'
  SearchByEnterprise = 'Par entreprise';
  SearchByServiceDepartement = 'Par services et départements';
  SearchByLastNameFirstNameMatricule = 'Par nom de famille, prénom ou #matricule';
  SelectPositionAndBonuses = 'Sélectionner le poste et les primes horaires';
  BonusDate = 'Date du Bonus';
  ChooseADate = 'Sélectionner une date';

  OtherBadges = 'Autres badges';
  EmployeeOtherBadgesList = 'Autres badges associés à l\'employé';
  EditEmployeeOtherBadge = 'Ajouter ou modifier un badge';
  NoVacationsFound = 'Aucune banque de vacances.';
  DoneBy = 'Fait par';
  ApplyParamsProfileAggregationToPayParams = 'Si nécessaire, vous pouvez sélectionner un profil pour remplacer les informations ci-dessous.';
  AddNamedWorkshift = 'Ajouter un quart prédéfini';
  NamedWorkshifts = 'Gestion des quarts prédéfinis';
  EditNamedWorkShiftRightsForUser = 'Modifier les accès pour un usager';
  EditPlanningRightsForUser= 'Modifier les accès pour un usager';
  EditParamsProfileRightsForUser= 'Modifier les accès pour un usager';
  EditSpifTypeRightsForUser='Modifier les accès pour un usager';

  HasAccess = 'Accès autorisé';

  WarningTitle = 'Avertissement';

  ApprovableShiftMoreInfoWeekScheduled = 'Heures déjà prévues cette semaine: {{scheduled}} hh:mm, avec ce quart de travail le total sera: {{willBeScheduled}} hh:mm';
  ApprovableShiftMoreInfoWeekScheduledOvertime = '<div class="emprez-orange-fiesta">Attention si le quart est accepté, l\'employé fera {{overtimeWillBe}} hh:mm de temps supplémentaire.</div>';

  ApprovableShiftMoreInfoWeekApprovedTimesheets = 'Feuilles de temps déjà approuvées cette semaine: {{approved}} HH:MM.';
  ApprovableShiftMoreInfoSeniority = 'Ancienneté depuis le {{seniorityDate}}, {{seniorityInDays}} jours.';
  ApprovableShiftMoreInfoPriority = 'Priorité sur le poste: {{priority}}.'
  ShiftClickToAddAnImage = 'Shift+Click pour ajouter une image';
  ShiftClickToEditAnImageCtrlClickToDelete = 'Shift+Click pour changer l\'image et Ctrl+Click pour supprimer';
  DoYouReallyWantToDeleteThisProfilePicture = 'Voulez-vous supprimer la photo de profil?';
  EditPicture = 'Ajouter/Modifier une image';
  SpifDescription = 'Bonus';
  JobUnitDescription = 'Poste associé';
  AllieRHReports = 'Folks';
  ReportTXT = 'Rapport Standard';

  StartOfTaskLocation = 'Début de tâche';
  EndOfTaskLocation = 'Fin de tâche';
  CantDecideIfStartOfEndOfTask = 'Tâche';

  NoBudgetScheduled = 'Aucun horaire prévu';
  ExplainBudgetScheduled = 'Des horaires pour {{budgetInMinutes}} ({{budgetAmount}}) ont été prévus du {{startWeek}} au {{endWeek}}.';
  ExplainBudgetScheduledNoAmount = 'Des horaires pour {{budgetInMinutes}} ont été prévus du {{startWeek}} au {{endWeek}}.';
  BudgetManagement = 'Gestion des budgets';
  AccessDenied = 'Vous n\'avez pas accès à cette fonctionnalité';

  EventManagement = 'Gestion des évènements';
  NoEventFound = 'Aucun évènement pour la période sélectionnée.';
  EditDayEventAggregation = 'Évènement';

  ExplainDayEvent = 'Le {{eventDtStr}} pour {{unitDescription}}.';
  ExplainDayEventWithHour = 'Le {{eventDtStr}} à {{eventHourStr}} pour {{unitDescription}}.';
  DayEvent = 'Details';
  EventDt = 'Date';
  EventHour = 'Heure (optionnel)'


  SalesCostManagement = 'Gestion des ventes et des ratios ventes/coûts.';
  NoDaySalesFound = 'Aucune information sur les ventes.';
  ExplainDaySalesCostObjective = 'Il est prévu {{expectedSales}} de vente le {{eventDt}} pour {{unitDescription}}. L\'objectif du ratio ventes/coûts est de {{ratio}}.';
  ExplainDaySalesCostObjectiveNoRatio = 'Il est prévu {{expectedSales}} de vente le {{eventDt}} pour {{unitDescription}}.';
  ExpectedSales = 'Ventes prévues';
  RealSales = 'Ventes réelles';
  WantedRatio = 'Objectif ratio ventes/coûts';
  EditDaySalesCostObjectiveAggregation = 'Ratio Ventes/coûts';
  DaySalesCostObjective = 'Objectifs de coûts';
  ExplainDaySalesCostObjectiveRealSalesSales = 'Obj: {{ratio}} de {{expectedSales}} (réel) pour {{unitDescription}}';
  ExplainDaySalesCostObjectiveExpectedSalesSales = 'Obj: {{ratio}} de {{expectedSales}} (prévision) pour {{unitDescription}}';
  ExplainDaySalesCostObjectiveNotShowingAmount = 'Obj: {{ratio}} des ventes pour {{unitDescription}}';

  CanManageEvent = 'Gestion des évènements';
  CanManageOtherBudget = 'Gestion des budgets';
  CanManageSalesCostObjective = 'Gestion des ratios ventes/coûts';
  DataSaved = 'Données enregistrées';

  EmprezMessages = 'Annonces Emprez';
  NoEmprezMessage = 'Aucune annonce';
  EditEmprezMessage = 'Annonce';
  MessageToDisplay = 'Message texte';

  EmprezMessage = 'Annonce';
  GoToReadAboutTheEmprezMessage = 'Découvrez plus d\'information en suivant ce lien.';
  DontShowMeThisMessageAgain = 'Ne plus voir cette annonce';
  ShowDayEvents = 'Afficher les évènements';
  DoYouWantToDeleteAllSchedulesNotTimesheets = 'Le poste {{position}} n\'est pas actif. Voulez-vous supprimer les horaires et les gabarits associés ? (Les feuilles de temps déjà approuvées seront conservées.)'
  ScheduleDate = 'Date de l\'horaire';
  SaveSchedule = 'Enregistrer';
  CreateScheduleOrPunch = 'Ajouter un horaire ou un poinçon';
  PunchToUse = 'Horodateur';
  PunchDate = 'Date du poinçon';
  MealStart = 'Début Repas';
  MealEnd = 'Fin Repas';
  BreakStart = 'Début Pause';
  BreakEnd = 'Fin Pause';

  ShowApprovableSpecialAvailability = 'Demande d\'indisponibilité';
  NoCurrentSpecialAvailabilityToApprove = 'Aucune demande d\'indisponibilité.';

  ShowApprovablePeriodicAvailability = 'Demande de disponibilité';
  NoCurrentPeriodicAvailabilityToApprove = 'Aucune demande de disponibilité.';
  CantAccessPayingEnterprise = 'Aucun accès à l\'entreprise de paie de l\'employé';

  AllMemosWhoseAuthorIs = '{{nb}} mémos ont été envoyés par {{name}} ({{nbActive}} sont actifs)';
  AllMemosReceived = '{{nb}} mémos ont été reçus par {{name}} ({{nbActive}} sont actifs)';
  InactiveClickToActivate = 'Inactif (Click pour activer)';
  ActiveClickToDeActivate = 'Actif (Click pour désactiver)';

  GroupManagement = 'Gestionnaire de groupe d\'employés';
  PlanManagement = 'Gestionnaire de plan';
  AddPlan = 'Nouveau';
  NoteToEmployee = 'Note à l\'employé';
  OtherFilters = 'Autres Filtres';
  AdjustmentDetails = 'Détails de l\'ajustement';
  Details = 'Détails';
  ModifyLevelJobInBatch = 'Modifier les échelons en lot';
  SelectPosition = 'Sélectionner le poste';
  ModifyEmployeeSortOrderInBatch = 'Modifier le dossier employé (utilisé pour les tris) en lot';
  Position = 'Poste';
  PositionLevel = 'Échelon';
  CanChangePositionOnSchedule = 'L\'employé peut changer le poste de son horaire.';
  'schedule.position.different.ts' = 'Le poste prévu est différent de celui utilisé.';
  'schedule.position.different.ts.extra' = 'Le poste prévu {{schedule}} est différent de celui utilisé {{ts}}.';
  CreateHolidays = 'Ajouter ou supprimer des jours fériés en lot';
  AddHoliday = 'Ajouter les dates pour les jours fériés';
  AddingHolidaysInBatch = 'Des jours fériés seront ajoutés aux dates suivantes.';
  RemovingHolidaysInBatch = 'Si des jours fériés existent pour les dates suivantes, ils seront supprimés.';
  ChooseDate = 'Choisir une date';
  VacationDuration = 'Durée des vacances en heures:minutes';
  DurationForTheWholeDay = 'Journée complète';

  VacationPerDayOrPerMinute = 'Vacances à la journée ou à l\'heure';
  OneOrSeveralWholeDays = 'à la journée';
  SomeTimeDuringTheDay = 'à l\'heure';
  DoYouReallyWantToReactivateAllTheMemos = 'Voulez-vous vraiment réactiver tous les mémos?';
  DoYouReallyWantToDeactivateAllTheMemos = 'Voulez-vous vraiment désactiver tous les mémos?';
  ReactivateAll = 'Tout réactiver';
  DeactivateAll = 'Tout désactiver';
  ClickToEditEmployee = 'Cliquez pour voir le dossier employé';

  Commitments='Documents à signer';
  CommitmentAggregationManager = 'Documents à signer par les employés';
  CommitmentTitle = 'Titre';
  CommitmentCreatedBy = 'Créé par';
  CommitmentTargetUnits = 'Nombre de signatures';
  NoCommitmentTargetUnitsFound = 'Aucune cible définie';
  EmployeeSigned = 'Signé par l\'employé';
  CommitmentAggregationEdit = 'Document à signer';
  CommitmentDescription = 'Description';
  CommitmentIsActive = 'Actif';
  dueDt = 'Le document devra être signé avant';
  AddCommitmentAggregation = 'Nouveau';
  CommitmentTargetPopulation = '{{nb}}/{{total}} employés ciblés ont signé ({{completed}}%)';
  UsersWithAccessToCommitment='Usagers ayant accès au document';

  ShiftClickToIncludeInactive = 'Shift + cliquer pour charger aussi les inactifs';
  ExportResultsInPDF = 'Exporter en PDF';
  CommitmentHasAlreadyReceivedSignatures = 'Des employés ont déjà signé le document \'{{file}}\', il n\'est plus possible de le modifier';
  startOfWeekExplain = 'Début de semaine: {{day}}.';
  NotSameDayOfWeek = 'Erreur de configuration une unité n\'a pas le même jour pour le début de la semaine.';
  DoYouReallyWantToDeleteTheCommitmentAggregation = 'Voulez-vous vraiment supprimer \'{{name}}\' ?'
  DoYouReallyWantToResetThisCommitment= 'Voulez-vous supprimer les signatures pour \'{{name}}\' ? Les employés devront signer de nouveau.';
  ResetEmployeeCommitments='Supprimer les signatures existantes.';


  UseUnitsOrEnterpriseToSelectEmployeesToTargetForSignature = 'Choisissez des unités et/ou des entreprises pour déterminer quels employés devraient signer le document \'{{name}}\'.';
  EmployeeTargetedToSignDocument = 'Choisir les employés devant signer le document';
  EditOrConsult = 'Modifier/Consulter';

  UnitsTargetToSignDocument = 'Employés travaillant dans ces départements';
  EnterprisesTargetToSignDocument = 'Employés payés par ces entreprises de paie';

  OverBudgetAmount = '{{diff}} est hors budget.';
  OverBudgetMin = '{{diff}} est hors budget.';
  PicturesTakenByPunch = 'Photos prises par l\'horodateur';
  TakeOwnershipAndSave = 'Devenir Auteur & Enregistrer';
  ImportingTaxInformation = 'Import des relevé pour impôts (T4 et Relevé 1)';
  PayTaxInformationFileName = 'Relevé pour impôts: \'{{fileName}}\'';
  PayTaxInformationFormatType = 'Format du fichier à importer';
  DropPayTaxInformationHere = 'Déposer le fichier ici.';
  PAY_TAX_INFORMATION_FORMAT_TYPE_NETHRIS_ = 'Nethris-Desjardins';
  PAY_TAX_INFORMATION_FORMAT_TYPE_NETHRIS = 'Standard';

  EditShiftBonus = 'Prime pour les quarts de travail';
  AddJobBonus = 'Ajouter le bonus du poste';
  ShiftBonus = 'Primes pour les quarts de travail';

  ChooseShiftBonus = 'Prime de quart';
  WorkShiftBonusActive = 'Prime est active';
  WorkshiftBonusStartEndTime = 'Début - Fin';

  WorkShiftBonus = 'Primes de quart';
  AddWorkShiftBonus = 'Ajouter une prime de quart';
  NoWorkShiftBonusesFound = 'Aucune prime de quart.';
  EditWorkShiftBonus = 'Prime de quart';

  ListAllMemo = 'Tous les mémos';
  GoToAuthoredMemos = 'Liste des mémos envoyés';
  GoToReceivedMemos = 'Liste des mémos reçus';
  NoStatus = 'Aucun statut de lecture.';
  AddMemoStatus = 'Ajouter un statut';
  DeleteMemoStatus = 'Supprimer le statut';
  StatusDate = 'Date';
  StatusType = 'Type';

  EnterBadge = 'Numéro de badge';
  BadgeActive = 'Badge actif?';
  AddOrModifyEmployeeBadge = 'Ajouter ou modifier un badge pour un employé';
  AllPayGeneratedBy = 'Paies générées par {{name}}.';
  DoYouReallyWantToDeleteThePay = 'Voulez-vous effacer les informations sur cette paie? (Cela ne remet pas en question la paie générée par le client.)';
  NoEntriesFound = 'Aucune ligne exportée dans la paie';
  ListGeneratedPay = 'Paies Générées';


  GeoFenceManager = 'Gestionnaire des zones GPS';
  GeoFenceName = 'Nom';
  GeoFenceNameActive = 'Zone Active';
  GeoFenceCreatedBy = 'Auteur';
  EditGeoFence = 'Modification d\'une zone GPS';
  EditGeoFenceRightsForUser = 'Modifier les accès pour un usager';
  AddGeoFence = 'Ajouter Zone GPS';
  UsersWithAccessToGeoFence = 'Usagers pouvant utiliser cette zone GPS.';
  GeoFenceLat = 'Latitude';
  GeoFenceLon = 'Longitude';
  GeoFenceRadiusInMeter = 'Rayon en mètres (50m - 1000m)';
  CanManageGeoFence = 'Gestion des zones GPS';
  GeoFence = 'Zones GPS';
  GeoFenceExplain = 'Si et seulement si l\'employé utilise l\'application mobile pour effectuer ses poinçons, alors vous pouvez limiter l\'endroit physique d\'où il peut le faire selon les zones géographiques ci-dessous. ';
  CustomCumulativePremiumExplain='Ajouter des primes cumulatives personnalisées'

  ChooseGeoFence = 'Sélection';
  Choose = 'Choisir';
  EnterpriseUsesJobSegment = 'Export avec numéros de travail';
  Segments = 'Segments';
  SegmentsNumeros = 'Segments - Numéros de travail';
  Segment1 = 'Segment 1';
  Segment2 = 'Segment 2';
  Segment3 = 'Segment 3';
  Segment4 = 'Segment 4';
  Segment5 = 'Segment 5';
  Segment6 = 'Segment 6';
  TimesheetTotalIsNegative = 'Le total est négatif.';
  BlockOutOfSequenceButtons = 'Bloquer les boutons hors séquences (V2 & V3)';
  IncludeInactiveEmployee = 'Inclure les employés inactifs';
  ChangeStatusEmbauche = 'Modifier le statut';
  HiringDetailModifyStatus = 'Modification du Statut d\'Embauche';
  EmployeeNotificationDetails = 'Configuration Employé';
  NotificationPref = 'Préférence Notification';
  UpdateConfiguration = 'Enregistrer la Configuration'
  ClickToAddSchedule = 'Cliquer pour ajouter un horaire';
  ShiftClickToSeeTheInactive = 'Shift + Click pour voir actifs et inactifs';
  RemindMeLater = 'Rappeler plus tard';

  NotMemberYet = 'Pas encore membre';
  ChatManager = 'Gestionnaire des conversations';
  ChatRooms = 'Conversations'
  NoChatRoomSelected = 'Sélectionnez une conversation ci-contre ou ajoutez-en une nouvelle avec le bouton plus bas.';
  Invite = 'Inviter';
  nbMembers = '{{nb}} membres.';
  EnterYourMessageHere = 'Entrez votre message ici';
  ChannelIsPublic = 'Public';
  ChannelName = 'Nom';
  EditChatChannel = 'Conversation';
  Members = 'Membres';
  IfChannelIsPrivateWeWillInviteTheFollowing = 'Sélectionez les membres de votre conversation privée';
  ClickToUse = 'Click pour utiliser';
  NoMessages = 'Aucun Message';
  ClickToDeleteChannel = 'Supprimer cette conversation';
  ClickToLeaveChannel = 'Quitter cette conversation';
  DoYouReallyWantToDeleteThisChannel = 'Voulez-vous supprimer la conversation \'{{name}}\' ? (Tous les messages associées seront également supprimés)';
  NewChatFrom = '{{from}}: \'{{body}}\' dans \'{{channel}}\'';
  NewPrivateChatFrom = '{{from}}: \'{{body}}\'';
  TwilioServices = 'Services Twilio';
  TwilioServiceId = 'Service Twilio Id';
  FriendlyName = 'Nom';
  EditTwilioService = 'Service Twilio'
  DoYouReallyWantToDeleteThisTwilioService = 'Voulez-vous supprimer le service \'{{name}}\'?, Le service twilio sera supprimé avec tous les messages associés.'

  BankManager = 'Gestionnaire de banques de temps personnalisées';
  BankName = 'Nom';
  BankCreatedBy = 'Créateur';
  EditBankTypeRightsForUser = 'Modifier les accès pour un usager';
  AddBankType = 'Ajouter une banque';
  EditBankType = 'Banque de temps';
  BankTypeName = 'Nom';
  BankTypeActive = 'La banque est active';
  UsersWithAccessToBankType = 'Usagers pouvant utiliser cette banque de temps';
  DoYouReallyWantToDeleteThis = 'Voulez-vous supprimer \'{{name}}\'?';

  AddToBankCode = 'Code de paie pour un ajout';
  RemoveFromBankCode = 'Code de paie pour un retrait';
  SetBankCode = 'Code de paie pour spécifier le solde';
  None = 'Aucun';
  BankDetail = 'Exportation';
  explainBankType = 'Ajout: {{add}}, Utilisation: {{remove}} et Spécification: {{set}}.';
  OtherBanks = 'Banques de temps personnalisées';
  CanManageBankTypes = 'Peut gérer les banques de temps personnalisées';
  YouHaveMinutesInYourBankForPeriod = '{{left}} dans la banque du {{start}} au {{end}}. (Une journée équivaut à {{oneDayInMinutes}}.) ';
  YouHaveMinutesInYourBank = '{{left}} dans la banque . (Une journée équivaut à {{oneDayInMinutes}}.) ';
  BankWillUseYourCurrentRate = 'L\'exportation vers la paie utilisera le taux horaire de l\'employé.';
  BankWillUseTheFollowingRate = 'L\'exportation vers la paie utilisera {{rate}} comme taux horaire.';
  BankType = 'Banque';
  TimeInBankInMinutes = 'Solde en heures et minutes';
  OneDayInMinutes = 'Équivalent en heures et minutes d\'une journée type';
  HourlyWage = 'Taux horaire';
  TimeBankHourlyWage = 'Taux horaire à utiliser lors du paiement (si différent du taux courant)';
  UseNormalEmployeeRate = 'Utiliser le taux horaire courant';
  NoBankFound = 'Aucune banque de temps';
  TimeFromBank = 'Durée utilisée';

  IfApprovedBankWillBeOverTheBalance = 'Trop de temps pris par rapport à ce qui reste en banque.';
  BankWontBeExportedInPay = 'Cette feuille de temps ne sera pas exportée dans la paie.';
  BankTypeIsNotAvailableForEmployee = 'Cette banque n\'est pas associée à l\'employé.';
  EditBankTypeEmployeHoraire = 'Banque personnalisée';

  NoBankTypeTransactionFor = 'Aucune modification des banques personnalisées pour {{emp}}';
  UsedInSchedulesOrTs = 'Utilisation dans les horaires/feuilles de temps';
  addedMinuteToBank = '{{min}} heures:minutes ajoutées';
  removedMinuteFromBank = '{{min}} heures:minutes utilisées';

  RemovedFromBank = '{{value}} heures:minutes supprimées de la banque.';
  AddedToBank = '{{value}} heures:minutes ajoutées à la banque.';
  BankSetTo = 'La banque a été mise à {{value}} heures:minutes.';
  WillBeExportedInPayRoll = 'Export dans la paie';
  BankBalanceHasBeenModified = 'Le solde a été modifié le {{on}}.';
  BankTypeTransactions = 'Transactions dans les banques de temps personnalisées'
  EditBankTypeTransaction = 'Transaction dans une banque de temps personnalisée';
  TRANSACTION_TYPE_ADD = 'Ajout';
  TRANSACTION_TYPE_SET = 'Valeur Exacte';
  TRANSACTION_TYPE_REMOVE = 'Utilisation/Soustraction';
  ExportInPay = 'La transaction sera exportée dans la paie';
  TransactionType = 'Type de transaction';
  ValueInMinStr = 'Valeur HH:MM';
  BankTypeEmployeeTransactionInactive = '<span class="emprez-orange-fiesta">Inactif</span>';
  BankTypeEmployeeTransactions = 'Transactions sur les banques';
  EmployeeMustHaveBankTypeAssociated = 'L\'employé doit avoir été au préalable, associé à une banque de temps personnalisée.';
  AddBankTypeEmployeeInBatch = 'Ajouter des banques personnalisées en lot';
  AddOrDeleteBankTypeEmployeeInBatch = 'Ajouter ou supprimer des banques personnalisées en lot';
  BankTypeEmployeeInactive = '&nbsp;<span class="emprez-orange-fiesta">Inactif</span>';
  BankTypeReports = 'Rapports - Banques Personnalisées';

  BANK_TYPE = 'BdT perso.';
  BankTypeTransactionCantBeModifiedOrDeleted = 'Les modifications sont bloquées car la banque a déjà été modifiée le {{balanceModifedOn}}.';
  NoTwilioServices = 'Aucun service Twilio n\'a été créé.';


  ApprovablePaidFamilyDayRequestHeader='{{employeeFullName}} voudrait prendre le {{refDate}} comme une journée familiale payée.';
  ApprovableUnPaidFamilyDayRequestHeader='{{employeeFullName}} voudrait prendre le {{refDate}} comme une journée familiale non payée.';

  ApprovableBankTypeRequestHeaderCompleteDay = '{{employeeFullName}} voudrait prendre le {{refDate}} depuis sa banque \'{{bankName}}\'.';
  ApprovableBankTypeRequestHeader = '{{employeeFullName}} voudrait prendre {{nbMin}} heures:minutes, le {{refDate}} depuis sa banque \'{{bankName}}\'.';
  NoTimeLeftInBank = 'Il ne reste plus de temps dans cette banque.';
  TimeLeftInBankForEmployee = 'Il reste {{leftTime}} heures:minutes dans cette banque. (1 jour correspond à {{oneDayInMin}} heures:minutes)'
  NoTimeBankForThisEmployee = 'Cette banque de temps n\'est pas associée à cet employé, ou elle est en erreur.';
  ShowApprovableBankTypeRequest = 'Banques de temps';
  ShowApprovableFamilyDaysRequest='Journées familiales';

  NoCurrentBankTypeRequest = 'Aucune requête pour l\'utilisation des banques de temps.';
  NoCurrentFamilyDayRequest='Aucune requête pour l\'utilisation des journées familiales.';

  UsingBankTypes = 'Utilisation des banques de temps personnalisées';
  NotYetApproved = 'Pas encore approuvé';
  BankWillBeUsedToCalculateStatutoryHolidaysTooltip = 'Les heures seront accumulées comme des heures de travail pour le calcul des fériés.'
  BankWillBeUsedToCalculateStatutoryHolidays = 'Inclus pour les jours fériés';

  TotalAmountWillBeExportedInThePayrollTooltip = "Le montant total calculé sera exporté dans la paie. En général il n'est pas inclus si le taux horaire et les heures sont présentes.";
  TotalAmountWillBeExportedInThePayroll ="Exporter le montant total";
  BalanceCanBeNegative="Le solde peut être négatif";
  SynchronizeWithAPI='Synchroniser avec l\'API';
  VisibleByEmployee='Visible par l\'employé';



  BankTypeConsideredInCalculationForCumulativeBonus = 'Les feuilles de temps qui sont associées aux banques suivantes seront utilisées.';
  ChooseBankType = 'Banques de temps personnalisées';
  EmployeeCanRequestBankType = 'L\'employé peut faire une requête d\'utilisation de ses banques de temps personnalisées.';
  SurveyQuestionOtherRef = 'Autre Référence';
  ModifyExportPayCodesUseFromPosition = 'Remplacer les codes d\'exportation de la paie par ceux par défaut de la structure';
  IncludeInactivePositions = 'Inclure les employés dont le poste est inactif';
  CreatePrivateChatChannel = 'Créer une conversation privée';
  BonusAvailableForTsStartingOrAfter = '&nbsp;<span class="emprez-orange-fiesta">Pour les FDTs débutants à partir du {{dt}}.</span>';
  BonusAvailableForTsEndingOrBefore = '&nbsp;<span class="emprez-orange-fiesta">Pour les FDTs finissants au plus tard le {{dt}}.</span>';
  BonusAvailableForTsBetween = '&nbsp;<span class="emprez-orange-fiesta">Pour les FDTs comprises entre le {{start}} et le {{end}}.</span>';
  BonusActiveFrom = 'À partir du';
  BonusActiveFromMore = 'Le début du quart doit être le même jour ou après la date ci-dessous.';
  BonusActiveTo = 'Jusqu\'au';
  BonusActiveToMore = 'La fin du quart doit être le même jour ou avant la date ci-dessous.';
  MessageNotRead = '{{nb}} non lu';
  MessageNotReadPlural = '{{nb}} non lus';
  New = 'Nouveau'
  CreatePublicChannel = 'Créer une conversation publique';
  UserWillAccessToBankType = 'L\'usager pourra utiliser les banques sélectionnées';
  EmployeesWithAtLeastOneSchedule = 'Liste des employés avec au moins un horaire dans la période sélectionnée.';
  EmployeesWithAtLeastOneApprovedTS = 'Liste des employés avec au moins une FDT approuvée dans la période sélectionnée.';
  AdminReporting = 'Rapports';
  ImportSurveys = 'Importation de questionnaires';
  SurveyImported = 'Import réussi';
  CantImportSurvey = 'Erreur lors de l\'import, veuillez vérifier le format du fichier.';
  UploadJSONFile = 'Déposer votre fichier JSon';
  StartDt = 'Début';
  EndDt = 'Fin';
  AddMultiple = 'Ajout multiple';
  DatesInvalid = 'Les dates sont invalides. Vous pouvez vérifier que le début est bien avant la fin par exemple.';
  SchedulesDeleted = '{{nb}} horaires qui étaient prévus après la date de terminaison, ont été supprimés.';
  DeleteSchedulesAfterTerminationDate = 'Supprimer les horaires futurs';
  DeleteSchedulesAfterTerminationDateTip = 'Supprimer les horaires qui avaient été prévus après la date de terminaison.';
  EmployeeCanPunch = 'Employé peut poinçonner';
  InitialSeniorityInMin = 'Heures cumulées (Initial)';
  SurveySortOrder = 'Ordre de Tri';
  Completed = 'Complet';
  ImportOneOrSeveralSurveys = 'Importer une enquête ou des enquêtes';
  ExportAllResults = 'Exporter tous les résultats de toutes les enquêtes';
  ClickToSelectEmployeeThatCanPunch = 'Cliquer pour sélectionner tous les employés qui peuvent poinçonner';
  ClickToSelectInactiveEmployeeThatCanPunch = 'Cliquer pour sélectionner tous les employés (Inactifs seulement) qui peuvent poinçonner. (Shift+Click désélectionnera les employés inactifs seulement)';
  DoYouReallyWantToDeleteThisEmployeeFromThisTask = 'Voulez-vous supprimer la tache {{description}} de {{fn}} {{ln}}?';
  DoYouReallyWantToChangeThisUsername = '<span style="color:red">Attention!</span><br>Voulez-vous vraiment changer ce nom d\'usager?<br><br>Il sera <span style="color:red">totalement supprimé</span> incluant toutes les dépendances associées. (Questionnaires et Réponses, Banques persos, Plans,...)';
  YesIKnowWhatIamDoing = 'Oui, je comprends ce que je fais.';

  UseDepartureDate = 'Importer la date de départ'
  UseDepartureDateTip = 'Emprez va créer une cessation d\'emploi à la date de départ. (Faire Shift+Click pour tout dé-électionner)';
  UpdateVacationInformation='Mise à jour des banques de vacances';
  UpdateVacationInformationTip='Emprez va remplacer les banques de vacances avec l\'information contenue dans le système de paie. (Shift+Click pour tout dé-sélectionner)';

  UseReHiringDate = 'Importer la date de ré-embauche';
  UseReHiringDateTip = 'Emprez va créer une embauche à la date de ré-embauche. (Faire Shift+Click pour tout dé-sélectionner)';
  NbEmployeesTarget = '{{nb}} employés, {{nbPunch}} peuvent poinçonner, {{nbInactive}} sont inactifs, {{nbNoSurvey}} employés non ciblés. Sélection courante: {{selection}}.';
  UpdateCustomTimeBanksTip = 'Emprez forcera les banques personnalisées avec la valeur envoyée par l\'API. (Faire Shift+Click pour tout dé-sélectionner)';
  UpdateCustomTimeBanks='Mise à jour des banques personnalisées';


  AdministrativeRights = 'Droits';
  GrantablePreferences = 'Préférences';

  SURVEY_TYPE_GENERIC = 'Standard';
  SURVEY_TYPE_COVID_19 = 'Covid-19';

  SurveyOtherRef = 'Autre référence';
  SurveyIsReadonly = 'Lecture seule';
  SurveyType = 'Type';
  ExportToXLS = 'Export en XLS';

  CustomCumulativePremiumConfiguration = 'Primes cumulatives personnalisées'
  AvailableCustomCumulativePremiums = 'Primes disponibles';

  EditCustomCumulativePremiumConfiguration = 'Configuration - Prime Cumulative Personnalisée';
  DailyCumulativePremiumConfiguration6000 = 'Configuration de la partie quotidienne';
  DailyCumulativePremiumConfiguration6004 = 'Configuration de la partie quotidienne';
  DailyExportCode = 'Code Paie';
  DailyName = 'Nom (Rapport)';
  DailyCondition = 'Quand le total des heures';
  DailyConditionAmount = 'HH:mm';
  DailyCumulativeBonusPercent = 'Primes';
  DailyCumulativeBonusAmount = 'Primes';

  WeeklyCumulativePremiumConfiguration6000 = 'Configuration de la partie hebdomadaire';
  BiWeeklyCumulativePremiumConfiguration6004 = 'Configuration de la partie bimensuelle (2 semaines)';
  WeeklyExportCode = 'Code Paie';
  WeeklyName = 'Nom (Rapport)';
  WeeklyCondition = 'Quand le total des heures';
  WeeklyConditionAmount = 'HH:mm';
  WeeklyCumulativeBonusPercent = 'Primes';
  WeeklyCumulativeBonusAmount = 'Primes';
  CUMULATIVE_PREMIUM_CCP6000 = 'Prime 6000';
  CUMULATIVE_PREMIUM_CCP6001 = 'Prime 6001';
  CUMULATIVE_PREMIUM_CCP6002 = 'Prime 6002';
  CUMULATIVE_PREMIUM_CCP6003 = 'Prime 6003';
  CUMULATIVE_PREMIUM_CCP6004 = 'Prime 6004';
  CUMULATIVE_PREMIUM_CCP6005 = 'Prime 6005';
  CUMULATIVE_PREMIUM_CCP6006 = 'Prime 6006';
  CUMULATIVE_PREMIUM_CCP6007 = 'Prime 6007';
  CUMULATIVE_PREMIUM_CCP6008 = 'Prime 6008';
  CUMULATIVE_PREMIUM_CCP6009 = 'Prime 6009';


  TheEmployeeHadASalaryModification = 'Le salaire a été modifié le {{on}} de {{from}} à {{to}}. Voulez-vous ajouter ou modifier cette information au dossier?';
  SalaryUpdateReceivedIsTooLate='La modification salariale du {{receivedUpdate}} ne peut être appliquée, elle est avant la dernière modification faite au dossier {{lastUpdate}}.';


  REMOTE_ACCESS_TYPE_TEAMVIEWER = 'Teamviewer';
  REMOTE_ACCESS_TYPE_ZOHO_ASSIST = "Zoho-Assist";
  RemoteAccessType = 'Type d\'accès à distance';
  RemoteAccessName = 'Nom dans Zoho-Assist ou Teamviewer';
  IncludeInactivePosition = 'Inclure les postes inactifs';
  IncludeInactivePositionTip = 'Les destinataires avec un poste inactif seront inclus.';
  IncludeInactiveEmployeeTip = 'Les employés non terminés mais inactifs (congé maternité,...) seront inclus.';

  RUN_EVERY_TYPE_DAY = 'Tous les jours';
  RUN_EVERY_TYPE_WEEK = 'Toutes les semaines';

  Frequency = 'Fréquence';
  EmailTitle = 'Titre du courriel';
  EmailBody = 'Contenu du message';
  EmailRecipients = 'Destinataire';
  SendThisReportByEmailTip = 'Vous pouvez vous envoyer ce rapport sur une base quotidienne ou hebdomadaire.';


  OUTPUT_TYPE_PDF = 'Pdf';
  OUTPUT_TYPE_XLS = 'Excel';
  OUTPUT_TYPE_XLSX = 'Excel';
  OUTPUT_TYPE_TXT = 'Texte';
  HelloHereIsTheRequested = 'Bonjour {{name}},<br> Vous trouverez ci-joint le rapport demandé.<br>Bonne journée.<br>Votre équipe Emprez.';
  ReportToEmailTitle = 'Rapport périodique';
  ReportToEmailIsActive = 'Rapport périodique est actif';
  ReportToEmails = 'Rapports périodiques par courriel';
  ReportToEmailName = 'Nom';
  ReportToEmailRecipients = 'Destinataires'
  ReportToEmailFrequency = 'Fréquence';
  UserCanModifyCostDistribution = 'Peut modifier la distribution des coûts.';
  UserCanModifyCostDistributionTip = 'L\'employé peut modifier les codes de paie de la structure (Division, Service,...) ou des segments.';
  CanModifyOwnProfile='Peut modifier ses informations personnelles.';
  NbSegmentUsed = 'Nombre de segments utilisés';
  Segment1Label = 'Libellé du segment1 (optionnel)';
  Segment2Label = 'Libellé du segment2 (optionnel)';
  Segment3Label = 'Libellé du segment3 (optionnel)';
  Segment4Label = 'Libellé du segment4 (optionnel)';
  Segment5Label = 'Libellé du segment5 (optionnel)';
  Segment6Label = 'Libellé du segment6 (optionnel)';
  EditEnterpriseCostDistributionConfig = 'Configuration';
  EnterpriseCostDistributionConfig = 'Configuration des valeurs possibles (optionnel)';
  CostDistributionType = 'Type';
  COST_DISTRIBUTION_TYPE_SEGMENT1 = 'Segment1';
  COST_DISTRIBUTION_TYPE_SEGMENT2 = 'Segment2';
  COST_DISTRIBUTION_TYPE_SEGMENT3 = 'Segment3';
  COST_DISTRIBUTION_TYPE_SEGMENT4 = 'Segment4';
  COST_DISTRIBUTION_TYPE_SEGMENT5 = 'Segment5';
  COST_DISTRIBUTION_TYPE_SEGMENT6 = 'Segment6';

  COST_DISTRIBUTION_TYPE_DIVISION = 'Division';
  COST_DISTRIBUTION_TYPE_SERVICE = 'Service';
  COST_DISTRIBUTION_TYPE_DEPARTMENT = 'Département';
  COST_DISTRIBUTION_TYPE_SUBDEPARTMENT = 'Sous-Département';


  COST_DISTRIBUTION_TYPE_SI_ACCUMULATION_TYPE='Accumulation';
  COST_DISTRIBUTION_TYPE_SI_COST_TYPE='Coût Type';
  COST_DISTRIBUTION_TYPE_SI_TIME_TYPE ='Temps Type';
  COST_DISTRIBUTION_TYPE_SI_LABOR_CLASS='Travail - Classe';
  COST_DISTRIBUTION_TYPE_SI_LABOR_SHIFT='Travail - Quart';
  COST_DISTRIBUTION_TYPE_SI_LABOR_UNION = 'Travail - Syndicat';
  COST_DISTRIBUTION_TYPE_SI_DEPARTMENT='Département';
  COST_DISTRIBUTION_TYPE_SI_LOCATION='Localisation';


  EnterprisesPerEntity = 'Entreprises par entité';
  ShowDivisionsByEntity = 'Divisions par entité';
  ShowCRM = 'Afficher dans la partie CRM d\'Emprez';
  ShowInZoho = 'Afficher dans le CRM externe (Zoho)';
  CostsDistributionsTitle = 'Distribution des coûts (Si vide la distribution se fera selon le poste)';
  SendCredentialsToEmployee = 'Envoyer les informations d\'accès par courriel';
  PrintCredentialsForEmployee='Imprimer les informations d\'accès';

  SegmentsConfiguration = 'Configuration des segments (Numéros de travail)';
  DoYouReallyWantToDeleteThisValue = 'Voulez-vous vraiment supprimer cette valeur?';
  Value = 'Valeur';

  UpdateAllApiPassword = 'Tous les mots de passe';
  UpdateAllApiPasswordTip = 'Mettre à jour tous les mots de passe pour toutes les entreprises avec le même usager, même code et dans le même mode de test (ou non).';
  DoYouReallyWantToUpdateApiPassword = 'Voulez-vous utiliser le mot de passe \'{{password}}\' pour toutes les entreprises utilisant le code d\'entreprise \'{{enterpriseCode}}\' ET l\'usager \'{{username}}\' ET dont le Service Web de Test est \'{{testMode}}\'?';
  _RetrieveSegmentsConfiguration = 'Récupérer configuration depuis {{payRoll}}';
  RetrieveSegmentsConfiguration = 'Récupérer configuration';

  SyncAPIConfigTip = 'Vous pouvez synchronizer les informations de vos employés quotidiennement et automatiquement.';
  UpdateFromSyncAPITitle = 'Mise à jour des employés de \'{{name}}\'';
  UpdateFromSyncAPIBody = 'Bonjour {{name}},<br> Les informations de vos employés ont été mis à jour.<br>Bonne journée.<br>Votre équipe Emprez.';
  SyncAPIConfigTitle = 'Synchronization'
  SyncAPIConfigIsActive = 'La synchronization est activée'
  ChangePeriod = 'Changer la période';
  OutputType = 'Format';
  Month = 'Mois';
  EmployeesStatus = 'Statut des employés';
  TypeOfAbsence = 'Type d\'absence';
  NbOfAbsences = 'Nombre d\'absences';
  ShowAllAbsences = 'Voir toutes les absences';
  LateArrival = 'Retard';
  LateArrivals = 'Retards';
  LateArrivalsAndHours = 'Retards (HH:MM)';
  NonAuthorizedAbsences = 'Absences non autorisées';
  AuthorizedAbsences = 'Absences autorisées';

  EmployeeHrPerformances = 'Emprez BI: Performances de l\'employé'
  WorkedTS = 'Travail';
  AbsencesTotal = 'Absences';
  EntrainementsAndFormations = 'Entraînements & Formations';


  ACCIDENT_TYPE_CAR_ACCIDENT = 'Accident Automobile';
  ACCIDENT_TYPE_AGGRESSION = 'Agression';
  ACCIDENT_TYPE_ALLERGY = 'Allergies';
  ACCIDENT_TYPE_AMPUTATION = 'Amputation';
  ACCIDENT_TYPE_BURN = 'Brûlure';
  ACCIDENT_TYPE_FALL = 'Chute';
  ACCIDENT_TYPE_CONCUSSION = 'Commotion';
  ACCIDENT_TYPE_FOREIGN_BODY = 'Corps étranger';
  ACCIDENT_TYPE_HEATSTROKE = 'Coup de chaleur';
  ACCIDENT_TYPE_CUT = 'Coupure';
  ACCIDENT_TYPE_COVID_19 = 'Covid-19';
  ACCIDENT_TYPE_DEPRESSION = 'Dépression';
  ACCIDENT_TYPE_PAIN = 'Douleur';
  ACCIDENT_TYPE_DAZZLE = 'Éblouissement';
  ACCIDENT_TYPE_BRUISE = 'Echymose';
  ACCIDENT_TYPE_CONTUSION = 'Contusion';
  ACCIDENT_TYPE_EXCESSIVE_EFFORT = 'Effort Excessif';
  ACCIDENT_TYPE_ELECTROCUTION = 'Électrocution';
  ACCIDENT_TYPE_SWELLING = 'Enflure';
  ACCIDENT_TYPE_SPRAIN_STRAIN_DISLOCATION = 'Entorse/Foulure/Luxation';
  ACCIDENT_TYPE_FRACTURE = 'Fracture';
  ACCIDENT_TYPE_SLIP_STUMBLE = 'Glissade ou trébuchement';
  ACCIDENT_TYPE_HIT_STRANDED = 'Heurté ou Coincé';
  ACCIDENT_TYPE_FIRE_EXPLOSION = 'Incendie ou Explosion';
  ACCIDENT_TYPE_POISONING = 'Intoxication';
  ACCIDENT_TYPE_SUPERFICIAL_LESION = 'Lésion superficielle';
  ACCIDENT_TYPE_DISCOMFORT = 'Malaise';
  ACCIDENT_TYPE_REPETITIVE_MOVEMENT = 'Mouvement répétitif';
  ACCIDENT_TYPE_SURGERY = 'Opération';
  ACCIDENT_TYPE_BITE = 'Piqûre';
  ACCIDENT_TYPE_OPEN_DEEP_WOUND = 'Plaie profonde/ouverte';
  ACCIDENT_TYPE_HARMFUL_SUBSTANCE = 'Substance nocive';
  ACCIDENT_TYPE_OTHER = 'Autre';

  WORK_ACCIDENT_FILE_STATUS_TYPE_OPEN = 'Ouvert';
  WORK_ACCIDENT_FILE_STATUS_TYPE_CONSOLIDATED = 'Consolidé';

  BODY_REGION_TYPE_HEAD = 'Tête';
  BODY_REGION_TYPE_FACE = 'Visage';
  BODY_REGION_TYPE_EYE = 'Yeux';
  BODY_REGION_TYPE_EAR = 'Oreilles';
  BODY_REGION_TYPE_TEETH = 'Dents';
  BODY_REGION_TYPE_NECK = 'Cou';
  BODY_REGION_TYPE_CHEST = 'Poitrine';
  BODY_REGION_TYPE_LEFT_SHOULDER = 'Épaule gauche';
  BODY_REGION_TYPE_RIGHT_SHOULDER = 'Épaule droite';
  BODY_REGION_TYPE_LEFT_ARM = 'Bras gauche';
  BODY_REGION_TYPE_RIGHT_ARM = 'Bras droit';
  BODY_REGION_TYPE_LEFT_ELBOW = 'Coude gauche';
  BODY_REGION_TYPE_RIGHT_ELBOW = 'Coude droit';
  BODY_REGION_TYPE_LEFT_FOREARM = 'Avant-bras gauche';
  BODY_REGION_TYPE_RIGHT_FOREARM = 'Avant-bras droit';
  BODY_REGION_TYPE_LEFT_WRIST = 'Poignet gauche';
  BODY_REGION_TYPE_RIGHT_WRIST = 'Poignet droit';
  BODY_REGION_TYPE_LEFT_HAND = 'Main gauche';
  BODY_REGION_TYPE_RIGHT_HAND = 'Main droite';
  BODY_REGION_TYPE_LEFT_FINGERS = 'Doigts droits';
  BODY_REGION_TYPE_RIGHT_FINGERS = 'Doigts gauches';
  BODY_REGION_TYPE_LEFT_HIP = 'Hanche gauche';
  BODY_REGION_TYPE_RIGHT_HIP = 'Hanche droite';
  BODY_REGION_TYPE_LEFT_THIGH = 'Cuisse gauche';
  BODY_REGION_TYPE_RIGHT_THIGH = 'Cuisse droite';
  BODY_REGION_TYPE_LEFT_KNEE = 'Genou gauche';
  BODY_REGION_TYPE_RIGHT_KNEE = 'Genou droit';
  BODY_REGION_TYPE_LEFT_LOWER_LEG = 'Bas de la jambe gauche';
  BODY_REGION_TYPE_RIGHT_LOWER_LEG = 'Bas de la jambe droite';
  BODY_REGION_TYPE_LEFT_ANKLE = 'Cheville gauche';
  BODY_REGION_TYPE_RIGHT_ANKLE = 'Cheville droite';
  BODY_REGION_TYPE_LEFT_FOOT = 'Pied gauche';
  BODY_REGION_TYPE_RIGHT_FOOT = 'Pied droit';
  BODY_REGION_TYPE_LEFT_TOE = 'Orteils gauches';
  BODY_REGION_TYPE_RIGHT_TOE = 'Orteils droits';

  LESION_TYPE_AGGRAVATION = 'Aggravation';
  LESION_TYPE_GRADUAL_ONSET = 'Apparition graduelle';
  LESION_TYPE_NEARLY_ACCIDENT = 'Quasi-Accident';
  LESION_TYPE_RELAPSE = 'Rechute/Recidive';
  LESION_TYPE_DECEASED = 'Décès';
  LESION_TYPE_PRECISE_AND_SUDDEN_EVENT = 'Évènement précis et soudain';
  LESION_TYPE_PROFESSIONAL_SICKNESS = 'Maladie professionnelle';

  EmployeeWorkAccidents = 'Accidents du travail';
  AccidentDate = 'Date de l\'accident';
  LesionTypes = 'Types de lésion';
  AccidentTypes = 'Types d\'accident';
  BodyRegionTypes = 'Régions du corps';

  HealthFile = 'Dossier Santé-Sécurité';
  HowOccursTheAccident = 'Expliquez comment est survenu l\'accident ou la maladie';
  NbDaysOfAbsence = 'Nombre de jours d\'absences';

  TemporaryAssignment = 'Assignation temporaire';
  TemporaryAssignementNote = 'Commentaires sur l\'assignation temporaire';
  CorrectiveAction = 'Mesures correctives';
  CorrectiveActionNote = 'Commentaires sur les mesures correctives';
  FileStatus = 'Statut du dossier';
  ConsolidationDate = 'Date consolidation';
  DoYouReallyWantToDeleteThisCommand = 'Voulez-vous supprimer la commande \'{{ cmd }}\'? ';
  ZK_PUNCH_COMMAND_STATUS_READY = 'Prête à être envoyée.';
  ZK_PUNCH_COMMAND_STATUS_NEW = 'Nouvelle';
  ZK_PUNCH_COMMAND_STATUS_SENT = 'Envoyée';
  ZK_PUNCH_COMMAND_STATUS_DONE = 'Réponse reçue';
  ZK_PUNCH_MODEL_S900='S900';
  ZK_PUNCH_MODEL_S905='S905';

  CommandRequested = 'Requête';
  CommandStatus = 'État';
  ReturnCode = 'Code de retour';
  CommandReturned = 'Réponse reçue';

  SerialNumber = 'Numéro de série';
  ServerVersion = 'Version du serveur';
  ErrorDelayInSeconds = 'Délai entre les erreurs de connexion (sec.)';
  DelayBetweenServerAccessInSeconds = 'Délai entre les connexions (sec.)';
  DelayClockSyncTimeWithServerInSeconds = 'Délai synchro horloge (sec.)';
  IntervalInMinutesBetweenCheckingAndSendingNewData='Délai Vérif & Envoi (min.)';

  RealTime = 'Temps réel';
  TransmissionTimes = 'Heures de transmission (; max 10)';
  TransFlags = 'Type de transfert'
  MappedValueForCheckIn = 'Correspondance Poinçon \'Arrivée\'';
  MappedValueForCheckOut = 'Correspondance Poinçon \'Départ\'';
  MappedValueForMealStart = 'Correspondance Poinçon \'Début Repas\'';
  MappedValueForMealEnd = 'Correspondance Poinçon \'Fin Repas\'';
  MappedValueForBreakStart = 'Correspondance Poinçon \'Début Pause\'';
  MappedValueForBreakEnd = 'Correspondance Poinçon \'Fin Pause\'';
  MappedValueForWorkCode='Correspondance Poinçon \'Code de travail\' - Uniquement 254 si nécessaire';
  MappedValueForOther='Correspondance Poinçon \'Autre\'';


  BadgeType = 'Type';
  EMPLOYEE_BADGE_TYPE_CARD = 'Carte';
  EMPLOYEE_BADGE_TYPE_CODE_ZK = 'Code ZK';

  LastAttendanceOK = '<span class="emprez-vert-agrume">Dernière transmission des poinçons {{dt}}.</span>';
  LastAttendanceWarning = '<span class="emprez-orange-fiesta">Dernière transmission des poinçons {{dt}}.</span>';
  LastAttendanceError = '<span class="emprez-rouge-matador">Dernière transmission des poinçons {{dt}}.</span>';
  LastClockSyncOK = '<span class="emprez-vert-agrume">Dernière synchronization de l\'horloge {{dt}}.</span>';
  LastClockSyncWarning = '<span class="emprez-orange-fiesta">Dernière synchronization de l\'horloge {{dt}}.</span>';
  LastClockSyncError = '<span class="emprez-rouge-matador">Dernière synchronization de l\'horloge {{dt}}.</span>';

  LastHeartBeatOK = '<span class="emprez-vert-agrume">Dernière apparition {{dt}}.</span>';
  LastHeartBeatWarning = '<span class="emprez-orange-fiesta">Dernière apparition {{dt}}.</span>';
  LastHeartBeatError = '<span class="emprez-rouge-matador">Dernière apparition {{dt}}.</span>';

  ZkWorkCode = 'Code de travail';
  DoYouReallyWantToDeleteThisWorkCode = 'Voulez-vous supprimer le code {{code}} pour le poste {{jobLabel}}?';
  SessionLostPleaseReconnect = 'La session a expirée. Vous devez vous reconnecter pour continuer.';
  EditZkPositionWorkCode = 'Code de travail';

  GenerateCommandsForEmployees = 'Commandes \'Employé\'';
  GenerateCommandsForPositions = 'Commandes \'Code de travail\'';
  GenerateCommandsForFunctionKeys='Commandes \'Interface\'';
  NoCommandsFound = 'Aucune commande';
  ToBeRemovedFromZkPunch = 'À supprimer du poinçon';
  RemoveFromZkPunch = 'Supprimer du poinçon';

  Performances = 'Emprez BI';
  Actives = 'Actifs'
  Inactives = 'Inactifs';
  NewPlural = 'Nouveaux';
  TerminatedPlural = 'Terminés';

  IndustryClassification = 'Classification';
  MANUFACTURING_31 = 'Fabrication - Usine';
  CAR_AND_PART_DEALER_441 = 'Vente automobiles et/ou pièces';
  GROCERIES_445 = 'Épicerie';
  PHARMACIES_446 = 'Pharmacie';
  SPORTING_HOBBY_STORE_451 = 'Magasin de sports, hobby'
  GENERAL_STORE_452 = 'Magasin Général ou Grande Surface'
  TRANSPORT_48 = 'Transport';
  TRANSPORT_AIR_481 = 'Transport aérien';
  TRANSPORT_WATER_483 = 'Transport fluvial';
  TRANSPORT_TRUCK_484 = 'Transport routier';
  WAREHOUSE_493 = 'Entrepôt';
  DESIGN_SERVICE_5414 = 'Service de design';
  VETERINARY_SERVICE_54194 = 'Vétérinaire';
  NURSING_RESIDENTIAL_FACILITIES_623 = 'Résidence';
  PHYSICIANS_OFFICES_6211='Cabinet de Médecins';
  FOOD_SERVICES_AND_DRINKING_PLACES_722='Services de restauration et débits de boissons';
  PERSONAL_CARE_SERVICES_8121='Services de soins personnels';

  UNKNOWN = 'Inconnu';
  EditStructureAndDivision = 'Click pour visualiser et modifier la structure. Shift+Click pour modifier la division uniquement.';
  EmployeePerformancePerMonth = 'Performances mensuelles de ';
  AbsencesRatio = 'Absentéisme';
  LateArrivalRatio = 'Taux de retard';

  PerformanceModuleReports = 'Rapports - Emprez BI';
  PerformanceModuleDashboard = 'Emprez BI';
  NoInformationFound = 'Aucune information';
  RetrieveCommitmentFile = 'Télécharger le document';
  DoYouReallyWantToDeleteAllTheTemplates = 'Voulez-vous supprimer tous les gabarits?';
  ExtendedMeals = 'Repas';
  ExtendedMealsAndHours = 'Repas (HH:MM)';
  ExtendedMealsTip = 'Repas trop longs';
  ExtendedBreaks = 'Pauses';
  ExtendedBreaksAndHours = 'Pauses (HH:MM)';
  ExtendedBreaksTip = 'Pauses trop longues';
  LateDepartures = 'Fins de quart';
  LateDeparturesAndHours = 'Fins de quart (HH:MM)';
  LateDeparturesTip = 'Fins de quart retardées';


  TotalMoreTSThanScheduledInMin = 'Heures travaillées qui excèdent l\'horaire';
  TotalMoreTSThanScheduled = 'Feuilles de temps dont les heures travaillées excèdent l\'horaire';
  NumberOfMoreTSThanScheduled = 'Nombre de FDTs avec un excès';
  NumberOfMoreTSThanScheduledInMin = 'Durée totale (hh:mm)';
  MoreTSThanScheduled = 'Excès';
  MoreTSThanScheduledTip = 'Heures travaillées qui excèdent l\'horaire prévu.';
  NewPluralTip = 'Nouveaux employés qui commencent ce mois-ci.'
  TerminatedPluralTip = 'Employés qui quittent leur emploi ce mois-ci.';
  TotalAbsenteeism = 'Absentéisme (%)';
  EmployeeIsIncludedInPerformanceRH = 'Inclus dans Emprez BI';

  JobNumbersNoSegment = 'Numéro de travail';
  PasswordsAreHiddenForThisEnterprise = 'Les mots de passe sont cachés pour cette entreprise';
  PasswordsAreHidden = 'Les mots de passe sont cachés';
  UsernamesAreHidden = 'Les usagers sont cachés';
  PunchBadgesAreHidden = 'Les badges pour poinçonner sont cachés';
  EmployeeDOBHidden = 'Les dates de naissance sont cachées';
  EmployeeAddressHidden = 'Les adresses sont cachées';
  EmployeeGenderHidden='Les genres sont cachés';
  EmployeeCityHidden = 'Les villes sont cachées';
  EmployeePostalCodeHidden = 'Les codes postaux sont cachés';
  EmployeeProvinceOrStateHidden = 'Les provinces sont cachées';
  EmployeeCountryHidden  = 'Les pays sont cachés';
  EmployeeEmailHidden = 'Les emails sont cachés';
  EmployeeTelephoneHidden = 'Les téléphones sont cachés';

  SetAnExpiryDateOnSelection = 'Date d\'expiration sur la sélection';
  DeactivateSelection = 'Désactiver la sélection';
  ActivateSelection = 'Activer la sélection';
  NeedsToSelectSomeModules = 'Vous devez sélectionner un ou plusieurs modules.';
  CanLockTimesheet = 'Peut verrouiller les FDTs';
  CanUnlockAllTimesheet = 'Peut déverrouiller toutes les FDTs';
  LockAllTip='Verrouiller toutes les FDTs approuvées';
  UnLockAllTip='Déverrouiller (selon vos droits) les FDTs';
  LockAllExpenseTip='Verrouiller toutes les dépenses approuvées';
  UnLockAllExpenseTip='Déverrouiller (selon vos droits) les dépenses';


  LockAllTimesheets='Verrouiller les FDTs';
  LockAllExpenses = 'Verrouiller les dépenses';
  ExportOnlyExpenses = 'Exporter seulement les dépenses';

  ExplainLateArrival = 'Explication de l\'arrivée en retard (V3)';
  ExplainEarlyDeparture = 'Explication du départ en avance (V3)';
  ExplainLateDeparture= 'Explication du départ en retard (V3)';

  AlwaysExplainArrival = 'Toujours expliquer Arrivée (V3)';
  AlwaysExplainDeparture = 'Toujours expliquer Départ (V3)';
  ExplicationsDeparturePipedSeparated ='Explications Départ (V3)'
  ExplicationsArrivalPipedSeparated ='Explications Arrivée (V3)'
  AlwaysExplainTaskBeginning='Toujours expliquer Début de tâche (V3)';
  AlwaysExplainTaskEnding='Toujours expliquer Fin de tâche (V3)';



  MsgNotRead='Message non-lu';
  SeeTheWholeMemoThread='Afficher le fil des messages';
  ShiftClickToActivateDeactivateSelection='Activer une sélection, Shift+Click pour désactiver une sélection';
  ActivateSurveyAggregations='Activer une sélection';
  DeactivateSurveyAggregations='Désactiver une sélection';
  TheSelectedUserHasAccessToTheFollowing='Liste des accès de l\'usager sélectionné';
  ModuleExpiredOn='Accès au module jusqu\'au {{expiryDt}}.';
  AccessToModule='Accès au module';
  DetailsButtonExplanation='\'Détails\' montre les employés responsables de ces situations.';
  NbOfTimesheets='Nombre de feuille de temps';
  NbOfAbsencesInPercentage='Ratio d\'absences';
  NbOfAbsencesInPercentageEmprezIndice='Indice Emprez';
  HowToImproveTheSituation="Comment améliorer cette situation";
  HowToImproveTheSituationForTooLongMeals="Vos employés ne poinçonnent pas les repas?";
  HowToImproveTheSituationForTooLongBreaks="Vos employés ne poinçonnent pas les pauses?";
  ThisIsWhyTheyShould="Voici pourquoi ils devraient.";
  ClickHere='Cliquez ici.';

  ExplainWhyTSHaveToBeApproved='Afin d\'obtenir le bon calcul, il est primordial que les feuilles de temps soient bien approuvées.';
  HowToDoItWell='Comment bien le faire.';
  AbsenteismForThePeriod='Taux d\'absentéisme pour la période';
  AbsenteismForThePeriodEmprezIndice='Indice Emprez';
  TotalHoursScheduled='Heures prévues';
  TotalHoursApproved='Heures approuvées';
  ExtraTS='Heures excédentaires';
  ExtraTSRatio='Heures excédentaires (%)';
  ExtraTSRatioEmprezIndice='Indice Emprez (%)';

  WhyBreaksShouldBePunched='Pourquoi les pauses devraient être poinçonnées?';
  EmprezIndice='Indice Emprez';
  NbOfLateArrivals='Retards durant la période';
  NbOfLateArrivalsInPercentage='Retards en %';
  AverageLateArrivalInMin='Durée moyenne des retards';

  NbOfLateDepartures='Fins de quarts retardées durant la période';
  NbOfLateDeparturesInPercentage='Fins de quarts retardées en %';
  AverageLateDepartureInMin='Durée moyenne des fins retardées'

  NbOfExtendedMeals='Repas trop longs durant la période';
  NbOfExtendedMealsInPercentage='Repas trop longs en %';
  AverageExtendedMealInMin='Durée moyenne des dépassements';
  NbOfExtendedBreaks='Pauses trop longues durant la période';
  NbOfExtendedBreaksInPercentage='Pauses trop longues en %';
  AverageExtendedBreakInMin='Durée moyenne des dépassements';

  CreateAZkPunch='Créer un horodateur ZK';
  EditPunchNow='Paramétrez l\'horodateur';
  EmployeesResponsibleOfThisSituation='Employés responsables de cette situation';
  ReportAbsenteismPerMonthPerUnit='Rapport: Taux d\'absentéisme par mois, par département.';
  ReportLateArrivalPerMonthPerUnit='Rapport: Taux de retards par mois, par département.';
  ReportLateDeparturePerMonthPerUnit='Rapport: Fins de quarts retardées par mois, par département.';
  EditZkPunchCommand='Commande ZK';
  ModuleIsExpiredTheFeaturesAreLimited='Le module étant expiré, les fonctionnalités sont limitées.';
  YourCommentsHere='Vos commentaires ici!';

  VerifySchedulesErrorsTip='Vérifier s\'il y a des erreurs dans les horaires';
  Verify='Vérifier';
  Leading0AreRemovedFromZkCard='Tous les \'0\' au début des codes pour les cartes ZK sont automatiquement supprimés.';

  IncludeRoleAdmin='Afficher \'Administrateurs\'';
  IncludeRoleLimitedAdmin='Afficher \'Admin. (Limité)\'';
  IncludeRoleResponsable='Afficher \'Responsables\'';
  IncludeRoleLimitedResponsable='Afficher \'Resp. (Limité)\'';
  IncludeRoleEmployee='Afficher \'Employés\'';
  NotifyEmployeeTip='Envoyer un message par courriel ou dans l\'application mobile.';
  EmailIsNotValid='Le courriel n\'est pas valide, seule la notification par le mobile sera utilisée.';
  WhatMightHelp='Cliquer ici pour voir comment résoudre cette erreur.';
  ExpectingAnswer='Pas encore de réponse.';
  PriorityOnThePosition='Priorité sur le poste: ';
  FirstDayCSST = '1er jour CSST';

  Range1='Premiere partie';
  Range1Name='Nom (Rapport)';
  Range1Active= 'Actif';
  Range1ExportCode='Code Paie';
  Range1StartInMin='Début (ex: 10)';
  Range1EndInMin='Fin (ex: 120)';
  ConditionAmount='HH:mm';
  Range2='Deuxième partie';
  Range2Name='Nom (Rapport)';
  Range2Active= 'Actif';
  Range2ExportCode='Code Paie';
  Range2StartInMin='Début (ex: 10)';
  Range2EndInMin='Fin (ex: 120)';

  CumulativePremiumConfiguration6001='Configuration de la prime';
  CumulativePremiumConfiguration6002='Configuration de la prime';
  CumulativePremiumConfiguration6003='Configuration de la prime';
  CumulativePremiumConfiguration6004='Configuration de la prime';
  CumulativePremiumConfiguration6005='Configuration de la prime';
  CumulativePremiumConfiguration6006='Configuration de la prime';
  CumulativePremiumConfiguration6007='Configuration de la prime';
  CumulativePremiumConfiguration6008='Configuration de la prime';
  CumulativePremiumConfiguration6009='Configuration de la prime';

  RemoveMinutePartCumulativePremiumConfiguration6008='Configuration des minutes à supprimer';
  CumulativePartOfCumulativePremiumConfiguration6008='Configuration de la prime cumulative';


  CCP6000_MainExplanation='Cette prime permet de calculer le temps supplémentaire quotidien et hebdomadaire.<br><i>Le temps supplémentaire quotidien qui sera payé ne sera pas comptabilisé une deuxième fois dans le temps supplémentaire hebdomaire.</i><br>';
  CCP6000_DailyWithCondition='<b>Prime quotidienne</b> de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures est {{condition}}. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).';
  CCP6000_WeeklyWithCondition='<b>Prime hebdomadaire</b> de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures est {{condition}}. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).';

  CCP6001_MainExplanation ='Cette prime se déclenche pour les horaires de type {{schedules}}, lorsque le total {{period}} des heures est {{condition}}.<br>';
  CCP6001_Range='Prime de {{bonus}} lorsque le total {{period}} est compris entre {{startMin}} min. et {{endMin}} minutes. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).' ;
  CCP6001_Range_Unlimited='Prime de {{bonus}} lorsque le total {{period}} est plus de {{startMin}} minutes. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).' ;

  CCP6002_MainExplanation='Cette prime permet de calculer le temps supplémentaire quotidien et hebdomadaire pour les horaires de type {{schedules}}, lorsque le total quotidien des heures est {{dailyCondition}} et/ou lorsque le total hebdomadaire est {{weeklyCondition}}.<br><i>Le temps supplémentaire quotidien qui sera payé ne sera pas comptabilisé une deuxième fois dans le temps supplémentaire hebdomaire.</i><br>';
  CCP6002_Range_Daily='Prime de {{bonus}} lorsque le total quotidien est compris entre {{startMin}} min. et {{endMin}} minutes. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).' ;
  CCP6002_Range_Daily_Unlimited='Prime de {{bonus}} lorsque le total quotidien est plus de {{startMin}} minutes. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).' ;
  CCP6002_Range_Weekly='Prime de {{bonus}} lorsque le total hebdomadaire est compris entre {{startMin}} min. et {{endMin}} minutes. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).' ;
  CCP6002_Range_Weekly_Unlimited='Prime de {{bonus}} lorsque le total hebdomadaire est plus de {{startMin}} minutes. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).' ;

  CCP6003_MainExplanation ='Cette prime se déclenche pour les horaires de type {{schedules}}, lorsque le total {{period}} des heures est {{condition}}. La différence sera multipliée par {{multiplier}} puis ajouté à la banque {{bankName}}<br>';

  CCP6004_MainExplanation='Cette prime permet de calculer le temps supplémentaire quotidien et bimensuel (15 jours).<br><i>Le temps supplémentaire quotidien qui sera payé ne sera pas comptabilisé une deuxième fois dans le temps supplémentaire bimensuel (15 jours).</i><br>';
  CCP6004_DailyWithCondition='<b>Prime quotidienne</b> de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures est {{condition}}. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).';
  CCP6004_WeeklyWithCondition='<b>Prime bimensuelle (15 jours)</b> de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures est {{condition}}. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).';

  CCP6005_MainExplanation='Cette prime permet de calculer le temps supplémentaire.<br><i>Le temps supplémentaire est calculé UNIQUEMENT par quart de travail.</i><br>';
  CCP6005_Condition='<b>Prime</b> de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le temps approuvé du quart de travail est {{condition}}. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).';

  CCP6006_MainExplanation='Cette prime est calculée si la condition est remplie et qu\'une feuille de temps existe le {{specialBonusDay}}.<br>';
  CCP6006_Condition='<b>Prime</b> de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures de la semaine précédent le {{specialBonusDay}} est {{condition}}. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).';

  CCP6007_MainExplanation='Cette prime retirera {{minToRemove}} minutes si la condition est remplie.<br>';
//  CCP6007_Condition='La <b>prime</b> va retirer {{minToRemove}} minutes pour les horaires de type {{schedules}}, lorsque le total quotidien des heures est {{condition}}. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).';
  CCP6007_Condition='La <b>prime</b> va retirer {{minToRemove}} minutes pour les horaires de type {{schedules}}, lorsque le total quotidien des heures est {{condition}}.';

  CCP6008_MainExplanation='Cette prime retirera {{minToRemove}} minutes par feuille de temps si la condition est remplie, PUIS calculera la prime cumulative.<br>';
  CCP6008_RemoveCondition='La <b>prime</b> va retirer {{minToRemove}} minutes pour les horaires de type {{schedules}}, lorsque le total quotidien des heures est {{condition}}.';
  CCP6008_CumulativeCondition='<b>Prime {{period}}</b> de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures est {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';

  CCP6009_MainExplanation='Cette prime retirera {{minToRemove}} minutes par feuille de temps si la condition est remplie, PUIS calculera le temps supplémentaire quotidien et hebdomadaire.<br><i>Le temps supplémentaire quotidien qui sera payé ne sera pas comptabilisé une deuxième fois dans le temps supplémentaire hebdomaire.</i><br>';
  CCP6009_RemoveCondition='La <b>prime</b> va retirer {{minToRemove}} minutes pour les horaires de type {{schedules}}, lorsque le total quotidien des heures est {{condition}}.';
  CCP6009_DailyWithCondition='<b>Prime quotidienne</b> de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures est {{condition}}. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).';
  CCP6009_WeeklyWithCondition='<b>Prime hebdomadaire</b> de {{bonus}}, pour les horaires de type {{schedules}}, lorsque le total des heures est {{condition}}. (Code paie: {{codeForPay}}, Description paie: {{labelForPay}}).';




  ExportCode='Code Paie';
  SpecialBonusDay='Jour de la Prime';

  NoEmployeeToCreate='Aucun employé à créer.';
  FakeLastName='Masqué';

  ChangePasswordNextLogin='L\'employé devra changer son mot de passe à la prochaine connexion.';
  ManageRightsOnCustomReports='Gestion des accès aux rapports personnalisés';
  EditCustomReportRightsForUser='Modifier les accès pour un usager';
  EmployeeLastName='Nom';
  EmployeeFirstName='Prénom';
  ReportCode='Code du rapport';
  IncludeApprovedTS='Inclure les FDTs déjà approuvées';
  IncludeApprovedExpenses='Inclure les dépenses déjà approuvées';

  ExportToPDF='Exporter en PDF';
  Week1='Semaine 1';
  Week2='Semaine 2';

  UseDivisionProvinceAndCountryForSubDivisions='Remplacer le pays et la province pour toutes les unités de cette division';
  LeftInBank='<b>{{bankName}}</b>: <span class="muted">{{leftInMinutes}}</span>';
  SendCredentialsByEmailBatch='Envoyer les informations de connexion par courriel ou imprimer en PDF';
  Send='Envoyer';
  ForceNewPasswordAfterNextLogin='MdP expire';
  ForceNewPasswordAfterNextLoginTip='L\'usager devra changer son mot de passe à la prochaine connexion.';
  DoYouReallyWantToDeleteTheGroupOfEnterprise='Voulez-vous vraiment supprimer ce groupe \'{{name}}\' ?';
  ListOfGroupOfEnterprise='Groupes d\'entreprises - {{nb}} groupe(s)';
  GroupId='Identifiant';
  Name='Nom';
  SynchroAutomatiquePerEnterprise='Synchronisation automatique par entreprise';
  UseAddressFromAPI='Utiliser l\'adresse de l\'employé du service Web';
  UseDOBFromAPI='Utiliser la DDN de l\'employé depuis du service Web';
  ZkPunchModel='Modèle';
  Weeks='Semaines';
  SelectAllWeeks='Sélectionner toutes les semaines';
  ActivateCopiedSchedules='Publier tous les horaires copiés';
  MaxInactivityInDaysForManagers='Inactivité max pour les managers (jours)';
  PunchesPerEntity='Horodateurs par entité';
  NbDistinctEmployeesWithApprovedTS='Nb Employés avec au moins 1 FDT approuvée';

  DeleteTask='Supprimer le projet';
  ModifyTask='Modifier le projet';
  EmployeesOnTheTask='Ajouter ou supprimer des employés du projet';
  DetailsOfTheTask='Avancement du projet';

  AddingToBankTypes='Ajouts aux banques de temps personnalisées';
  WeAreRemovingFromTSToAddToBank='On enlève {{hoursToRemove}} depuis les {{fromTSType}}, on ajoute {{addToBank}} à la banque {{bankName}}';
  ValueToSubstractInMinStr='Valeur HH:MM à soustraire';

  NewServiceForSagesFromPJC='Nouveau protocole de communication pour Sages par le Centre RX - (Début 16 avril 2022)';
  MemoExpiresOn='Expire le ';

  EmployeeWhoseScheduleOrTimesheetHasDeleted='Employé dont l\'horaire ou la FDT ont été supprimés';
  EmployeeThatDeletedScheduleOrTimesheet='Employé qui a supprimé l\'horaire ou la FDT';
  searchScheduleFromDate='Horaire ou FDT à partir du ';
  searchScheduleToDate='Horaire ou FDT jusqu\'au';
  DeletedBy='Suppr. par';
  DeletedWhen='Suppr. le';
  ScheduleTime='Horaire';
  TotalAmount='Total ($)';
  DeletedScheduleAndTimesheet='Horaire/FDT suppr.';
  ListHolidayBanks='Liste des banques de vacances';
  HolidayBanks='Banque de vacances';
  HolidayBankId='Id';
  HolidayBankPeriodStart='Début';
  HolidayBankPeriodEnd='Fin'
  AccumulatedAmount='Mont. Acc.';
  VacationInDays='Nb jours';
  VacationsBalanceInMinutes='Solde (min)';
  VacationsInMinuteAverageRate='Taux moyen';
  DoYouReallyWantToDeleteThisVacationBank='Voulez-vous supprimer cette banque (id: {{id}}) ?';
  DeleteHolidayBank='Supprimer';
  Phones='Téléphones';
  ListSyncAPIConfig='Synchro API';
  NoSyncAPIConfigFound='Aucune configuration';
  LastRunDate='Dernière exécution';
  NextRunDate='Prochaine exécution';
  RunAroundTime='Heure approximative de la prochaine exécution';
  DisplayLastRunDetails='Afficher les détails de la dernière exécution';
  NoSyncAPIDetailFound='Aucun détail';
  EmployeeFullName='Nom complet';

  CollapseDivisionsTip='Plier ou déplier les divisions';
  CollapseDivisions='Plier / Déplier';
  AccessTokenIsNotAuthorizedYet='Token d\'accès non disponible';
  PotentialEnterprises='Entreprises qui sembleraient être liées... (À vérifier)';
  PotentialDivisions='Divisions qui sembleraient être liées... (À vérifier)';

  ExpenseDate='Date';
  ExpenseType='Type';
  EditExpenseType='Type de dépense';
  EditExpense='Dépense à rembourser';
  NbUnitWithUnitName='Valeur de la dépense en ';
  NoExpensesFound = 'Aucune dépenses';
  AddExpenseFiles = 'Ajouter fichiers (Optionnel, 5 fichiers maximum) ';
  DoYouReallyWantToDeleteThisExpense='Voulez-vous supprimer cette dépense?';
  ExpenseHasFiles= 'Téléchargez les fichiers joints';
  DoYouReallyWantToDeleteThisExpenseFile='Voulez-vous supprimer ce fichier? Cela ne pourra pas être annulé.';
  AllUpdateZoho = 'Mettre à jour Zoho pour toutes les entreprises actives avec un lien Zoho';
  ZohoSynchroResults = 'Résultats des synchronizations avec Zoho';
  ExpenseTypes='Gestion des types de dépenses';
  Expenses='Dépenses';
  CanAddExpenses='Peut ajouter des dépenses.';
  CanManageExpenseType='Peut gérer les types de dépenses';
  valuePerUnit='Valeur par unité';
  unitName='Unité';
  UpdateAllActiveEnterpriseWithZohoAccess='Mettre à jour Zoho pour toutes les entreprises actives';
  UpdatingZoho='MAJ Zoho';
  UpdatingBilling='MAJ Facture périodique';

  ToBeDeleted='À supprimer (incluant tous les employés et leurs FDTs)';
  ScheduledToBeDeletedAfterDate='Suppression prévue le ou à partir du';
  WillBeDeactivatedOnDate='Se désactivera au premier login le :'

  EnterpriseToBeDeleted='Entreprises à supprimer';
  PageMissing='Page non trouvée.';
  PreviousSearch='Dernière Recherche';
  ParamsProfileIsMandatoryWhenCreatingEmployee = 'Le profil de paramètres est obligatoire à la création d\'employés.';
  DoYouReallyWantToDeleteThisBankTypeEmployee='Voulez-vous supprimer cette banque pour la période sélectionnée?';
  DoYouReallyWantToDeleteThoseSickDays='Voulez-vous supprimer cette période sélectionnée?';
  DoYouReallyWantToDeleteThoseFamilyDays='Voulez-vous supprimer cette période sélectionnée?';

  DoYouReallyWantToDeleteThoseVacations='Voulez-vous supprimer cette période sélectionnée?';
  ClientName='Nom du client';
  Create='Créer';
  EditEnterprise = 'Modifier l\'entreprise';
  GenerateAutomaticSchedules = 'Remplir les horaires suivant les préférences';
  PositionDescription='Postes';
  RestartCamera='Redémarrage Camera (V8)';
  DisplayTimerForMealsAndBreaks='Affichage du chronomètre pour les pauses et les repas (Virtual)';
  EmployeeWithNoLogin='Employés - Accès aux applications & Encryption des mots de passe';
  CanAccessApplications='Accès Applications';
  LastLogin = 'Dernier Login'
  noLoginSince='Aucun login depuis';
  CantConnectApplications='Pas de connexion aux applications (portail, client, mobile,...)';
  OnlyEmployeeWithNoLogin='Seulement les employés qui ne se sont jamais connectés auparavant.';
  ChangePasswordAtFirstLogin='L\'usager changera son mot de passe';
  SendConnectionInformationByEmail='Envoyer les informations de connection par email';
  EncryptPasswordForSelectedEmployees='Encrypter mdp Sélection';
  IncludeEmployeeWithAnEncryptedPassword = 'Inclure les employés avec un mot de passe encrypté';
  TotalDestructionOfEnterpriseAndEmployees='Destruction totale de l\'entreprise et de tous ses employés';
  DeleteEnterpriseTitle='Suppression de l\'Enterprise';
  DeleteForReal='Suppression complète de TOUTE l\'information associée à cette entreprise.';

  AddEnterpriseStatutoryHoliday='Ajouter un jour férié';
  CopyHolidaysBetweenEnterprises='Copier les jours fériés entre les entreprises';
  EnterpriseStatutoryHoliday = 'Jour férié';
  StatutoryHolidayDate = 'Date du jour férié';
  ShiftClickToLoadPastDates='Shift+Click pour charger les dates dans le passé';
  DoYouReallyWantToDeleteThisHoliday='Voulez-vous supprimer ce jour férié?';
  CopyStatutoryHolidays='Copier les jours fériés';
  FromEnterprise='Depuis l\'entreprise';
  ToEnterprise='Vers l\'entreprise';
  Copy='Copier';

  DoYouReallyWantToDeleteTheSpifType='Voulez-vous supprimer le type \'{{name}}\'?';
  SpifOwner='Auteur';
  UsersWithAccessToSpifType= 'Usagers pouvant utiliser ce type';
  AddSpifType='Ajouter';
  SearchUnsubscribedEmails='Recherche des courriels désabonnés';
  EnterUnsubscribedEmail='Entrer le courriel à rechercher';
  SearchEvents='Recherche des évènements';
  EnterEmail='Entrer le courriel associé aux évènements recherchés';
  NoEmailsFound='Aucun courriel.';
  DashboardPreferences='Tableau de bord';
  OtherPreferences='Autres';
  Speed='Test de vitesse';
  SpeedTestIn='Test réalisé en {{ms}} milliseconds.';
  DeleteSchedules='Supprimer les horaires';

  Evaluation='Évaluation';
  EvaluationsManager='Gestionnaire des modèles d\'évaluations';
  AddEvaluationAggregation='Ajouter modèle d\'évaluation';
  DoYouReallyWantToDeleteTheEvaluationAggregation='Voulez-vous supprimer ce modèle?';

  EVALUATION_QUESTION_TYPE_YES_NO = 'Oui/Non';
  EVALUATION_QUESTION_TYPE_CHECK_CHOICE = 'Multi-Choix';
  EVALUATION_QUESTION_TYPE_RADIO_CHOICE = 'Multi-Choix (Exclusif)';
  EVALUATION_QUESTION_TYPE_ONE_TO_FIVE = 'Échelle 1 à 5';
  EvaluationTitle='Titre';
  EvaluationCreatedBy='Créé par';
  EvaluationNbQuestions='Nb Questions';
  EvaluationAggregationTitle='Modèle d\'évaluation';
  CanManageEvaluation='Gestion des modèles d\'évaluations';
  CanSendMemoToSameLevelUser='Messagerie avec les usagers de même niveau';

  EmployeeEvaluations='Évaluations de l\'employé';
  DueDate='Échéance';
  EvaluationEmployee='Paramètres du modèle d\'évaluation';
  EvaluateEvaluationEmployee = 'Évaluation de l\'employé';
  EditEvaluationTemplate='Modifier les paramètres du modèle d\'évaluation';
  EvaluateTheEmployee='Évaluer l\'employé';
  StartEvaluation='Commencer';
  NoteFromEmployee='Note (Employé)';
  NoteFromManager='Note (Evaluateur)';
  EvaluationIsComplete='L\'évaluation est complète';
  NoteFromAssessor='Note globale pour l\'évaluation';
  AddEvaluationFiles = 'Ajouter fichiers (Optionnel, 5 fichiers maximum) ';
  EvaluationHasFiles= 'Téléchargez les fichiers joints';
  DoYouReallyWantToDeleteThisEvaluationFile='Voulez-vous supprimer ce fichier? Cela ne pourra pas être annulé.';
  YES='Oui';
  NO='Non';
  TemplateType='Modèle';
  CreateStandard='Modèle standard';
  CreateStandardTip='Créer un modèle selon un standard défini';
  ResetEvaluationEmployee='Refaire l\'évaluation en supprimant les réponses.';
  DoYouReallyWantToResetTheEmployeeEvaluation='Voulez-vous supprimer les réponses de cette évaluation \'{{name}}\'?';
  NotCompleted = 'Non Complet';
  StronglyDisagree='Fortement en désaccord';
  Disagree='Désaccord';
  NotAgreeNorDisagree='Neutre'
  Agree='En accord';
  StronglyAgree='Tout à fait d\'accord';
  NoAnswerForThisQuestion='Pas de réponse à cette question';
  QuestionIsInactive='Inactive';
  DoYouReallyWantToDeleteTheEmployeeEvaluation='Voulez-vous supprimer cette évaluation?'
  DoYouReallyWantToDeleteAllTheEmployeeEvaluations ='Voulez-vous supprimer TOUTES ces évaluations?';

  NoTimesheetSummaryFound='Aucun sommaire de feuilles de temps. Vous n\'avez probablement pas encore de feuilles de temps pour cette période.';
  HumanResourceReports='Rapports - Ressources Humaines';
  ClickToSort='Cliquez pour trier';
  '5IsABetterGradeThan1'='note: 5 est une meilleure note que 1';
  FnamePreferred='Prénom usuel';
  CloneEmployeePositions='Copier les postes d\'un employé';
  SelectPositionsYouWantToCopy='Sélectionnez les postes à copier';
  CopyJobsFromAnotherEmployee='Copier les postes d\'un autre employé';
  ShowHideEmployeeNoSchedules='Cacher/Afficher les employés sans horaire';
  SearchAhead='Rechercher dans la liste...';
  Next='Suivant';
  Finish='Terminer';
  CalculateDailyBeforeWeekly='Calculer les primes quotidiennes avant les primes hebdomadaires';
  MinuteScheduledAndPublished = '{{scheduled}} prévues: {{published}} publiées + <span class="emp-parme">{{notPublished}} non publiées</span>.';
  MinuteScheduled = '<span class="emprez-vert-agrume">{{scheduled}} prévues et publiées.</span>';
  MinuteScheduledAndPublishedWithAmount='{{scheduled}} ({{scheduledAmount}}) prévues: {{published}} ({{publishedAmount}}) publiées + <span class="emp-parme">{{notPublished}} ({{notPublishedAmount}}) non publiées</span>.';
  MinuteScheduledWithAmount='<span class="emprez-vert-agrume">{{scheduled}} ({{scheduledAmount}}) prévues et publiées.</span>';
  EmployeeNotifications='Notifications reçues';
  SentDate = 'Date Soumission';
  NoNotificationsFound='Aucune notifications';
  EmployeeMemberOfGroups='Membre des groupes';
  ViewGroup='Voir le groupe';
  RemoveFromGroup = 'Supprimer du groupe';
  DoYouReallyWantToRemoveTheEmployeFromGroup='Voulez-vous vraiment supprimer l\'employé du groupe \'{{groupName}}\'?';
  ChooseGroup='Choisir un groupe';
  Group = 'Groupe';
  YouAreNotTheOwnerOfThisGroup='Vous n\'êtes pas propiétaire du groupe.';
  CreateANewGroup='Créer un nouveau groupe';
  RequestList='Requêtes reçues';

  Presences = 'Présences actuelles';
  PresencesMightBeDelayed='Les présences dépendent des informations envoyées par les horodateurs. Un délai de 15 min est à prévoir dépendamment de leurs configurations.'
  Unit = 'Unité';
  ScheduledStart='Début prévu';
  PunchedStart='Début poinçonné';
  PunchedStartWithAdjustment = 'Début poinçonné (Arrondi)';
  WhoIsPresentNow='Présences actuelles';
  NoPresencesFound='Aucune présence pour le moment';
  YouCantSelectThisGroupYouDontHaveTheOwnership='Vous ne pouvez pas utiliser ce groupe. Vous devriez demander à son propriétaire \'{{owner}}\'.';
  DoYouReallyWantToDeleteCurrentScheduleFor='Voulez-vous supprimer les horaires courants de {{employee}}?';
  NoNotesFound='Aucune notes.';

  SchedulesPlanningNG = 'Plans';
  SchedulesPerEmployeesNG = 'Employés';
  SchedulesPerJobsNG = 'Structure';
  SchedulesForOneJobNG = 'Poste';
  Tools = 'Outils';
  AliasManagerNG = 'Quarts prédéfinis';
  CostManagement = 'Gestion des coûts';
  EventManagementNG = 'Évènements';
  BudgetManagementNG='Budgets';
  SalesCostManagementNG = 'Ventes';
  AddOrRemoveInBatch='Ajouts et suppressions en lot';
  AddJobInBatchNG ='Postes';
  AddHourlyBonusInBatchNG='Primes horaires';
  AddOrModifyEmployeeBadgeNG='Badges';
  AddCumulativeBonusInBatchNG='Primes cumulatives';
  CreateOrDeleteVacationRecordNG='Vacances';
  CreateOrDeleteSickDaysNG='Jours de maladie';
  CreateOrDeleteFamilyDaysNG = 'Journées Familiales';
  CreateHolidaysNG='Jours fériés';
  AddOrDeleteBankTypeEmployeeInBatchNG='Banques personnalisées';
  AddSpifInBatchNG='Bonus';
  ModifyInBatch='Modifications en lot';
  UpdateSalaryInBatchNG='Salaire';
  UpdateVisibleEmployeeNG='Visibilité';
  ModifyLevelJobInBatchNG='Échelon';
  ModifyEmployeeSortOrderInBatchNG='Ordre de tri';
  VerificationExportAndUpdate='Usage périodique';

  ManagementOf='Gestionnaires';
  BonusManagementShort = 'Primes';
  SpifTypeManagementShort='Types de Bonus';
  ParamsProfileManagerShort='Profils de paramètres';

  NamedWorkshiftsShort='Quarts prédéfinis';
  SurveyManagerShort='Enquêtes';
  GeoFenceManagerShort='Zones GPS';
  BankManagerShort='Banques de temps personnalisées'
  BankManagerShort2='Banques personnalisées'
  BankTypeTransactionsShort='Transactions dans les banques de temps personnalisées'
  BankTypeTransactionsShort2='Transactions Banques perso.'
  ApiAccessesShort='Accès API';
  ReportToEmailsShort='Rapports par emails';
  ManageRightsOnCustomReportsShort='Accès aux rapports personnalisés';
  ManageRightsOnCustomReportsShort2='Accès aux rapports perso.';
  PerformanceModuleDashboardShort='Emprez BI';
  ExpenseTypesShort='Types de dépenses';
  HolidayManagementShort='Jours fériés';
  EvaluationsManagerShort='Modèles d\'évaluations';
  DeleteUnapprovedSchedulesAndGabarits ='Supprimer les horaires/FdTs non approuvées et les gabarits';
  HideShowAmounts='Cacher/Afficher les montants';
  EmployeeTools='Traitement en lot';
  CreateChatUserTip='Forcer la création d\'un usager pour le chat';
  SessionWithIntuitIsValid='La session est valide';
  SessionWithIntuitIsNotValid='La session n\'est pas valide, vous devez vous reconnecter.';
  Automatic='Automatique';
  UseCgiAPIV2='Utiliser CGI API V2 (Avec consentement)';
  UseCgiAPIV2WithoutConsent ='Utiliser CGI API V2 (Sans consentement)';
  CgiAPIV2ClientId='Identifiant Client'
  CgiAPIV2ClientSecret='Secret Client';
  CgiAPIV2TestMode='Mode Test - API V2';



  CgiBusinessId='CGI Business Id';
  DoYouReallyWantToDeleteThisToken='Voulez-vous supprimer ce jeton?';
  NoTokenFound='Aucun Jeton';

  SessionWithAPIIsValid = 'La session est active';
  VerifyConnection='Verifier la session';
  SessionWithAPIIsNotValid = 'La session a expirée';
  ConnectToAPI='Se connecter';
  ConnectToAPITitle = 'Connexion à {{service}}';
  YouNeedToSelectABank='Vous devez sélectionner une banque';
  SelectedBankHasNoSetCodeToRetrieveFromAPI='La banque sélectionnée n\'a pas de code pour la retrouver dans l\'API';
  LastBalanceUpdate='Solde mis à jour le {{last}}';
  ItemsSelected = '{{nb}} éléments sélectionnés';
  RecipientsSelected = '{{nb}} destinataires'
  SelectAnItem = 'Sélectionner les éléments';
  SelectRecipients = 'Sélectionner les destinataires';
  NoSelectionAvailable = 'Aucune sélection...';
  NoRecipientToSelect = 'Aucun destinataire';
  FindRecipientToInvite='Rechercher des destinatires';

  FavoritePanel='Vos favoris';
  ConfigureFavoriteMenu='Configuration';
  ConfigureYourMenu='Configurer vos favoris';
  FavoriteMenu='Vos favoris';
  AvailableMenu = 'Menus disponibles';
  NoDivisionsAssociatedWithThisTwilioAccount='Aucune division associée, ce accès twilio pourrait être supprimé';
  NoEnterprisesAreConnectedToFolks='Aucune entreprise n\'est connecté avec Folks';

  UseAllieRHFolks='API Folks';
  AllieRHFolksClientId='Identifiant Client dans Folks';
  AllieRHFolksSecret='Secret Client dans Folks';
  AllieRHFolksKey='Identifiant de l\'enterprise dans Folks';
  VerifyAllieRHCompanyNumber='Verifier \'Company Number\' (Import)';

  ExternalID='Externe';
  ExternalID2='Externe 2';
  selectAll='Tout sélectionner';
  unSelectAll = 'Tout dé-sélectionner';
  OnAddCalendar='Ajouter calendrier';
  FEDERAL ='Fédéral';
  BanksAndHolidays = 'Banques & Vacances';
  Skills='Compétences';
  EmprezBI = 'Emprez BI';
  NoInformation = 'Aucune information';
  _All = 'All';
  WithSchedulesOnly = 'Avec horaires seulement';
  WithoutSchedulesOnly = 'Sans horaires seulement';

  HideAmountTemporary='Cacher les montants (Temp.)';
  Preferences = 'Préférences';
  SavePreferences = 'Enregistrer les préférences';

  EMPREZ_UI_V1 ='Version 1 - Obsolète';
  EMPREZ_UI_V2 ='Version 2';
  EMPREZ_UI_V3 ='Version 3';
  MobileAndWebAccess='Accès Mobile et Web';
  Hiring='Embauche';
  Positions='Postes';
  CCQConfiguration = 'CCQ';
  CopyCalendarUrlToClipboard='Copier le lien pour ajouter au calendrier (Google, Apple,...)';
  SendCalendarUrlByEmail='Envoyer le lien pour ajouter au calendrier (Google, Apple,...)';
  TimesheetParams='Feuilles de temps';
  DoYouReallyWantToApplyTimesheetParamsToEmployeePaidBy = 'Voulez-vous vraiment appliquer les paramètres à tous les employés payés par {{name}}?';
  EmployeeScheduleParams='Paramètres des horaires';
  EmployeeTimesheetParams='Paramètres des feuilles de temps';
  PayParams = 'Paie';
  EmployeePayParams = 'Paramètres pour la paie';
  RPA360Tools='RPA360 - Outils';
  General='Général';
  ConfigurationAndParameters='Configurations & Paramètres';

  CGICustomerConfiguration='Configuration Client pour l\'API V2';
  SageIntacctConfiguration='Configuration Client Sage Intacct';

  BusinessId='Id Entreprise';
  BusinessCode='Code Entreprise';
  DescriptionEn='Description (En)';
  DescriptionFr='Description (Fr)';
  RetrieveBusinessId='Récupérer les informations';
  CompanyItemNumber='Numéro de compagnie';
  CompanyItemName='Description';
  CompanyItemStatus='Statut';
  EnterpriseCodeCompanyNumber='Code Entreprise / Numéro de compagnie';
  InformationAboutBusinesses='Information - Entreprises'
  InformationAboutCompanies='Information - Compagnies'

  SelectDivisions = 'Sélectionner les divisions';
  DivisionsSelected = '{{nb}} divisions'
  NoDivisionToSelect = 'Aucune division';
  FilterByPositions='Filtrer par poste';
  NoPositionToSelectYetLoadSomeSchedules='Charger des horaires';
  SelectedPosition='{{nb}} postes';
  Punchs = 'Poinçons';
  AdHocParameters = 'Défaut';
  AdHocParametersTip = 'Ces paramètres seront utilisés lorsque vous créez de nouveaux employés';
  Applications = 'Web & Mobile';



  Costs = 'Coûts';
  Projects= 'Projets';
  PerformanceModule = 'Emprez BI';
  HumanResource='Ressources Humaines';

  ChooseEmployeeToken='Choisir un employé avec un token';
  EmployeeToken='Employé - Token';
  PleaseSelectAnEnterpriseOrAGroupOfEnterprise='Veuillez sélectionner une entreprise ou un groupe d\'entreprises';
  UpdateFromWebServiceShort = 'Récupérer les informations de {{payRoll}}';
  UpdateFromFolksShort='Synchroniser depuis Folks';


  ReportingGroup='Groupes';
  ShowOrHideToolbar='Cacher / afficher la barre d\'outils';
  ReadJobIdFromCustomFields='Lire \'JobId\' dans les champs perso.';
  JobIdCustomFieldName='Nom du champ perso. \'JobId\'';

  SynchroFromFolks='Récupération des informations de Folks et mettre à jours les employés';
  SynchroFromOdoo='Récupération des informations de Odoo et mettre à jours les employés';
  Synchronization='Synchroniser';
  UseEndDateTip = 'Emprez va créer une cessation d\'emploi à la date de fin.';
  UseEndDate='Utiliser la date de fin';
  UpdateSalary='Mise à jour du salaire';
  UpdateEmployee='Mise à jour des employés';
  UpdateEmployeeTip='Mise à jour de certaines données démographiques et de l\'ancienneté';
  CreateEmployeeFromFolks='Créer les employés';
  CreateEmployeeFromFolksTip='Importer les employés depuis Folks. Une configuration est nécessaire pour relier les postes d\'Emprez avec ceux de Folks.';
  UpdateContacts='Mise à jour des contacts';
  SyncAPIConfigsCGIAPI='Synchronisation - CGI API';
  SyncAPIConfigsFolks='Synchronisation - Folks API';
  SyncAPIConfigsOdoo='Synchronisation - Odoo API';

  Years='Année';
  NOTIFICATION_TYPE_EMAIL = 'Courriel';
  NOTIFICATION_TYPE_APPLICATION = 'Application Mobile';
  NOTIFICATION_TYPE_APPLICATION_AND_EMAIL = 'Courriel + Application Mobile';
  NOTIFICATION_TYPE_NONE = 'Pas de notification';

  onReceivingVacationRequest ='Demandes de vacances';
  onReceivingBankUsageRequest='Demandes d\'utilisation d\'une banque de temps';
  onReceivingApplyOnOpenShift='Postulation sur un quart de travail';
  onReceivingExchangeShiftRequest='Échange de quarts de travail';
  onReceivingAvailabilitiesRequest='Nouvelles disponibilités';
  onReceivingUnAvailabilityRequest='Indisponibilités';
  EmployeeNotificationConfiguration='Notifications pour les requêtes des employés';

  ConversationWithOnePerson='Conversation avec un seul interlocuteur';
  ConversationWithMultiplePerson='Conversation avec un groupe';
  UsersCanLeaveChannel='Quitter';
  UsersCanLeaveChannelFull='Les usagers peuvent quitter les conversations';
  DoYouReallyWantToRemoveThisParticipant='Voulez-vous supprimer {{name}} de cette conversation?';
  EnterNewNameForTheConversation='Modifier le nom';
  ClickToModify='Cliquer pour modifier';
  ClickToRemoveMember='Retirer ce membre';
  Submit='Soumettre';
  ModifyConversationName = 'Modifier le nom de la conversation';
  DeleteMessages='Sélectionner les messages à supprimer';
  SelectedMessages = '{{nb}} messages sélectionnés.';
  DoYouReallyWantToDeleteTheSelectedMessages='Voulez-vous vraiment supprimer les messages sélectionnés?';
  NewConversation='Nouvelle Conversation';

  StartRecording = 'Démarrer l\'enregistrement';
  StopRecording = 'Terminer l\'enregistrement';
  Recording='Enregistrement en cours...';
  FileAttachedToConversationTooLarge = 'La taille du fichier est trop grande. (max {{limit}} Mo)';
  UsersCanSendAudio = 'Les usagers peuvent envoyer de l\'audio (max 3 min)';
  UsersCanSendFile='Les usagers peuvent envoyer des fichiers (jpg, png et pdf) (max 2MB)';
  UsersCanSendPicture='Les usagers peuvent prendre et envoyer des photos (max 2MB)';
  NoEmployeesWorkingInDivision='Aucun employé';
  DeleteUnitAndJobs='Supprimer l\'unité et les postes';
  EntityEdit='Entité';
  NewEntity='Nouvelle Entité';

  BirthdaysValidation='Fêtes';
  NoBirthdays='Pas de fêtes bientôt.';
  EmployeeBirthday='Aujourd\'hui {{birthday}} c\'est la fête de {{fn}}!';
  EmployeeBirthdaySoon='{{fn}} a sa fête le {{birthday}} prochain.';
  EmployeeBirthdayPassed='{{fn}} avait sa fête le {{birthday}} dernier.';

  ExpiredSkillsValidation='Compétences - Expirations';
  EmployeeSkillIsExpiring='La compétence \'{{skill}}\' de {{fn}} expire le {{refDate}}.';
  EmployeeSkillIsExpired='La compétence \'{{skill}}\' de {{fn}} a expiré le {{refDate}}.';
  FilterByFullname='Filtre';
  SelectEntity='Sélectionner une entité';
  ExpensesToApprove='Dépenses à approuver';
  ExpensesByWeekAndEmployee='Dépenses par semaine et par employé';
  NoItemsFound='Aucun élément trouvé.';

  ThoseParametersWillInfluenceThePayNumber='Ces paramètres influencent la numérotation des périodes de paie. Normalement la numérotation (2024-23 par ex.) dépend de la date du paiement et non pas des dates de la période.'
  DaysToDeposit='Paiement après nb jours (défaut: 5)';
  PayBacktime='Nombre de semaines (nb*7) avant le paiement (défaut: 0)';

  PunchWithVoiceEnabledWarning='Expérimental! SEULEMENT pour les horodateurs virtuels utilisant /virtual-punch avec le navigateur Chrome!';
  VoiceEnabledInFrench='Reconnaissance du français';
  VoiceEnabledInEnglish='Reconnaissance de l\'anglais';

  FoldAllShiftsToFill = 'Plier tous les quarts à combler';
  UnFoldAllShiftsToFill = 'Déplier tous les quarts à combler';

  NoExpensesToApprove='Aucune dépense à approuver.';

  FamilyDaysTitle ='Journées familiales';
  EmployeeFamilyDays='Journées familiales';
  NoFamilyDays = 'Aucune journée familiale';
  NbPaidDaysAllowed='Nombre de jours payés alloués';
  NbPaidDaysUsed='Jours payés utilisés';
  NbUnPaidDaysAllowed='Nombre de jours non-payés alloués';
  NbUnPaidDaysUsed='Jours non-payés utilisés';
  DoYouReallyWantToDeleteThisFamilyDays='Voulez-vous vraiment supprimer ces journées familiales?';
  CreateOrDeleteFamilyDays='Ajouter ou supprimer les journées familiales en lot';

  NotEnoughUnPaidFamilyDaysLeft='Il ne reste plus de journées familiales non payées';
  NotEnoughPaidFamilyDaysLeft='Il ne reste plus de journées familiales payées';

  AutoAttendanceDisclaimer = 'Les feuilles de temps de type Travail, Formation et Entraînement seront automatiquement approuvées si elles ne contiennent pas d\'erreurs.';
  AutoAttendance='Approbation automatique';
  AutoAttendanceMessage = 'Approbation automatique - Détails';
  DlgAutoAttendanceMessages = 'Approbation automatique - Détails';
  NoAttendanceMessage = 'Aucun message';
  DoYouReallyWantToDeleteThisMessage='Voulez-vous supprimer ce message?';
  UpdateAutoAttendanceBatch='Modifier l\'approbation automatique en lot';
  IsPunching='Poinçonne ?';
  UpdateAutoAttendanceBatchLabel='Approbation automatique';

  DoYouReallyWantToDeleteSelectedMessage='Voulez-vous supprimer les messages sélectionnés?';
  DeleteSelection='Supprimer la Sélection';
  Selection='Sélection'
  DoYouWantToSelectThisApplicantForThisShift = 'Voulez-vous ajouter le quart à combler à {{applicant}} ?';
  ImportProject='Importer un projet';
  IMPORT_PROJECT_TYPE_MS_PROJECT_MPX = 'MS Project MPX';
  UploadFile='Choisir le fichier à importer';

  TestOdoo='Odoo (Test)';
  TestFolks='Folks (Test)';

  UsesOdoo='API Odoo' ;
  OdooHost='Hôte (URL)';
  OdooDatabase='Base de données';
  OdooUsername='Usager';
  OdooPasswordOrAPIKey='Mot de passe ou Clé API';

  MatchEmployeeWithOdoo='Odoo: Associer avec les employés d\'Emprez (par prénom + nom)'
  ImportEmployeeFromOdoo='Odoo: Importer les employés dans Emprez';
  NoEnterprisesAreConnectedToOdoo='Aucune entreprise n\'est configurée pour utiliser Odoo';

  VerifyOdooCompanyNumber='Verifier le numéro de compagnie de Odoo';
  OdooCompanyNumber='Numéro de compagnie de Odoo';
  OdooCodeForTsType='Correspondance Type de FdT dans Odoo (ALL=1,ABSAUTH=44,ABSAUTHPAYE=...)';
  LinkedWithExternalHRService='Lien avec service externe de RH';
  PasswordSentToEmailOnFile='Votre mot de passe a été envoyé à l\'adresse courriel associée à votre compte.';
  ROICalculation='Calcul du ROI (XLS)';
  DisplayDistinctSchedules='Afficher les horaires distincts';
  AddGPSFenceOnPosition='Ajouter des zones géographiques sur un poste';
  AddGPSFenceOnPositionNG = 'Zones géographiques';

  ReplaceGPSFences='Remplacer les zones géographiques';
  GPSFences='Zones géographiques';
  Print='Imprimer';
  AbsenceSubType ='Raison de l\'absence';

  ABSENCE_SUB_TYPE_FAMILY_OBLIGATION='Obligation Familiale';
  ABSENCE_SUB_TYPE_MEDICAL_APPOINTMENT  = 'Rendez-vous Medical';
  ABSENCE_SUB_TYPE_ACCIDENT_ON_DUTY  = 'Accident au travail';
  ABSENCE_SUB_TYPE_FLOATER  = 'Flottant';
  ABSENCE_SUB_TYPE_ACCIDENT_OFF_DUTY  = 'Accident hors du travail';
  ABSENCE_SUB_TYPE_LAY_OFF  = 'Mise à pied';
  ABSENCE_SUB_TYPE_SHORTAGE_OF_WORK  = 'Manque de travail';
  ABSENCE_SUB_TYPE_DISCIPLINARY  = 'Disciplinaire';
  ABSENCE_SUB_TYPE_DENTIST  = 'Dentiste';
  ABSENCE_SUB_TYPE_WEATHER  = 'Météo';
  ABSENCE_SUB_TYPE_SICK  = 'Maladie';
  ABSENCE_SUB_TYPE_OTHER  = 'Autre';
  ABSENCE_SUB_TYPE_LATE  = 'Retard';
  ABSENCE_SUB_TYPE_UNION_LEAVE  = 'Syndicat';
  ABSENCE_SUB_TYPE_EARLY_DEPARTURE  = 'Départ anticipé';
  ABSENCE_SUB_TYPE_INVALIDITY  = 'Invalidité';
  ABSENCE_SUB_TYPE_EMERGENCY_LEAVE  = 'Départ pour urgence';
  ABSENCE_SUB_TYPE_UNAVAILABLE  = 'Non disponible';
  ABSENCE_SUB_TYPE_QUARANTINE  = 'Quarantaine';

  BlockTextMemoBetweenEmployee='Les employés ne peuvent pas envoyer de mémo texte entre eux.';
  OvernightTSAccountedOnEndDate='Les FdTs \'overnight\' seront payées selon la date de fin.';
  OvernightTSAccountedOnEndDateDescription='Une feuille de temps du lundi 23:00 à mardi 04:30 sera considérée être le mardi (Normalement elle serait considérée être le lundi)'
  SummaryAreUsingTheTSDateAndNotTheStartOfTheWeek='Le sommaire hebdomadaire utilise la date des fdts comme référence'
  SummaryAreUsingTheTSDateAndNotTheStartOfTheWeekDescription='Historiquement le début de la période de paie est utilisé comme référence, cela décale le paiement des fériés dans la période suivante SI la période de paie est \'farfelue\' (ex: n\'est pas Dimanche ou Lundi) ET que le jour férié tombe le dernier jour de la deuxième semaine de paie. Aucune changement dans ce qui sera payé au final, mais cela permet de conserver la logique dans l\'affichage du sommaire. '
  CalculateStatutoryHolidayWithoutSummary='Calcul des fériés';
  CalculateStatutoryHolidayWithoutSummaryDescription='Sélectionner cette option pour ne pas utiliser les sommaires hebdomadaires, mais directement la feuille de temps associée.';


  UsesSageIntacct='Sage Intacct';
  SageIntacctCompanyId='Company Id - Utilisé dans la fenêtre de login dans Sage';
  SageIntacctEntityId='Entity Id (Optionnel) - Associées à la Company dans Sage';

  MatchEmployeeWithSageIntacct='Sage-Intacct: Associer avec les employés d\'Emprez (par prénom + nom)';
  MatchEmployeeFromEnterpriseWithSageIntacct = 'Association avec {{name}}';
  ImportEmployeeFromSageIntacct='Sage-Intacct: Importer les employés dans Emprez';
  ImportEmployeeWithSageIntacct='Importer avec {{name}}';
  NotesFromConversionFromAPI = 'Information interne à propos de la conversion depuis l\'API';


  ExternalEntityCode='Code externe Entité';
  ImportSageIntacctProject='Importer depuis Sage-Intacct';
  AssociatedWithTheTask='Association avec la tâche';
  TimedTaskIsAssociatedWithTheEmployee='L\'employé est associé avec la tâche.';

  ReportTaskToSageIntacct= 'Sélectionnez les tâches à envoyer dans Sage-Intacct';
  ReportTasksToSageIntacct ='Envoyer dans Sage-Intacct';
  SendToSageIntacct='Envoyer';
  AlreadySent='Envoyé le {{sentDate}}';
  MyPreferences='Mes préférences';
  MyProfile='Mon profil';
  BatchGroup='Groupes';
  CanAddEmployeeToGroup='Peut ajouter des employés';
  CanRemoveEmployeeToGroup = 'Peut supprimer des employés';
  CanAdd='Peut ajouter';
  CanRemove='Peut supprimer';

  WizStep='Étape';
  WizSelectEmployeesDescription='Sélectionnez les employés';
  WizApplyModificationDescription='Appliquer les modifications';
  WizModifyParametersDescription='Modifier les paramètres';
  WizInformationResults='Résultats';
  Previous='Précédent';
  SelectTerminatedAndVisible='Sélectionner tous les employés visibles ET terminés.';
  UsersRights='Gestion des usagers';
  NoErrorsFound='Aucune erreur.';
  NoDeletedScheduleOrTimesheet='Aucun horaire ou feuille de temps.';
  TimesheetTime='Début et fin de la feuille de temps';
  PunchTime = 'Début et fin poinçonnées';
  ToggleAmountTemporary='Afficher / Cacher les montants';
  ToggleAMPMTemporary='Afficher / Cacher AM/PM';
  PublishThisLine='Publier cette ligne';
  UnPublishThisLine='Dé-publier cette ligne';
  DeleteSchedulesOnThisLine='Supprimer les horaires de cette ligne';

  EditEmployeeSchedule = 'Modifier l\'horaire';
  DeleteEmployeeSchedule='Supprimer l\'horaire';
  EditEmployee='Modifier l\'employé';

  HideUnit='Cacher l\'unité';
  ShowUnit='Montrer l\'unité';
  HideChildren='Cacher les sous-unités';
  ShowChildren='Montrer les sous-unités';
  Contacts='Contacts d\'urgence';
  DisplayCharts='Afficher les graphiques';
  YouHaveANewDocumentToSign='Vous avez un nouveau document à signer';
  YouHaveANewDocumentToSignBody='Bonjour,<br> Un nouveau document \'{{name}}\' à signer est disponible. Utilisez votre portail Emprez ou votre application mobile pour le lire et le signer.<br> Merci.';
  NotifyEmployees='Notifier les employés';
  NoEmployeesLeftToNotify='Aucun employé à notifier, ils ont tous signé le document.';
  DoYouWantToNotifyTheEmployees='Voulez-vous notifier les employés qui n\'ont pas encore signé le document ?';
  ExternalId='Id externe';
  Up = 'Vers le haut';
  Down =  'Vers le bas';
  GotoChatChannel='Répondre à la Conversation';

  Verifications='Vérifications';
  PlanningErrors='Erreurs dans les plans';
  BudgetErrors='Erreurs dans les budgets';
  EmployeeScheduleErrors='Erreurs dans les horaires';
  EmployeHoraireToFillErrors='Erreurs dans les quarts à combler';
  ExpiredSkillsErrors='Compétences ou Qualifications expirées';
  BirthdaysAlert='Fêtes futures ou passées.'
  EmployeePerformanceToReviewAlert='Évaluations à compléter';

  ToApprove = 'À approuver';
  SelectTimesheetsToApprove='Sélectionner les feuilles de temps à approuver';
  NoProjectFound='Aucun projet.';
  FilterByEmployee='Employé';
  ApprovedTimesheets='Total';
  FilterByApprover='Approbateurs';
  AllApprovers='Tout afficher';
  GeneralInformation='Information générales';
  PersonalInformation='Information personnelle';
  EmergencyContacts='Contacts d\'urgence';
  DailyManagement = 'Gestion quotidienne';
  AddASchedule='Ajouter un horaire';
  AddATimesheet = 'Ajouter une feuille de temps';
  AddATask='Ajouter une tâche';
  TimeManagement = 'Gestion du temps';
  MoneyManagement = 'Finances';
  CommunicationManagement='Communication';
  MiscManagement='Ajout au dossier';
  VacationManagement='Vacances';
  DoYouReallyWantToDeleteThisCustomReport='Voulez-vous supprimer l\'accès à ce rapport?';
  VacationsList='Liste des vacances utilisées et prévues';

  CostDistribution='Distribution des coûts (optionnel)';
  CostDistributionFromEnterprise='Lire les paramètres depuis l\'entreprise suivante';
  AddEmployeeTimedTask='Durée de la tâche';
  startHour='Heure de début (hh:mm)';
  endHour='Heure de fin (hh:mm)';
  TimedTaskToChoose='Tâche';
  ErrorStartOfTaskIsAfterEndOfTask = 'Erreur: Le début de la tâche est après la fin de la tâche.';
  ErrorEndOfTaskIsAfterEndOfShift = 'Erreur: La fin de la tâche ({{endOfTask}}) est après la fin du quart de travail ({{endOfShift}}).';
  ErrorStartOfTaskIsBeforeStartOfShift = 'Erreur: Le début de la tâche ({{startOfTask}}) est avant le début du quart de travail ({{startOfShift}}).';
  ChooseCommitment='Choisir';
  Commitment='Document à signer';
  DefaultPosition= 'Poste par défaut : \'{{position}}\'';
  ApplyConfigurationForHolidays='Appliquer également la configuration pour les fériés.';
  TasksInTimesheets='Tâches accomplies durant le quart de travail';
  Start='Début';
  End='Fin';
  AddEmployeeToAllTasks='Ajouter des employés aux tâches';
  AddEmployeesToTask ='Ajouter des employés à cette tâche';
  DeleteTimedTask ='Supprimer la tâche';
  ModifyTimedTask = 'Modifier la tâche';
  DuplicateTimedTask = 'Dupliquer la tâche';
  Logout='Déconnexion';
  DoYouReallyWantToDeleteAllUnapprovedTheWorkshift='Voulez-vous vraiment supprimer TOUTES les feuilles de temps NON approuvées ?';
  DoYouWantToDeleteThisReport = 'Voulez-vous supprimer ce rapport?';
  GPSInformation = 'GPS Information';
  ChannelIsReadOnly ='Cette conversation est en lecture seule.';
  CantLeaveChannel ='Vous ne pouvez pas quitter cette conversation.';
  DeactivateEnterprise='Désactiver l\'entreprise';
  DoYouReallyWantToDeactivateThisEnterprise='Voulez-vous vraiment désactiver cette entreprise?';
  DoYouReallyWantToRemoveAllUnitWithNoEmployeesAndNoUsersAndNoChildren='Voulez-vous vraiment supprimer toutes les unités sans employés ET sans usagers ET sans sous-unités?';

  UseBulletinBoardChannel='Utiliser Annonces Publiques (Lecture tous - Écriture: admins)'
  BulletinBoardChannelName ='Nom du canal - Annonces';

  UseDiscussionBoardChannel='Utiliser Babillard (Lecture & Écriture tous )';
  DiscussionBoardChannelName ='Nom du canal - Babillard';
  ApplyTimesheetParamsToEmployeeOfEnterprise='Appliquer les paramètres';
  RetrieveConfigurationFromSage='Charger la configuration depuis Sage-Intacct';
  Synchronize='Synchroniser';
  ThisProjectHasAlreadyBeanImportedFromSage='Le projet \'{{name}}\' a déjà été importé. Emprez va mettre à jour les informations et ajoutera les tâches et les ressources manquantes. Les tâches et les ressources déjà importées ne seront pas supprimées. Voulez-vous continuer?';
  DoYouWantToRefuseTheOtherRequests='Voulez-vous refuser les autres requêtes?';
  ChooseAPremium= 'Choisissez une prime';
  Premiums='Primes';
  YouCantHaveMoreThan20Premiums='Vous ne pouvez pas avoir plus de 20 primes.';
  PreviousPeriods='Périodes précédentes';
  NextPeriods='Prochaines périodes';

  FamilyDays='<b>Journées familiales</b>: <span class="muted">{{paidUsedDays}}/{{paidDays}} payées, {{unpaidUsedDays}}/{{unpaidDays}} non payées</span>';
  FamilyDaysWithDates='<b>Journées familiales (du {{start}} au {{end}})</b>: <span class="muted">{{paidUsedDays}}/{{paidDays}} payées, {{unpaidUsedDays}}/{{unpaidDays}} non payées</span>';
  SickDaysDisplayFormat='<b>Journées Maladies (HH:MM)</b>: <span class="muted">{{usedSickDays}}/{{sickDaysLeft}} utilisées / restantes</span>';

  SickDaysBalance='<b>Journées Maladies</b>: <span class="muted">{{sickDaysLeft}}</span>';

  FamilyDaysBalanceNoDates='<b>Journées familiales</b>: <span class="muted">{{paidDaysLeft}} payées restantes, {{unpaidDaysLeft}} non payées restantes</span>';
  FamilyDaysBalanceWithDates='<b>Journées familiales</b><span style="font-size: x-small">(du {{start}} au {{end}})</span>: <span class="muted">{{paidDaysLeft}} payées restantes, {{unpaidDaysLeft}} non payées restantes</span>';

  NoFamilyDaysAvailable='Aucune journée familiale';

  BalanceIs='<span class="muted">&nbsp;Solde: {{balance}} </span>';
  More='Plus';
  DurationInHoursMinutes='Durée (HH:MM)';
  SelectEmployees='Sélectionnez les employés';

  UseUnitsOrEnterpriseToSelectEmployeesToModify='Choisissez des unités et/ou des entreprises pour déterminer les employés à modifier';

  ModifyEmployeePunchParamsInBatch='Modifier les paramètres du poinçon des employés';
  ModifyEmployeePortalParamsInBatch='Modifier les paramètres du portail des employés';
  _ModifyEmployeeScheduleParamsInBatch='Modifier les paramètres des horaires des employés';
  ModifyEmployeeScheduleParamsInBatch='Modifier les paramètres de requête des employés';

  ModifyEmployeeTimesheetParamsInBatch='Modifier les paramètres des feuilles de temps des employés';

  ApplyStatutoryHolidays='Appliquer également la configuration pour les fériés.';
  EmployeePosition='Poste';
  DefaultSorting='Tri par défaut';
  EmployeeTaskDescriptionStartDate_Sorting='Par employé, tâche et début de tâche';
  StartDateEmployeeTaskDescription_Sorting='Par début de tâche, employé et tâche';
  StartDateTaskDescriptionEmployee_Sorting='Par début de tâche, tâche et employé';
  Download = 'Télécharger';
  Upload = 'Téléverser';
  SelectedTasks='{{nb}} tâche(s)';
  SelectTask = 'Filtrer par tâche';
  SelectedEmployees='{{nb}} employé(s)';
  FilterEmployee='Filtrer par employé';
  NewHRConfiguration='Nouvelle configuration RH';
  NoHRConfigurationFound='Aucune configuration RH';
  HRConfigurations = 'Configurations RH';
  NoUserAccess='Aucun accès usager';
  NoParameters = 'Aucun paramètre';
  DeleteHRConfiguration='Suppression d\'une configuration RH';
  DoYouReallyWantToRemoveThisConfiguration ='Voulez-vous supprimer la configuration \'{{name}}\'? La suppression est définitive.';
  HRConfiguration ='Configuration RH';
  EditAccessRights='Modifier les droits d\'accès';
  EditRightsForMoreInformation = 'Droits spécifiques';
  FullAccess = 'Accès total';
  DisplayOrder='Ordre d\'affichage';
  Owner='Auteur';

  DocumentCenter = 'Pôle RH';

  SelectExpenseType='Filtrer par type';
  SelectedExpenseTypes='{{nb}} type(s)';
  NoExpenseTypeFound='Aucun type';
  SORT_BY_EMPLOYEE_BY_DATE='Par employé et date';
  SORT_BY_DATE_BY_EMPLOYEE='Par date et employé';
  DlgChooseCustomCodesTitle='Selection';

  SelectType='Filtrer par type';
  SelectedTypes='{{nb}} type(s)';
  NoTypesFound='Aucun type';
  SelectedApprover = 'Filtrer par approbateur';
  SelectApprover='{{nb}} approbateur(s)';
  NoApprouverFound = 'Aucun approbateur';
  Salaries = 'Salaires';

  SelectConsequence='Filtrer par conséquence';
  SelectedConsequences='{{nb}} conséquence(s)';
  NoConsequencesFound='Aucune conséquence';


  HR_PARAM_TYPE_CATEGORY = 'Catégorie';
  HR_PARAM_TYPE_CONSEQUENCE = 'Conséquence';
  HR_PARAM_TYPE_GRIEVANCE_TYPE = 'Type de grief';
  HR_PARAM_TYPE_CERTIFICATE_CATEGORY = 'Catégorie de certificat';
  HR_PARAM_TYPE_TRAINING_ORGANISATION='Organisme - Formation';


  HR_PARAM_TYPE_SECURITY = 'Sécurité';
  HR_PARAM_TYPE_SECTION = 'Section';
  CurrentListOfParameters='Liste actuelle';
  CreateNewConsequence='Ajouter une conséquence';
  Consequence='Conséquence';
  AddDisciplineFiles = 'Ajouter des fichiers';
  DownloadFiles='Télécharger les fichiers joints';
  DoYouReallyWantToDeleteThisFile='Voulez-vous supprimer ce fichier?';

  GRIEVANCE_STATUS_TYPE_ACCEPTED='Accepté';
  GRIEVANCE_STATUS_TYPE_REFUSED = 'Refusé';

  Grievances='Griefs';
  SelectedTypeOfEvents='{{nb}} type(s)';
  SelectTypeOfEvent='Filtrer par type d\'évènement';
  NoTypeOfEventFound='Aucun type d\'évènement trouvé.';
  Grievance = 'Grief'
  GrievanceName='Nom (Réf,...)';
  ParentGrievance= 'Grief associé';
  ChooseGrievance='Choisir un grief';


  DateRef='Date de référence';
  TypeOfEvent='Type d\'évènement';
  CreateNewType='Créer un nouveau type';
  Actors='Intervenants';
  GoingToCourtOfJustice='Passage devant les tribunaux'
  LegalCosts='Coûts légaux';

  OtherCosts='Autres coûts';
  ResolutionDt='Date de résolution';
  Resolution='Résolution'
  GrievanceStatusType='Statut'
  AddGrievanceFiles='Ajouter des fichiers';
  AddFiles='Ajouter des fichiers';


  DropPunchToImport='Placer ici le fichier à importer';
  ImportGroupCarburPunchXLS='Import des entrées/sorties - Groupe-Carbur'

  VALIDITY_UNIT_TYPE_DAYS='jours';
  VALIDITY_UNIT_TYPE_MONTHS='mois';
  VALIDITY_UNIT_TYPE_YEARS='années';


  Certificat='Certificat';
  EmployeeCertificates='Certifications des employés';
  EmployeeCertificate='Certification de l\'employé';

  Category='Catégorie'
  ValidityValue='Validité';
  ValidityUnit='Unité - Validité';
  NbOfHoursToCompleteCertificate='Nombre d\'heures du cours';
  RequiredCertificates='Certificats pré-requis';
  Eligible='Éligible'

  ChooseCertificat='Choisissez un certificat';
  CreateNewCategory='Créer une nouvelle catégorie';

  SelectedCategories='{{nb}} catégorie(s)';
  SelectCategory='Filtrer par catégorie';
  NoCategoryFound='Aucune catégorie';
  CategoryName='Nom de la catégorie';
  NoCertificatesToChooseFromYouNeedToCreateSome = 'Vous n\'avez pas encore de certificats à choisir.';
  NbOfHoursToComplete='Nb heures de cours';
  Validity='Validité'
  Certificates = 'Certificats';

  SelectedCertificates='{{nb}} Certificats';
  SelectCertificate='Filtrer par certificat';
  NoCertificateFound='Aucun certificat';
  AddEmployeeCertificateFiles='Ajouter des fichiers';
  ReceivedOnDt='Début de validité';
  AlwaysValid='Toujours valide';
  ValidTillDt='Fin de validité';

  DoYouReallyWantToRemoveThisEmployeeFromTheTrainingProgram='Voulez-vous supprimer cet employé de la formation?';

  FromDt='De'
  ToDt='À'
  Element = 'Élément';

  TrainingProgram = 'Formation'
  TrainingPrograms = 'Formations';
  NbOfHours='Durée de la formation en heures'
  TrainingProgramDurationInDays = 'La formation prendra {{duration}} jour(s).';
  EligibleToGovernmentProgram='Admissible - Loi 90';


  TrainingProgramType='Type de formation'
  TRAINING_PROGRAM_TYPE_INTERNAL='Interne'
  TRAINING_PROGRAM_TYPE_EXTERNAL='Externe'
  Trainer = 'Formateur'
  TrainingCost='Coûts ($)'
  PerDiemTrainerCost='Coûts ($ Per Diem)'
  PerDiemEmployeeCost ='Coûts ($ Per Diem)';

  TrainingOrganisationCost = 'Coûts ($)';
  TrainingOrganisation='Organisme Externe';
  CreateNewTrainingOrganisation='Créer un nouvel organisme';

  SORT_BY_DATE_BY_CERTIFICAT='Trier par date et certificat';
  SORT_BY_CERTIFICAT_BY_DATE='Trier par date et certificat';


  SelectedTrainers='{{nb}} formateurs';
  SelectTrainer = 'Filtrer par formateur';
  NoTrainerFound = 'Aucun formateur';


  EmployeeTrainingProgram='Formation - Employé'
  EmployeeCost='Coûts';
  OtherEmployeeCost='Autres coûts';
  EmployeeTrainingProgramResultType='Statut de l\'employé';

  EMPLOYEE_TRAINING_PROGRAM_RESULT_TYPE_NOT_COMPLETED = 'Non completé, en cours';
  EMPLOYEE_TRAINING_PROGRAM_RESULT_TYPE_COMPLETED_WITH_SUCCESS = 'Succès';
  EMPLOYEE_TRAINING_PROGRAM_RESULT_TYPE_COMPLETED_WITH_FAILURE = 'Échec';
  EmployeeThatWillFollowThisTrainingProgram = 'Employés suivant cette formation';

  TsType='Type';
  ApprovedBy='Approuvé par';
  ApprovedOn='Approuvé le';
  Evaluations = 'Évaluations';
  RemoveAll='Tout supprimer';

  SelectedEvaluations='{{nb}} évaluations';
  SelectEvaluation='Filtrer par évaluation';
  NoEvaluationFound='Aucune évaluation';
  SelectTheDueDateForTheEvaluation='Choisissez la date d\'échéance de l\'évaluation';
  ApplyToEmployee='Associer des employés';

  LearningCenter='Pôle Formation'
  PerformanceCenter ='Pôle Performance';

  HRPerformanceTemplates='Gabarits de performances';
  EmployeePerformances='Performances des employés';

  EmployeeAbilities = 'Aptitudes des employés';
  Abilities='Aptitudes'

  SelectedAbilities='{{nb}} aptitude(s)';
  SelectAbility='Filtrer par aptitude';
  NoAbilityFound='Aucune aptitude';
  NoAbilityToChooseFromYouNeedToCreateSome='Veuillez commencer par créer des aptitudes.';
  EmployeeAbility='Aptitude de l\'employé';
  Ability='Aptitude'
  WeightForReview='Coefficient / Poids pour le calcul de l\'évaluation'
  AbilityLevel='Niveau de l\'aptitude'
  CreateNewAbility='Créer une nouvelle aptitude';
  CurrentListOfAbilities='Liste des aptitudes';
  LabelForEmployeeAbilityWithWeightAndLevel='{{title}} - niv.: {{level}}, coef.: {{weight}}';
  IncludeKRAInReview='Inclure les domaines de résultats (KRA) dans les performances';
  AutoReviewByEmployee='Auto évaluation de la performance';
  AddManagerAsReviewer='Ajouter les supérieurs hiérarchiques comme évaluateurs';

  WeightForKRAInReview = 'Coéfficient pour les domaines de résultats (KRA)';
  IncludeCompetencyInReview='Inclure les compétences dans les performances';
  WeightForCompetencyInReview = 'Coéfficient des compétences';
  IncludeAbilityInReview='Inclure les aptitudes dans les performances';
  WeightForAbilityInReview = 'Coéfficient des aptitudes';
  IncludeGoalInReview='Inclure les objectifs dans les performances';
  WeightForGoalInReview='Coéfficient des objectifs';
  IncludeReview360InReview='Inclure les commentaires des gestionnaires et/ou collègues';
  WeightForReview360InReview='Coefficients pour les commentaires des gestionnaires et/ou collègues';


  HRPerformanceTemplate='Mesure de la performance (Gabarit)';

  DueDt='Date d\'échéance'
  PeriodStartDt='Début de la période';
  PeriodEndDt = 'Fin de la période';
  EmployeePerformance = 'Performance de l\'employé';
  EMPLOYEE_PERFORMANCE_STATUS_TO_BE_COMPLETED='À compléter';
  EMPLOYEE_PERFORMANCE_STATUS_COMPLETED='Complet';

  SelectedPerformanceTitles='{{nb}} Performance(s)';
  SelectPerformanceTitle='Filtrer par Performance';
  NoPerformanceTitleFound='Aucune performance';
  EmployeeAbilityReviews='Mesure des aptitudes';
  EmployeeAbilityReviewsTab='Aptitudes';
  PleaseReviewThisAbility='Notez cette aptitude: <b>{{name}}</b>';
  NoAbilityToRateForEmployee='Aucune aptitude à noter pour cet employé';
  EmployeeAbilityReview='Mesure de l\'aptitude de l\'employé';

  RatingAndNote='Notez et Commentez';
  SORT_BY_DATE_BY_TITLE_BY_EMPLOYEE='Par Date, Titre & Employé';
  SORT_BY_TITLE_BY_DATE_BY_EMPLOYEE='Par Titre, Date & Employé';

  LabelForEmployeeCompetencyWithWeightAndLevel='{{title}} - coef: {{weight}}';
  CreateNewCompetency = 'Ajouter une nouvelle compétence';
  SelectedCompetencies='{{nb}} compétence(s)';
  SelectCompetency = 'Filtrer par compétence';
  Competency='Compétence';
  NoCompetencyFound = 'Aucune compétence';

  EmployeeCompetencies = 'Compétences de l\'employé';
  EmployeeCompetency = 'Compétence de l\'employé';
  CurrentListOfCompetencies='Liste de compétences';
  PleaseReviewThisCompetency ='Notez cette compétence: <b>{{name}}</b>';
  NoCompetencyToRateForEmployee='Aucune compétence à noter pour cet employé';
  EmployeeCompetencyReviews='Mesure des compétences de l\'employé';
  EmployeeCompetencyReviewsTab='Compétences';

  LabelForEmployeeKRAWithWeightAndLevel='{{title}} - coef: {{weight}}';
  CreateNewKRA = "Créer un nouveau domaine de résultats";
  SelectedKRAs='{{nb}} domaine(s) de résulats';
  SelectKRA = 'Filtrer par domaine de résultats';
  NoKRAFound = 'Aucun domaine de résultats';
  EmployeeKRAs = 'Domaines de résultats de l\'employé';
  EmployeeKRA = 'Domaine de résultats de l\'employé';
  CurrentListOfKRAs='Liste des domaines de résultats';
  PleaseReviewThisKRA   ='Notez ce domaine de résultats: <b>{{name}}</b>';
  NoKRAToRateForEmployee='Aucun domaine de résultats à noter pour cet employé';
  EmployeeKRAReviews='Mesure des domaines de résultats de l\'employé';
  EmployeeKRAReviewsTab='Domaines de résultats';


  PRIORITY_TYPE_LOW='Basse priorité';
  PRIORITY_TYPE_MEDIUM='Moyenne priorité';
  PRIORITY_TYPE_HIGH='Haute priorité';

  SelectedGoals='{{nb}} objectif(s)';
  SelectGoal='Filtrer par objectif';
  NoGoalFound = 'Aucun objectif';
  LabelForEmployeeGoalWithWeightAndLevel = '{{title}} - coef: {{weight}}, {{priority}} ';
  EmployeeGoals='Objectifs de l\'employé';
  EmployeeGoal = 'Objectif de l\'employé';
  Goals='Objectifs';

  NoGoalToRateForEmployee='Aucun objectif à noter pour cet employé';
  EmployeeGoalReviews='Mesure des objectifs de l\'employé';
  EmployeeGoalReviewsTab='Objectifs';

  EmployeeReview360s='Commentaires des gestionnaires et/ou collègues de l\'employé';
  EmployeeReview360sTab='Commentaires adhoc';

  ActiveInactiveTerminatedEmployees = '{{nbActive}} actif(s), <span class=\"emprez-orange-fiesta\">{{nbInactive}} inactif(s)</span>,  <span class=\"emprez-rouge-matador\">{{nbTerminated}} terminé(s)</span>';
  Statuses = 'Statuts';
  ReminderDt = 'Date de rappel';
  TooManyHoursPerDay='Trop d\'heures par jour (>8h)';
  RenewalDt = 'Date de renouvellement';
  TrainingCostReport='Rapport des coûts';

  SelectedJobs='{{nb}} poste(s)';
  FilterByJob = 'Filtrer par poste';
  NoJobFound = 'Aucun poste';
  SearchEmployee = 'Chercher les employés';
  SearchEmployeePlaceholder = 'Par nom de famille, prénom ou #Matricule';
  LoadEmployees='Charger les employés';
  CompletedDate='Complété le';
  DateRange='Période';
  ChooseDateRange='Choisissez une période';

  SelectedGoalKPIs='{{nb}} indicateur(s)';
  SelectGoalKPI='Filtrer par indicateur';
  NoGoalKPIFound='Aucun indicateur';

  GoalKPI = 'Indicateur - Objectif';
  GoalKPIs = 'Indicateurs des objectifs';
  KRAs = 'Domaines de résultats';
  AssociatedKRAs = 'Domaines de résultats associés (Optionnel)';
  AssociatedGoals='Objectifs associés (Optionnel)';

  AddNew='Créer un nouveau choix';
  ChooseKRAs='Choisir';
  ChooseKRADescription='Choisissez un domaine de résultats';
  KRA='Domaine de résultats'
  Goal = 'Objectif';
  CreateNewGoal='Ajouter un nouvel objectif';

  UnitKRAs='Les employés travaillant dans ces unités, sont automatiquement associés à ce domaine (Optionnel)';

  ChooseGoals='Sélection'
  ChooseGoalDescription='Sélectionner un ou plusieurs objectifs.';

  SelectedManagers='{{nb}} supérieur(s) hiérarchique(s)';
  SelectManager='Filtrer par supérieur hierarchique';
  NoManagerFound='Aucun supérieur hiérarchique';
  EmployeeManagers='Supérieurs hiérarchiques des employés';
  FinalAssessmentForTheReview='Synthèse globale';

  SORT_BY_TITLE = 'Tri par titre';
  SORT_BY_DESCRIPION = 'Tri par description';
  HRCareerAggregation = 'Plan de développement';
  HRCareerAggregations = 'Plans de développement';
  EmployeeCareers='Plans de développement des employés';
  EmployeeCareer='Plan de développement de l\'employé';

  HRCareer = 'Plan de développement';
  HRCareerDetail = 'Objectif de développement';
  HRCareerDetails = 'Objectifs de développement';

  SelectedCareers='{{nb}} plans de développement';
  SelectCareer='Tri par plans de développement';
  NoCareerFound='Aucun plan de développement';
  CreateNewCareer='Créer un nouveau plan de développement';


  CAREER_DETAIL_TYPE_TRAINING = 'Formation';
  CAREER_DETAIL_TYPE_COACHING = 'Entrainement (Coaching)';
  CAREER_DETAIL_TYPE_SPECIAL_PROJECT = 'Projet spécial';
  CAREER_DETAIL_TYPE_OTHER = 'Autre';

  CAREER_STATUS_TYPE_OPEN='Ouvert';
  CAREER_STATUS_TYPE_IN_PROGRESS='En cours';
  CAREER_STATUS_TYPE_CANCELLED='Annulé';
  CAREER_STATUS_TYPE_COMPLETED='Terminé';

  NoRecognitionFound='Aucune reconnaissance';
  EmployeeRecognitions='Reconnaissances des employés';
  EmployeeRecognition='Reconnaissance de l\'employé';


  RECOGNITION_TYPE_INFORMAL_THANK_YOU='Merci informel';
  RECOGNITION_TYPE_FORMAL_RECOGNITION='Reconnaissance formelle';
  RECOGNITION_TYPE_SPECIAL_BONUS='Prime spéciale';
  RECOGNITION_TYPE_WAGE_INCREASE='Augmentation salariale';

  RECOGNITION_SOURCE_TYPE_MANAGER='Manager';
  RECOGNITION_SOURCE_TYPE_COLLEAGUE='Colleague';
  RECOGNITION_SOURCE_TYPE_UPPER_MANAGEMENT='Upper Management';

  EmployeePerformanceReviewers='Évaluateurs';

  NotCompletedByReviewerYet='À évaluer';
  CompletedByReviewer='Complet';
  AddEmployeeToAutoEvaluate='Ajouter auto-évaluation';
  AutoEvaluationByTheEmployee='Auto-évaluation';
  StartEvaluationPerformance='Évaluer';

  PerformancesConfiguration='Configuration';
  PerformancesEmployeeConfiguration='Configuration des employés'
  PerformancesEvaluations='Évaluations';
  HRSurveys='Enquêtes RH';
  EmployeeHRSurveys='Enquêtes RH des employés';

  CertificatesAndCareerPaths='Cheminement éducatif';
  EmployeesCertificatesAndCareerPaths='Éducation des employés';
  EmployeeTrainingPrograms='Formations des employés';

  EmployeeDocumentsAndNotes='Documents et Notes';
  EmployeeFinancials='Finances';
  EmployeeExceptions='Exceptions';


  EmployeePerformancesToComplete='Évaluations à valider';
  EmployeePerformancesToReview='Évaluations à compléter';
  AverageGrade='Moyenne des notes';

  AccessByUsers = 'Accès usagers';
  AccessRights = 'Droits';
  ChooseUnits='Choisir des unités';
  ChooseUnitDescription='Description';
  RecognitionType='Type'
  RecognitionSource='Source';

  ListReportsByEmail='Rapports par courriel';
  DlgWebPayRequest='Paramètres';
  DisplayAmount='Afficher les montants';

  FromDate = 'Du';
  ToDate = 'Au';

  NoEmployeeToSelect='Aucun employé';
  DuplicateTimedTaskGroup='Dupliquer le projet';

  DoYouWantToDuplicateTheEmployeesOnTheTask='Le projet et ses tâches seront dupliqués, voulez-vous également associer les employés à ces nouvelles tâches?';
  Duplicate='Copie';

  EnterpriseVacationsAreInHoursMinutesDescription='ATTENTION: Toutes les banques de vacances déjà créées devront être vérifiées et modifiées au besoin. Tout changement de cette option est la responsabilité de l\'usager et sera enregistré dans le journal.'
  PayParametersModificationWarning='ATTENTION: Modifier la période de paie a des conséquences importantes pour les paies passées et futures. Des feuilles de temps approuvées pourraient être non payées ou payées en double. Tout changement de cette option est la responsabilité de l\'usager et sera enregistré dans le journal.'

  EnterpriseLogs='Journal des modifications';
  ShowLogs='Journal';
  NoLogs='Aucune information';

  VACATIONS_IN_MINUTES='Vacances en minutes';
  PAY_PERIOD_REF='Période de paie';
  ImportSchedulesFromOnTrack='Importer les horaires de OnTrack';
  ImportSchedulesOnTrack='Importer les horaires de OnTrack';
  ActivityDateForPlanning='Entrée en vigueur (optionnel)';
  CopyOf='Copie de ';
  DisplayActiveTheseHours='Filtrer par heure';
  DoYouReallyWantToDeleteThisTimedTask='Voulez-vous supprimer cette tâche \'{{description}}\'?';
  MINUTE_REMOVAL_TYPE_AT_THE_END='À la fin';
  MINUTE_REMOVAL_TYPE_AT_THE_BEGINNING='Au début';
  HowToRemoveMinutes='Retirer les minutes';
  MinutesToRemove='Minutes à retirer';

  CumulativeExportCode=   'Code Paie';
  CumulativeName=  'Nom (Rapport)';
  CumulativeCondition='Quand le total des heures';
  CumulativeConditionAmount='HH:mm';
  MemoStatistics = '{{nbReadPercent}}% de messages lus.';
  MemoStatisticsTitle='Statistiques du message';
  DoYouWantToDeleteThisMemo='Voulez-vous supprimer ce message \'{{title}}\'?';
  MemoNotReadYet='Message non lu par {{recipients}}.';
  MemoNotAcknowledgedYet ='Message non confirmé par {{recipients}}.';

  SendReminder='Envoyer un rappel';
  ReminderToReadTitle = 'Rappel pour le message: \'{{title}}\' de {{from}}';
  ReminderToReadBody='Bonjour,<br>Ceci est pour vous rappeler que vous avez reçu un message \'{{title}}\' de {{from}} le {{created}} qui nécessite votre attention.<br>Merci.';

}
